import config from "./config";
import { triggerGa } from "./gaUtils";
import { GUMLET_ENABLED, GUMLET_PREFIX_URL } from "./mediaTransform";

export const AUTHENTICATION_STATES = {
  AUTHENTICATED: "AUTHENTICATED",
  ONLY_FIREBASE_AUTHENTICATED: "ONLY_FIREBASE_AUTHENTICATED",
  NOT_AUTHENTICATED: "NOT_AUTHENTICATED",
};

export const SENTRY = {
  DSN: config.API.sentry_dns,
  SAMPLE_RATE: 0.2,
};

export const PLATFORM_LABEL_MAP = {
  instagram: "ig",
  youtube: "yt",
  facebook: "fb",
};

// DIY Product Limits
export const DIY_PRODUCT_LIMITS = {
  MAX_PRODUCTS: 30,
};

// Social login localStorage/sessionStorage keys
export const SOCIAL_LOGIN_STORAGE_KEYS = {
  EXPIRED_DISMISSED: {
    instagram: "social_login_expired_dismissed_insta",
    youtube: "social_login_expired_dismissed_yt",
    facebook: "social_login_expired_dismissed_fb",
  },
  NOT_CONNECTED_ACCESSED_DIY: {
    instagram: "ig_not_connected_accessed_diy",
    youtube: "yt_not_connected_accessed_diy",
    facebook: "fb_not_connected_accessed_diy",
  },
  EXPIRED_SHOWN_THIS_SESSION: "social_login_expired_shown_this_session",
};

export const DRAWER_TYPE = {
  EXPIRED: "expired",
  WAITLISTED: "waitlisted",
  NOT_CONNECTED: "notConnected",
};

export const GA_CATEGORIES = {
  USER_IMPRESSION: "user_impression",
  SUPPORT: "support",
  HELP: "help",
  FIRST_POST: "firstpost",
  NAVIGATION: "navigation",
  LOGIN: "login",
  ERROR: "error",
  USER_EXIT: "user_exit",
  USER_ENGAGEMENT: "user_engagement",
  USER_INTERACTION: "user_interaction",
  CHART_INTERACTION: "chart_interaction",
  CREATE: "create",
  USER_EDUCATION: "usereducation",
  REWARDS: "rewards",
  LOADING: "loading",
  WEB_VITALS: "WEB_VITALS",
  STORY_INTERACTION: "story_interaction",
  VIDEO_INTERACTION: "Videointeraction",
  DELETE: "delete",
  IMPRESSION: "impression",
  CHECK: "check",
  LOADING_TIME: "LoadingTime",
  SOURCE_PRODUCT: "sourceproduct",
  BRAND_ERROR: "brand_error",
  INVALID_LINK: "invalid_link",
  SOCIAL_LOGIN: "social_login",
  BRANDS_EXPERIMENT: "brands_experiment",
  REWARDS_EXPERIMENT: "rewards_experiment",
  NEW_BRANDS_EXPERIMENT: "new_brands_experiment",
  EXCLUSIVE_BRANDS: "exclusive_brands",
  SPOTLIGHT_CREATORS: "SpotlightCreators",
  INTERACTION: "interaction",
  ENGAGE_COMMENT: "engage_comment",
};

export const GA_ACTION = {
  // Engage V2.1 — Media upload + Google-link detection (GA sheet "Engage v2.1")
  FILE_UPLOAD: "file_upload",
  WARNING_VIEWED: "warning_viewed",
  ENGAGE_DRAWER_VIEWED: "drawer_viewed",
  ENGAGE_CTA_CLICK: "cta_click",
  FIELD_ERROR: "field_error",
  ADDED_PRODUCT_LINK: "added_product_link",
  WISHLINK_FETCH: "wishlink_fetch",
  // CXB-3342 — Brand-campaign interest form
  BRAND_COLLAB_INTENT_FORM_SHOWN: "brand_collab_intent_form_shown",
  BRAND_COLLAB_INTENT_INTERESTED: "brand_collab_intent_interested",
  BRAND_COLLAB_INTENT_NOT_RIGHT_NOW: "brand_collab_intent_not_right_now",
  FILTER_VALUE_SELECTION: "filter_value_selection",
  FILTER_OPTION_SELECTION: "filter_option_selection",
  MORE_FILTERS_CTA_CLICKED: "more_filters_cta_click",
  QUICK_FILTER_APPLY: "QuickFilterApply",
  BUTTON_IMPRESSION: "button_impression",
  REVIEW_SUBMITTED_SUCCESS: "review_submitted_success",
  REVIEW_SUBMIT_ERROR: "review_submit_error",
  PHOTO_ADDED: "photo_added",
  VIDEO_UPLOADED: "video_uploaded",
  RATING_SELECTION: "rating_selection",
  SIZE_RECOMMENDATION_SELECTION: "size_recommendation_selection",
  FIT_SELECTION: "fit_selection",
  OCCASION_SELECTION: "occasion_selection",
  REVIEW_TEXT_INPUT: "review_text_input",
  CONFIRM_BUTTON: "confirm_button",
  FINAL_CONFIRMATION: "final_confirmation",
  FIELD_CLICK: "field_click",
  COMMISSIONS_CLICK: "commissions_click",
  FTUX_KNOW_MORE_CLICK: "ftux_know_more_click",
  REWARDS_SEE_ALL_CLICK: "rewards_see_all_click",
  REWARDS_CARD_SCROLL: "rewards_card_scroll",
  SOURCING_VIEW_PRODUCTS_CLICK: "sourcing_view_products_click",
  STYLED_BY_INFLUENCER_SECTION_IMPRESSION:
    "styled_by_influencer_section_impression",
  STYLED_BY_INFLUENCER_REEL_CLICK: "styled_by_influencer_reel_click",
  STYLED_BY_INFLUENCER_REEL_PLAY: "styled_by_influencer_reel_play",
  STYLED_BY_INFLUENCE_REEL_CLOSE: "styled_by_influence_reel_close",
  BRAND_DETAILS_SECTION_IMPRESSION: "brand_details_section_impression",
  BRAND_RATING_CHIP_CLICK: "brand_rating_chip_click",
  IMAGE_FULL_SCREEN_OPEN: "image_full_screen_open",
  IMAGE_ZOOM: "image_zoom",
  IMAGE_FULL_SCREEN_SWIPE: "image_full_screen_swipe",
  PRODUCT_HIGHLIGHTS_READ_MORE_CLICK: "product_highlights_read_more_click",
  PRODUCT_DETAILS_VIEW_ALL_CLICK: "product_details_view_all_click",
  PDP_PINCODE_BOX_CLICK: "pin_code_box_click",
  PDP_PINCODE_CHECK: "pin_code_check",
  PDP_EDD_DISPLAYED: "edd_displayed",
  SIMILAR_PRODUCTS_CAROUSEL_SCROLL: "similar_products_carousel_scroll",
  COLLECTIONS_BANNER_CLICK: "collections_banner_click",
  CATEGORY_WIDGET_CLICK: "category_widget_click",
  // SEL-1681: Seleqt sourcing trend surfaces (sheet "Trends GA").
  TREND_IMPRESSION: "trend_impression",
  TREND_CARD_CLICK: "trend_card_click",
  TREND_CAROUSEL_SCROLL: "trend_carousel_scroll",
  TREND_VIDEO_CLICK: "trend_video_click",
  TREND_VIDEO_IMPRESSION: "trend_video_impression",
  TREND_VIDEO_BACK: "trend_video_back",
  EXPLORE_TREND_BUTTON_CLICK: "explore_trend_button_click",
  VIDEO_CAROUSEL_IMPRESSION: "video_carousel_impression",
  VIDEO_WATCHED: "video_watched",
  SECTION_IMPRESSION: "section_impression",
  CARD_IMPRESSION: "card_impression",
  SUPPORT_CLICK: "support_click",
  REARRANGE_PRODUCT: "rearrange_product",
  FILTER_INTERACTION: "filter_interaction",
  BRAND_FILTER: "BrandFilter",
  ANALYTICS: "analytics",
  COPY_WISHLINK_OFFER: "copywishlinkoffer",
  VIEW_ALL: "viewall",
  D2DCAT_PAGE: "D2CCategoryPage",
  YT_VIDEO: "YTVideo",
  ECOMM_PAGE: "Ecommpage",
  FILTER_CLICK: "filterclick",
  OFFER_CARD: "offercard",
  COPY_WISHLINK: "copywishlink",
  CALENDAR_NAVIGATION: "calendarnavigation",
  CALENDAR_VIEW: "Calendarview",
  CREATE_IG_POST: "createigpost",
  DONE_CLICK: "Doneclick",
  DEBUG_START: "DebugStart",
  DEBUG_RESTART: "DebugRestart",
  FAB_CLICK: "fabclick",
  MONTHLY_FILTERS: "monthlyfilter",
  NUDGE_CLICK: "NudgeClick",
  ORDER_DETAILS_PENDING: "orderdetailspending",
  ORDER_DETAILS_CONFIRMED: "orderdetailsconfirmed",
  PAUSE_VIDEO: "pausevideo",
  FLIPKART_CLICK: "flipkartclick",
  ENGAGE_GTM_DRAWER_CLOSE: "engagegtmdrawerclose",
  LOADER_TIMEOUT: "loadertimeout",
  SEE_ALL_PRODUCT_FINDS: "SeeAllProductFinds",
  MEESHO_CLICK: "meeshoclick",
  DOB_UPDATE: "dobupdate",
  ADDRESS_UPDATE: "addressupdate",
  PAGE_NAVIGATION: "pagenavigation",
  ACCORDION_OPEN: "accordionopen",
  ACCORDION_CLOSE: "accordionclose",
  TOGGLE_CLICK: "toggleclick",
  MILESTONE_SCREEN: "milestonescreen",
  FOOTER_CLICK: "footerclick",
  SKIP_JOURNEY: "skipjourney",
  BACK: "back",
  CONTENT_FILTER_SELECTION: "contentfilterselection",
  COPY_CONTENT_LINK: "copycontentlink",
  CONFIRM_SHOP_NAME: "confirmshopname",
  CREDIT_CLICK: "creditclick",
  PRO_TIP_CLICK: "protipclick",
  SKIP_POST_LINK: "skippostlink",
  TAGS_SELECTION: "tagsselection",
  SELECT_CHANNEL: "selectchannel",
  CONTENT_FILTER_CLEAR: "contentfilterclear",
  CONTENT_FILTER_OPEN: "contentfilteropen",
  CONTENT_SORT_OPEN: "contentsortopen",
  SORT: "sort",
  HIDE_CONTENT: "hidecontent",
  COPY_LINK: "copylink",
  EDIT_CONTENT: "editcontent",
  WATCH_VIDEO: "watchvideo",
  EDIT_INFO_CLICK: "editinfoclick",
  UPDATE_DETAILS: "updatedetails",
  VIDEO_INTERACTION: "videointeraction",
  NEXT_STEPS_CLICK: "nextstepsclick",
  EDIT_KEYWORDS: "editkeywords",
  EDIT_REPLIES: "editreplies",
  ADD_KEYWORD: "addkeyword",
  UNLINK_INSTA_CONFIRMATION: "unlinkinstaconfirmation",
  UNLINK_INSTA: "unlinkinsta",
  INSTA_REDIRECT: "instaRedirect",
  TOGGLE: "toggle",
  REFRESH_PRODUCTS: "refreshproducts",
  IMAGE_UPLOAD: "imageupload",
  PUBLISH_CONTENT: "publishcontent",
  PRODUCT_STATUS: "productstatus",
  REDIRECT: "redirect",
  ADD_PRODUCT_LINKS: "addproductlinks",
  ADD_ANOTHER_PRODUCT: "addanotherproduct",
  SAVE_DRAFT: "savedraft",
  PASTE_LINK: "pastelink",
  DETECT_LINKS: "detectlinks",
  EDIT_POST_LINK: "editpostlink",
  TAGS_OPEN: "tagsopen",
  ADD_CONTENT: "addcontent",
  CLEAR_SEARCH: "clearsearch",
  SEARCH_BRAND: "searchbrand",
  BRAND_FILTER_CHECKBOX: "brandfiltercheckbox",
  BRAND_FILTER_CLEAR: "brandfilterclear",
  BRAND_FILTER_OPEN: "brandfilteropen",
  BRAND_FILTER_SELECTION: "brandfilterselection",
  BRAND_CARD_CLICK: "brandcardclick",
  PREVIEW_CONTENT: "previewcontent",
  BUTTON_CLICK: "buttonclick",
  BUTTON_CLICK_EVENT: "button_click",
  FILTER_SELECT: "filter_select",
  BUTTON_VIEWED: "buttonviewed",
  REWARDS_EXPERIMENT_BUTTON_CLICK: "button_click",
  REWARDS_EXPERIMENT_PAGE_VIEW: "page_view",
  SUBMIT_FORM: "submitform",
  SOCIAL_LOGIN: "sociallogin",
  CONTACT_US: "contactus",
  OVERVIEW_CLICK: "overviewclick",
  BANNER_CLICK: "bannerclick",
  REWARDS_CLICK: "rewardsclick",
  BRAND_CLICK: "brandclick",
  BOTTOM_NAV_CLICK: "bottomnavclick",
  HAMBURGER_CLICK: "hamburgerclick",
  SHOT_CUT_CLICK: "shortcutclick",
  GRAPH_SCROLL: "graphscroll",
  GRAPH_PERIOD: "graphperiod",
  DATE_SELECTION: "dateselection",
  PILL_SELECTION: "pillselection",
  LOAD_MORE_POSTS: "loadmoreposts",
  TOOLTIP_CLICK: "tooltipclick",
  ACCORDION_CLICK: "accordionclick",
  TARGET_CLICK: "targetclick",
  CREATOR_CLICK: "creatorclick",
  CARD_CLICK: "cardclick",
  CARD_CLICKED: "card_clicked",
  SEE_MORE_CLK: "seemoreclicked",
  SEE_LESS_CLK: "seelessclicked",
  CARD_VIEWED: "cardviewed",
  CARD_SWIPED: "cardswiped",
  METRICS_VIEW: "metrics_view",
  CARD_DISMISSED: "carddimissed",
  DRAWER_VIEWED: "drawerviewed",
  CALL_BTN_CLK: "callbuttonclicked",
  MAY_BE_LATER_BTN_CLK: "maybelaterbuttonclicked",
  CTA_CLICK: "ctaclick",
  PIE_CLICK: "pieclick",
  CONTENT_DETAILS: "contentdetails",
  COPY_ALL_LINKS: "copyalllinks",
  NOTIFICATION_ICON_CLICK: "notification_icon_click",
  NOTIFICATION_CLICK: "notification_click",
  SHARE_REFERRAL: "Share_referral",
  COLLECTION_OPEN: "collection_open",
  CATEGORY_FILTER: "category_filter",
  SPECIAL_FILTER: "special_filter",
  ADD_COLLECTION: "add_collection",
  PRODUCT_CLICK: "product_click",
  ICON_CLICK: "iconclick",
  STORY_INTERACTION: "story_interaction",
  WEB_VITALS: "WEB_VITALS",
  BRAND_SELECTION: "brand_selection",
  STORY_VIEW: "story_view",
  STORY_OPEN: "open",
  STORY_HOLD: "hold",
  STORY_TAP: "tap",
  STORY_END: "end",
  PLAY: "play",
  PAUSE: "pause",
  SCROLL_H: "scroll_h",
  CLOSE: "close",
  SEE_ALL_CLICK: "see_all_click",
  OVERLAY_CLICK: "overlay_click",
  OVERLAY_JOURNEY_VIEWED: "overlay_journey_viewed",
  TAB_CLICK: "tabclick",
  COPY_POST_WISHLINK: "copy_post_wishlink",
  QUICKFILTER_CLICK: "quickfilter_click",
  SUPPORT_ICON_CLICK: "support_icon_click",
  FRESHDESK_OPEN: "FRESHDESK_OPEN",
  GTM_DRAWER_IMPRESSION: "gtm_drawer_impression",
  HORIZONTAL_SWIPE: "horizontalswipe",
  HEADER_CLICK: "HeaderClick",
  WIDGET_CLICK: "WidgetClick",
  CATEGORY_CLICK: "CategoryClick",
  VIEW_MORE_CATEGORY: "ViewMoreCategory",
  CATALOG_OPEN: "CatalogOpen",
  COPY_PRODUCT_LINK: "CopyProductLink",
  DELETE: "Delete",
  CONFIRM_PRODUCTS: "ConfirmProducts",
  CONFIRM_ADDRESS: "ConfirmAddress",
  PLACE_ORDER_REQUEST: "PlaceOrderRequest",
  APPLY_FILTER: "ApplyFilter",
  VIDEO_CLICK: "VideoClick",
  VIDEO_VIEW: "VideoView",
  FAQ_CLICK: "FAQClick",
  FAQ_CATEGORY: "FAQCategory",
  FAQ_EXPANDED: "FAQExpanded",
  FAQ_COLLAPSED: "FAQCollapsed",
  GOT_IT_CLICK: "GotItClick",
  REMOVE: "Remove",
  ADD_NEW_ADDRESS: "AddNewAddress",
  LEARN_CLICK: "LearnClick",
  SEARCH: "Search",
  SEARCH_RESULTS_LOAD: "SearchResultsLoad",
  PRODUCT_CARD_CLICK: "ProductCardClick",
  PRODUCT_CARD: "ProductCard",
  SORT_OPEN: "SortOpen",
  SORT_SELECTION: "SortSelection",
  FILTER_OPEN: "FilterOpen",
  FILTER_CLEAR_ALL: "FilterClearAll",
  SIZE_CLICK: "SizeClick",
  SIZE_CHART_CLICK: "SizeChartClick",
  ADD_TO_CART: "AddToCart",
  CART_ICON: "CartIcon",
  BANNER_IMPRESSION: "BannerImpression",
  FILTER_SELECTION: "FilterSelection",
  PRODUCT_IMPRESSION: "ProductImpression",
  COPY_COUPON_CODE: "CopyCouponCode",
  MULTIPLE_FILTER_SELECTION: "MultipleFilterSelection",
  OKAY_CLICK: "OkayClick",
  MILESTONE_CLICK: "MilestoneClick",
  FRESHDESK_USER_CREATED: "FreshdeskUserCreated",
  SHOPSY_CLICK: "ShopsyClick",
  QUICK_ACTION_CLICKED: "QuickAccessClicked",
  QUICK_ACTION_VIEWED: "QuickAccessViewed",
  INDICATOR_MARK_SEEN_REJECTED: "IndicatorMarkSeenRejected",
  OPTIN_CLICK: "OptinClick",
  TRACK_PROGRESS: "TrackProgress",
  VIEW_DETAILS: "ViewDetails",
  VISIT_BRAND_SITE: "VisitBrandSite",
  SOURCING: "Sourcing",
  REEL_PLAYER: "ReelPlayer",
  TNC_CLICK: "TnCClick",
  ACTIVATE_ENGAGE: "ActivateEngage",
  VIEW_LEADERBOARD_REWARDS: "ViewLeaderboardRewards",
  CREATOR_CLICK_LEADERBOARD: "CreatorClickLeaderboard",
  CONTENT_LINKS: "contentlinks",
  API_CALL_STARTED: "ApiCallStarted",
  API_CALL_END: "ApiCallEnd",
  REWARD_CARD: "RewardCard",
  REWARD_BOTTOMSHEET: "Reward_bottomsheet",
  NO_CLICK: "no_click",
  REEL_IMPRESSION: "ReelImpression",
  REEL_CARD_IMPRESSION: "ReelCardImpression",
  HOME_BANNER_VIEW: "HomeBannerView",
  BRAND_BANNER_VIEW: "BrandBannerView",
  REMOVESAVELATERCLICK: "RemoveSaveClick",
  SAVELATERCLICK: "SaveLaterClick",
  MOVE_TO_CART: "MoveToCart",
  DELETE_CLICK: "DeleteClick",
  ADD_CHANNEL_PROFILE: "addChannelProfile",
  SWITCH_PROFILE: "switchProfile",
  PROFILE_SWITCHED: "profileSwitched",
  COLLECTION_CARD: "collectioncard",
  NEW_LAUNCH: "newlaunch",
  FAQ_FEEDBACK: "FAQ_Feedback",
  PRODUCT_SELECT: "ProductSelectiuon",
  CATEGORY_SELECT: "CategorySelection",
  IMAGE_SELECT: "ImageSelection",
  IMAGE_VIEW: "ImageView",
  FETCH_CUTOUTS: "FetchCutouts",
  IMAGE_INTERACTION: "ImageInteraction",
  IMAGE_DELETE: "ImageDelete",
  IMAGE_ADD: "ImageAdd",
  NEXT: "next",
  PREVIOUS: "previous",
  REDIRECT_TO_BRAND: "RedirectToBrand",
  TDS_CLICK: "tds_click",
  TAX_CLICK: "tax_click",
  GST_CLICK: "gst_click",
  TDS_YEAR_SELECT: "tds_year_select",
  TDS_QTR_SELECT: "tds_quarter_select",
  CONFIRM_CLICK: "confirm_click",
  EMAIL_CHECK: "enter_email_check",
  PAN_CHECK: "enter_pan_check",
  SEND_TDS_MAIL: "send_tds_mail",
  DOWNLOAD_TDS: "download_tds",
  TDS_NEXT_CLICK: "tds_next_click",
  TDS_NOT_GENERATED_TOAST: "tds_not_generated_toast",
  VIEW_ANOTHER_CLICK: "view_another_click",
  RETRY_DOWNLOAD_CLICK: "retry_download_click",
  ENTER_PAN_CLICK: "enter_pan_click",
  COMPONENT_CLICK: "component_click",
  PAGE_VIEW: "page_view",
  BACK_CLICK: "back_click",
  CATEGORY_DRAWER: "category_drawer",
  CATEGORY_DRAWER_CHOOSE: "category_drawer_choose",
  CATEGORY_DRAWER_CHOOSE_CUSTOM: "category_drawerchoose_custom",
  CATEGORY_DRAWER_DONE: "category_drawer_done",
  COLLAB_COMMERCIALS_CLICK: "collab_commercials_click",
  NONCOLLAB_COMMERCIALS_CLICK: "noncollab_commercials_click",
  AD_COMMERCIALS_CLICK: "ad_commercials_click",
  PAST_COLLABS_CHOICE: "pastcollabs_choice",
  TIME_PERIOD: "time_period",
  MEDIUM: "medium",
  ENTER_GST_NUMBER: "enter_gst_number",
  ENTER_GST_CERTIFICATE: "enter_gst_certificate",
  VIEW_FILE: "view_file",
  SELECT_MONTH: "select_month",
  CHECKBOX_CLICK: "checkbox_click",
  BANNER_VIEW: "banner_view",
  CATALOG_CREATION: "CatalogCreation",
  ADDED_TO_CART: "AddedToCart",
  ADD_DETAILS: "adddetails",
  BRAND_ERROR: "brand_error",
  CUSTOM_PRODUCT: "customproduct",
  IMAGE_SWIPED: "imageswiped",
  SL_AUTH_RESPONSE: "sl_auth_response",
  OTP_VERIFIED: "otp_verified",
  AUTH_STATE_CHANGED: "auth_state_changed",
  AUTH_TOKEN_REFRESH_FAILED: "auth_token_refresh_failed",
  AUTH_FORCE_REFRESH: "auth_force_refresh",
  AUTH_INIT_TIMEOUT: "auth_init_timeout",
  VARIANT_SEEN: "variant_seen",
  BOTTOMSHEET_OPENED: "bottomsheet_opened",
  BOTTOMSHEET_REDIRECT: "bottomsheet_redirect",
  LOADER_DURATION: "loader_duration",
  BRANDS_SHARE_WISHLINK: "share_wishlink",
  BRANDS_MY_WISHLINK: "my_wishlink",
  BRANDS_COPY_WISHLINK: "copy_wishlink",
  BRANDS_SHARE_TO_STORY: "share_to_story",
  FILTER_CLICK: "filter_click",
  SCROLL: "scroll",
  STREAKS_CUSTOM_PAGE_VIEW: "streaks_custom_page_view",
  HOW_IT_WORKS_CUSTOM_PAGE_VIEW: "how_it_works_custom_page_view",
  COMPONENT_VIEWED: "componentviewed",
  DROPDOWN_CLICK: "dropdown_click",
  CUSTOM_PAGE_VIEW: "custom_page_view",
  EDIT_POST_TITLE: "editposttitle",
  HIDE_UNHIDE_DRAWER: "hide_unhide_drawer",
  // Streaks homepage-takeover FTUX (doc-exact, additive)
  PAGE_TAKEOVER: "page_takeover",
  IMPRESSION: "impression",
  BANNER_IMPRESSION_EVENT: "banner_impression",
  BANNER_CLICKED_EVENT: "banner_clicked",
};

export const GA_LABEL = {
  REWARD_FTUX_POPUP: "reward_ftux_popup",
  REWARD_FTUX_BACK: "reward_ftux_back",
  REWARD_FTUX_CLOSE: "reward_ftux_close",
  REWARD_FTUX_CTA: "reward_ftux_CTA",
  DISCOVER_V2: "discover_v2",
  REWARDS_OPTIN: "rewards_optin",
  REWARD_CARD: "RewardCard",
  REWARD_BOTTOMSHEET: "Reward_bottomsheet",
  INCREMENTAL_REWARD_FTUX: "incremental_reward_ftux",
  SOURCING_EDUCATION: "sourcing_education",
  BRAND_SOURCING: "brand_sourcing",
  SOURCED_PRODUCTS: "sourced_products",
  ADD_PHOTO: "add_photo",
  ADD_VIDEO: "add_video",
  SUBMIT_REVIEW_FINAL: "submit_review_final",
  SUBMIT_REVIEW: "submit_review",
  SUBMIT_PRODUCT_REVIEWS: "submit_product_reviews",
  ENABLE_NOW: "enable_now",
  DOWNLOAD_QR: "download_qr",
  SELECT_BY_WISHLINK: "select_by_wishlink",
  SELEQT: "seleqt",
  THRIFT_ADMIN_BANNER: "thrift_admin_banner",
  DOWNLOAD: "download",
  VIEW_DETAILS: "view_details",
  RECONNECT: "reconnect",
  GOT_IT: "got_it",
  CRITERIA_NOT_MET: "criteria_not_met",
  AUTO_LOGOUT: "auto_logout",
  CTA_CLICK: "cta_click",
  FEEDBACK_GIVEN: "feedback_given",
  SUPPORT_ACCESSED: "support_accessed",
  VIDEO_PLAYED: "video_played",
  CLEAR_ALL_FILTERS: "clear_filter",
  FILTER_CLICK: "filter_click",
  ANNOUNCEMENT: "announcement",
  CONTINUE_WITHOUT_FB: "continue_without_facebook",
  BACK_CLICK: "back_click",
  RETRY_LOGIN: "retry_login",
  PREVIOUS_CLICK: "previous_click",
  NEXT_CLICK: "next_click",
  EXIT: "exit",
  SETTINGS_CLICK: "settings_click",
  CONNECT_ENGAGE_CLICK: "connect_engage_click",
  SETTINGS_TAB: "settings_tab",
  HEALTH_TAB: "health_tab",
  HIDE: "hide",
  HIDE_CONFIRM: "hide_confirm",
  UNHIDE: "unhide",
  RETURNS_FORM: "Returns_Form",
  CREATE_DIY: "/create-diy",
  SUGGESTED_ACTIONS: "suggestedactions",
  SWITCH_PROFILE: "switchProfile",
  APPLY: "Apply",
  CLEAR: "Clear",
  INSIGHTS: "Insights",
  INSTA_STORY: "InstaStory",
  ENGAGE_DEBUG: "EngageDebug",
  WHATSAPP: "whatsapp",
  WHATSAPP_CHAT: "whatsapp_chat",
  MONTHLY_ORDER_STATUS: "monthly_order_status",
  REQUEST_REPORT: "Requestreport",
  CONFIRMED_BRAND: "ConfirmedBrand",
  PENDING_BRAND: "PendingBrand",
  POTENTIAL_RETURNS: "potentialreturns",
  PAST_PAYOUTS: "pastpayouts",
  SINGLE_PAYOUT: "singlepayout",
  TDS: "TDS",
  PENDING_COMMISSIONS: "pendingcommissions",
  CONFIRMED_COMMISSIONS: "confirmedcommissions",
  REWARDS_REFERRAL: "rewardsreferral",
  ELIGIBLE_PRODUCTS: "eligible_products",
  VIEW_PRODUCTS: "view_products",
  QUALIFIES: "qualifies",
  DOESNOT_QUALIFIES: "doesnot_qualifies",
  LANGUAGE_CHANGE: "languagechange",
  PAYOUTS_PRELAUNCH: "payoutsprelaunch",
  LIBAS_REWARDS_SOURCING_NUDGE_CLICK: "libasrewardssourcingnudgeclick",
  LIBAS_REWARDS_BANNER: "libasrewardsbanner",
  VIEW_COMMISSIONS: "viewcommissions",
  ENGAGE_GTM_DRAWER_CLOSE: "engagegtmdrawerclose",
  ENGAGE_COMMENTS_TOGGLE: "engagecommentstoggle",
  ENGAGE_AUTO_COMMENT_TOGGLE: "engageautocommenttoggle",
  ENGAGE_STORIES_TOGGLE: "engagestoriestoggle",
  APP_HIGHLIGHT_BANNER: "apphighlightbanner",
  WRAPPED_VIEWED: "wrappedviewed",
  WRAPPED_CLICKED: "wrappedclicked",
  WRAPPED_HOME: "wrappedhome",
  LOADER_TIMEOUT_TEXT_SHOWN: "loadertimeouttextshown",
  LOADER_TIMEOUT_CLICKED: "loadertimeoutclicked",
  BPC_MEET: "bpcmeet",
  WINTER_MEET: "wintermeet",
  CREATOR_DEMO: "creatordemo",
  SUBMIT_REFERRAL: "submitreferral",
  SKIP_REFERRAL: "skipreferral",
  TIRA: "tira",
  LEADERBOARD: "leaderboard",
  REWARDS_CALCULATION: "rewardscalculation",
  EXPLORE_PRODUCT_FINDS: "ExploreProductFinds",
  PRODUCT_FINDS_BUTTON: "ProductFindsButton",
  MUST_READ: "mustread",
  MEESHO: "meesho",
  BRANDFEST: "brandfest",
  EDIT_SAVE: "editsave",
  NAME: "name",
  CROSSPOSTING: "crossposting",
  ADDRESS: "address",
  EMAIL: "email",
  DOB: "dob",
  CANCEL: "cancel",
  CONFIRM: "confirm",
  REMOVE_CANCEL: "removecancel",
  REMOVE_CONFIRM: "removeconfirm",
  REMOVE_CLICK: "removeclick",
  CHANGE_DEFAULT: "changedefault",
  EDIT_CLICK: "editclick",
  PAGE_CHANGE: "pagechange",
  ORDER_DATE: "orderdate",
  DATEWISE_ORDERS: "datewiseorders",
  FILTER_LIST: "filterlist",
  ORDER_LEDGER: "orderledger",
  ENGAGE_ACTIVATION: "engageactivation",
  ENGAGE_SETTINGS: "engagesettings",
  THRESHOLD_EARNINGS: "thresholdearnings",
  FIRST_SALE: "firstsale",
  ENGAGE: "engage",
  IN_FOCUS: "infocus",
  OUT_FOCUS: "outfocus",
  FEEDBACK_SUBMIT: "feedbacksubmit",
  FEEDBACK_OPEN: "feedbackopen",
  WISHLINK: "wishlink",
  BOTH: "both",
  SHARE_WISHLINKS: "sharewishlinks",
  ENGAGE_DRAWER: "engagedrawer",
  POST_CREATION: "postcreation",
  BRANDS_CATEGORY: "brandscategory",
  MUTE: "mute",
  UNMUTE: "unmute",
  NEXT: "next",
  BACK: "back",
  CONTINUE: "continue",
  IMAGE_SIZE: "imagesize",
  DISPLAY: "display",
  COVER: "cover",
  BIO: "bio",
  GENDER: "gender",
  BANK_ACCOUNT_DETAILS: "bankaccountdetails",
  PAYOUT_FAILURE: "payoutfailure",
  OPEN: "open",
  CLOSE: "close",
  PLAY: "play",
  PAUSE: "pause",
  KEYWORDS_UPDATED: "keywordsupdated",
  KEYWORDS_SELECTION: "keywordsselection",
  EDIT_EXISTING_CLICK: "editexistingclick",
  EDIT_EXISTING_SAVE: "editexistingsave",
  DELETE_EXISTING_CLICK: "deleteexistingclick",
  DELETE_EXISTING_CONFIRM: "deleteexistingconfirm",
  NEW_TEMPLATE_CLICK: "newtemplateclick",
  NEW_KEYWORD_ADD: "newkeywordadd",
  NEW_TEMPLATE_ADD: "newtemplateadd",
  ENGAGE_STATUS: "engagestatus",
  SALE: "sale",
  LOGIN: "login",
  ENTER_MOBILE: "entermobile",
  ENTER_OTP: "enterotp",
  RESEND_OTP: "resendotp",
  SIGNUP: "signup",
  HOME: "home",
  SOCIAL_LOGIN_SUCCESS: "sociallogin_success",
  FB_PAGE_SELECT: "fbpage_select",
  BACK_TO_LOGIN: "back_to_login",
  CONFIRM_CLICK: "confirm_click",
  EXPLORE_WISHLINK: "explorewishlink_click",
  SWITCH_PAGE_CLICK: "switchpage_click",
  LINK_SOCIAL: "linksocial",
  UNLINK_SOCIAL: "unlinksocial",
  UNLINK_SOCIAL_CONFIRM: "unlinksocialconfirm",
  SOCIAL_LOGIN: "sociallogin",
  SKIP_FOR_NOW: "skipfornow",
  ENTER_DETAILS: "enterdetails",
  SIGNUP_FAIL: "signupfail",
  POST: "post",
  COLLECTIONS: "collections",
  ANALYTICS: "analytics",
  PAYOUTS: "payouts",
  PAYOUTS_CX_PENDING_COMMISSIONS: "pending_commissions",
  PAYOUTS_CX_PAYOUT_STATUS: "payout_status",
  PAYOUTS_CX_PAYOUT_HISTORY: "payout_history",
  PAYOUTS_CX_OTHER_FEATURES: "other_features",
  PAYOUTS_CX_HOW_PAYOUTS_WORK: "how_payouts_work",
  PAYOUTS_CX_FAQ: "faq",
  PAYOUTS_CX_CONTACT_SUPPORT: "contact_support",
  PAYOUTS_CX_SEE_ALL: "see_all",
  PAYOUTS_CX_MORE_UPCOMING_PAYOUTS: "more_upcoming_payouts",
  PAYOUTS_CX_VIEW_COMPLETE_HISTORY: "view_complete_history",
  PAYOUTS_CX_DATE_FILTER: "date",
  PAYOUTS_CX_PAYOUT_TYPE_FILTER: "payout_type",
  PAYOUTS_CX_ADD_PAN_DETAILS: "add_pan_details",
  PAYOUTS_CX_ADD_BANK_DETAILS: "add_bank_details",
  PAYOUTS_CX_COMPLETE_PROFILE: "complete_profile",
  PAYOUTS_CX_SUBMIT_APPEAL: "submit_appeal",
  PAYOUTS_CX_NO_PAYOUTS: "no_payouts",
  PAYOUTS_CX_PAYOUT_CLEARED: "payout_cleared",
  PAYOUTS_CX_TDS_CERTIFICATE: "tds_certificate",
  PAYOUTS_CX_TAX_INVOICE: "tax_invoice",
  PAYOUTS_CX_CLAIM_GST_CREDIT: "claim_gst_credit",
  REWARDS: "rewards",
  ENGAGE_PROPS: "engageprops",
  SHOP_PROPS: "shopprops",
  PLAYBOOK: "playbook",
  BRANDS: "brands",
  BRAND_WEBSITE: "brandwebsite",
  COPY_SHOP_LINK: "copyshoplink",
  SHOP: "shop",
  CREATE: "create",
  PROFILE: "profile",
  HELP: "help",
  LOGOUT: "logout",
  DETAILEDANALYTICS: "detailedanalytics",
  DAY: "day",
  WEEK: "week",
  PRESET: "preset",
  CHANNEL: "channel",
  AMAZON_CARD: "amazoncard",
  POSTS: "posts",
  PRODUCTS: "products",
  PRODUCTIG: "ProductIG",
  MANUAL: "manual",
  SELLING_PLAYBOOK: "sellingplaybook",
  RETURNS_TRACKING: "returnstracking",
  SOURCING: "sourcing",
  IG: "ig",
  YT: "yt",
  FB: "fb",
  TG: "tg",
  POST_IG: "postig",
  POST_YT: "postyt",
  POST_FB: "postfb",
  POST_PINTEREST: "postpinterest",
  KNOW_MORE: "know_more",
  ORDERED_COMMISSION: "ordered_commission",
  FAILED_CROSS_POSTING: "failed_cross_posting",
  FACEBOOK: "facebook",
  CURRENT: "current",
  PREVIOUS: "previous",
  UPCOMING: "upcoming",
  CREATOR_SHOP: "creatorshop",
  EARNINGS: "earnings",
  MY_SHOP: "myshop",
  DRAFTS: "drafts",
  TAG: "tag",
  setShowTooltip: "setShowTooltip",
  DEFAULT: "default",
  UNSEEN: "unseen",
  UNCLICKED: "unclicked",
  CTA: "cta",
  BANNER: "banner",
  NONE: "none",
  HOWREFERRALWORKS: "Howreferralworks",
  OKREFERRAL: "Okayreferral",
  REFERRALTERMS: "ReferralTerms",
  REFERRALPAGE: "ReferralPage",
  SHAREWHATSAPP: "Sharewhatsapp",
  COPYCODE: "Copycode",
  SHAREANY: "ShareAny",
  REFERRAL: "Referral",
  IMAGE: "Image",
  IMAGEIG: "ImageIG",
  BUTTON: "Button",
  BEST_SELLERS: "BestSellers",
  PLP: "PLP",
  RECOMMENDED_COLLECTIONS: "RECOMMENDED_COLLECTIONS",
  VIEWDETAILSYTSHOPPING: "ViewDetailsYTShopping",
  OPT_OUT_YT_SHOPPING: "OptoutYTShopping",
  LOGIN_CLOSE: "LoginClose",
  AUTO: "auto",
  HOLD: "hold",
  BRAND_SELECTION: "brand_selection",
  SELECT: "select",
  UNSELECT: "unselect",
  DESELECT: "Deselect",
  CREATE_FIRST_LINK: "CreateFirstLink",
  EXPLORE_BRANDS: "ExploreBrands",
  COLLECTION: "Collection",
  SINGLE_PRODUCT: "SingleProduct",
  CREATOR_NAME: "Creator name",
  CREATOR_EARNINGS: "CreatorEarnings",
  DATE_SELECTION: "dateselection",
  CONVERSIOTN_RATE: "conversionrate",
  VALUE_REALISATION: "value_realisation",
  SHOPPINGAPP_EARNING: "shoppingapp_earning",
  CPP_CARD: "cpp_card",
  PAYOUTS_CHANGED: "payoutschanged",
  VERIFY: "verify",
  NPS_SURVEY: "npssurvey",
  DEACTIVATE: "deactivate",
  DELETE: "delete",
  REWARDS_BANNER: "rewards_banner",
  TOOLTIP_OPEN: "tooltip_open",
  TOOLTIP_CLOSE: "tooltip_close",
  NYKAA_REWARDS_BANNER: "nykaa_rewards_banner",
  NYKAA_REWARDS_SOURCING_NUDGE_CLICK: "nykaa_rewards_sourcing_nudge_click",
  FRESHDESK_CHAT: "freshdesk_chat",
  HAS_SOURCING: "HasSourcing",
  MINI_SOURCING: "MiniSourcing",
  CART: "Cart",
  MY_ORDERS: "MyOrders",
  SEARCH_ICON_CLICK: "searchIconClick",
  BRAND_SEARCH: "BrandSearch",
  CATEGORY_SUBCATEGORY: "CategorySubcategory",
  BRAND_SUBCATEGORY: "BrandSubcategory",
  SOURCING_LOCKED: "SourcingLocked",
  BRAND: "Brand",
  SUBCATEGORY: "Subcategory",
  CUSTOM: "Custom",
  CLEAR_ALL: "ClearAll",
  STATUS: "Status",
  TIME: "Time",
  EDUCATION: "Education",
  EDUCATION_BANNER: "education_banner",
  BARTER: "Barter",
  OKAY_CLICK: "OkayCLick",
  SIZE_CLICK: "SizeClick",
  SIZE_CHART_CLICK: "SizeChartClick",
  STICKY_BUTTON: "stickybutton",
  AJIO_REWARDS_BANNER: "ajio_rewards_banner_comingsoon",
  AJIO_NUDGE: "ajio_rewards_sourcing_nudge_click",
  SIZE_CHART_DRAWER: "SizeChartDrawer",
  MYNTRA_REWARDS_BANNER: "myntra_rewards_banner",
  FRESHDESK_USER_CREATED_BUT_RESTORED_ID_NOT_FOUND:
    "FreshdeskUserCreatedButRestoredIDNotFound",
  FLIPKART_LEADERBOARD_EXTERNAL: "flipkart_leaderboard_external",
  ENGAGE_COMMENT: "engage_comment",
  ENGAGE_SHARE: "engage_share",
  MEESHO_LEADERBOARD_EXTERNAL: "meesho_leaderboard_external",
  MYNTRA_LEADERBOARD_EXTERNAL: "myntra_bpc",
  API_CALL: "api_call",
  GTM_DRAWER: "gtm_drawer",
  FAQ_LIKED: "YES",
  FAQ_DISLIKED: "NO",
  THANK_YOU_CREATORS: "thank_you_creators",
  THANK_YOU_CREATORS_BANNER: "thank_you_creators_banner",
  BLACKLISTED: "blacklisted",
  CONNECT_TELEGRAM: "connectTelegram",
  CREATE_COLLAGE: "CreateCollage",
  NEXT_SELECT_PRODUCTS: "NextSelectroducts",
  NEXT_SELECT_BEST_IMAGES: "NextSelectBestImages",
  CANCEL_COLLAGE: "CancelCollage",
  DONE_COLLAGE: "DoneCollage",
  RESIZE: "Resize",
  ROTATE: "Rotate",
  REPOSITION: "Reposition",
  BRING_BACK: "BringBack",
  BRING_FRONT: "BringFront",
  DOWNLOAD_COLLAGE: "DownloadCollage",
  DELETE_COLLAGE: "DeleteCollage",
  EDIT_COLLAGE: "EditCollage",
  ADD_IMAGE: "AddImage",
  DELETE_IMAGE: "DeleteImage",
  COPY_COLLAGE_LINKS: "CopyCollageLinks",
  PUBLISH_COLLAGE: "PublishCollage",
  WRAPPED: "wrapped",
  START: "start",
  ALL_ELEMENTS: "allElements",
  TAP: "tap",
  SHARE: "share",
  ADD_COLLECTION: "addCollection",
  GROWTH: "Growth",
  GROWTHBUTTON: "GrowthButton",
  RECOMMENDATIONS: "recommendations",
  BEAUTY_AND_PERSONAL_CARE: "Beauty & Personal Care",
  HOWGROWTHWORKS: "HowGrowthWorks",
  GO_TO_DOWNLOAD: "go_to_download",
  DOWNLOAD_OPTIONS: "download_options",
  TDS_NOT_FOUND: "tds_not_found",
  DOWNLOAD_FAILED: "download_failed",
  PAN_VERIFICATION: "PANVerification",
  PROCEED_CLICK: "proceed_click",
  PROCEED_ANYWAY_CLICK: "proceed_anyway_click",
  CRASH_COURSE: "crash_course",
  MEESHO_QR_CODE: "meesho_qr_code",
  MEESHO_NEW_USER_ACQUISITION: "meesho_new_user_acquisition",
  INTEREST_MARKED: "interestmarked",
  INTEREST_NOT_MARKED: "interestnotmarkedyet",
  START_TRACKING: "start_tracking",
  APPLY_CLICK: "apply_click",
  DOESNT_HAVE_AMAZON_ACCESS: "doesnt_have_access",
  HAS_AMAZON_ACCESS: "has_access",
  CONNECT_MY_SOCIAL_CLICK: "connectmysocial_click",
  ENGAGE_FTUX: "engageftux",
  CHECK_COLLABS: "check_collabs",
  CHECK_REWARDS: "check_rewards",
  GROW_NOW: "grownow",
  ADJUSTMENT: "adjustment",
  FLAGGED_CONTENT: "flagged_content",
  DISPUTE_FORM: "dispute_form",
  GENERATE_INVOICE: "generate_invoice",
  ENTER_EMAIL: "enter_email",
  SEND_INVOICE: "send_invoice",
  CHECK_ANOTHER: "check_another",
  VIEW_ANOTHER: "view_another",
  UPLOAD_GST_CERTIFICATE: "upload_gst_certificate",
  GST: "GST",
  RE_APPLY: "re_apply",
  CONSENT: "consent",
  READ_POLICY: "read_policy",
  CLAIM_CREDIT: "claim_credit",
  CLAIM_ANOTHER: "claim_another",
  GET_INVOICE: "get_invoice",
  SUPPORT: "support",
  SUBMIT_REQUEST: "submit_request",
  RETRY_DOWNLOAD: "retry_download",
  SHOP_NAME_EDUCATION: "shop_name_education",
  NO_IMAGE: "noimage",
  CREATE_CATALOG: "createcatalog",
  VIEW_YOUR_CARTS: "viewyourcarts",
  ADD_MORE_PRODUCTS: "addmoreproducts",
  WISHLINK_SOURCING: "wishlinksourcing",
  BRAND_SOURCING: "brandsourcing",
  BOTH_SOURCING_ORDERS: "both_sourcing_orders",
  SAVE_FOR_LATER_PLP: "SaveForLaterPLP",
  TOOLTIP_CLICK: "tooltipclick",
  CREDIT_HISTORY: "credit_history",
  CUSTOM_COLLECTION: "customcollection",
  RECOMMENDEDCOLLECTIONS: "recommendedcollections",
  MULTIPLE_FILTER_SELECTION: "MultipleFilterSelection",
  CONTENT_PENDING: "ContentPending",
  TO_BE_RETURNED: "ToBeReturned",
  CALL_SUPPORTNO: "call_supportno",
  ADDRESS_LIST: "address_list",
  DELIVERY_ADDRESS_SELECTION_CLICK: "DelveryAddressSelectionClick",
  ADD_NEW_ADDRESS: "add_new_address",
  SAVE_NEW_ADDRESS: "save_new_address",
  GOT_IT_CLICK: "got_itclick",
  RECOMMENDEDCOLLECTION: "recommendedcollection",
  BANNER_CLICK: "banner_click",
  REENGAGE_FOLLOWERS: "reengage_followers",
  DMTYPE_ENGAGE: "dmtype_engage",
  CLOSE_ENGAGEFORSTORIES_EDUCATIONBANNER:
    "close_engageforstories_educationbanner",
  CHECK_WLPOST_DRAWER: "check_wlpost_drawer",
  FILTER_OPTION_CLICKED: "filter_option_clicked",
  STORIES_EDUCATION: "stories_education",
  SOURCE_NOW: "source_now",
  OTP_VERIFIED: "otp_verified",
  POLLING_ANIMATION: "polling_animation",
  LIBAS_SALE_2_26_BANNER: "libas_sale_2_26_banner",
  BRANDS_COLLECTION: "collection",
  BRANDS_PRODUCT_CARD: "product_card",
  BRANDS_BOTTOM_SHEET: "bottom_sheet",
  BRANDS_PRODUCT_TILE: "product_tile",
  BRANDS_SHARE_TO_STORY: "share_to_story",
  REWARDS_EXPERIMENT_REWARD_BRAND: "reward_brand",
  REWARDS_EXPERIMENT_PLAY_CONTENT: "play_content",
  REWARDS_EXPERIMENT_VIEW_REWARD_DETAILS: "view_reward_details",
  REWARDS_EXPERIMENT_NEXT_CONTENT: "next_content",
  REWARDS_EXPERIMENT_PREVIOUS_CONTENT: "previous_content",
  REWARDS_EXPERIMENT_VIEW_ALL: "view all",
  REWARDS_EXPERIMENT_VIEW_SOURCING: "view_sourcing",
  REWARDS_EXPERIMENT_COLLECTION: "collection",
  REWARDS_EXPERIMENT_PRODUCT_CLICK: "product_click",
  REWARDS_EXPERIMENT_COPY_WISHLINK: "copy_wishlink",
  SHARE_WISHLINK: "share_wishlink",
  BRAND_TILE: "brand_tile",
  OPEN_INFO: "open_info",
  CHECK_WEBSITE: "check_website",
  REWARD_OPTIN: "reward_optin",
  REWARD_DETAILS: "reward_details",
  REWARD_TILE: "reward_tile",
  CONTENT_PLAY: "content_play",
  CONTENT_SCROLL: "content_scroll",
  SEE_ALL_CONTENT: "see_all_content",
  SEE_ALL_BRANDS: "see_all_brands",
  VIEW_ALL_BRAND_TRAY: "view_all_brand_tray",
  START_SEARCH: "start_search",
  CLICK_AUTO_SUGGEST: "click_auto_suggest",
  SHARE_WL: "share_wl",
  COPY_WL: "copy_wl",
  OPEN_IG: "open_ig",
  GROWTH_EARNINGS: "growth_earnings",
  FILTER_BRAND: "brand",
  FILTER_CATEGORY: "category",
  EXPLORE_COLLECTION: "explore_collection",
  VIEW_ALL_PRODUCTS: "view_all_products",
  SEARCH_ENTERED: "search_entered",
  SEARCH_RESULTS_LOAD: "search_results_load",
  SEARCH_CLEARED: "search_cleared",
  PRODUCT_CLICK_EXT: "product_click_ext",
  SORT_RESULTS: "sort_results",
  FILTER_SELECT: "filter_select",
  CONTENT_REEL_SCROLL: "content_reel_scroll",
  VIEW_REWARD: "view_reward",
  SOURCE: "source",
  STORY_WISHLINK: "story_wishlink",
  NOTIFY_ME: "notify_me",
  SURVEY_SUBMIT: "survey_submit",
  STREAKS_FTUX: "streaks_ftux",
  OKAY_GOTIT_CLICK: "okay_gotit_click",
  // COC 2026
  COC_FTUX: "coc_ftux",
  REDIRECT_TO_YT: "redirect_to_yt",
  NOMINATIONS: "nominations",
  WINNERS: "winners",
  WINNER: "winner",
  VIEW_ALL_NOMINATIONS: "view_all_nominations",
  FOLLOW_US: "follow_us",
  STREAKS: "streaks",
  MAIN_TAB_CLICK: "main_tab_click",
  STREAK_PILL_CLICK: "streak_pill_click",
  HOW_IT_WORKS_CLICK: "how_it_works_click",
  STREAK_LISTING: "streak_listing",
  EMPTY_STATE: "empty_state",
  HISTORY_LINE_ITEM_CLICK: "history_line_item_click",
  STREAK_CARD: "streak_card",
  STREAK_CARD_CTA_CLICK: "streak_card_cta_click",
  STREAK_CARD_CTA_CLICK_PRELAUNCH: "streak_card_cta_click_prelaunch",
  STREAK_CARD_CTA_CLICK_LIVE: "streak_card_cta_click_live",
  STREAK_CARD_CTA_CLICK_MISSED: "streak_card_cta_click_missed",
  STREAK_CARD_CTA_CLICK_WON: "streak_card_cta_click_won",
  CONDITIONS_BAR: "conditions_bar",
  BRAND_TOOLTIP: "brand_tooltip",
  STREAK_TRACKER_SCROLL: "streak_tracker_scroll",
  STREAK_IDENTITY: "streak_identity",
  LAST_UPDATED_STRIP: "last_updated_strip",
  RULES_SECTION: "rules_section",
  FAILURE_RULES_SECTION: "failure_rules_section",
  SECTION_TOGGLE: "section_toggle",
  LINKS_SECTION: "links_section",
  PERIOD_TOGGLE: "period_toggle",
  POST_LINE_ITEM_CLICK: "post_line_item_click",
  COPY_SP_WISHLINK_CLICK: "copy_SP_wishlink_click",
  NEED_HELP_CLICK: "need_help_click",
  STREAK_PDF_CLICK: "streak_pdf_click",
  HOW_IT_WORKS_TAB_CLICK: "how_it_works_tab_click",
  GOT_IT_CLICK: "got_it_click",
  STREAK_PROGRESS: "streak_progress",
  CHECK_STREAKS: "check_streaks",
  // Streaks homepage-takeover FTUX (doc-exact events, additive)
  STREAK_FTUX_HOME_TAKEOVER_SHOWN: "streak_ftux_popup",
  STREAK_FTUX_HOME_TAKEOVER_CTA: "streak_ftux_CTA",
  STREAK_FTUX_HOME_TAKEOVER_CLOSE: "streak_ftux_close",
  SELEQT_STUDIO_EXPERIMENT_BANNER_CLICK:
    "seleqt_studio_experiment_banner_click",
};

export const GA_LABEL2 = {
  SELEQT_BY_WISHLINK_FTUX: "seleqtbywishlink_ftux",
  OPPORTUNITIES: "Opportunities",
  EXCITING_SALES: "Exciting Sales",
  FRESH_BRANDS_ON_WISHLINK: "Fresh Brands on Wishlink",
  COLLECTION_TILE: "collection_tile",
  SEE_ALL_COLLECTIONS: "see_all_collections",
  INSIDE_COLLECTION: "inside_collection",
  COLLECTION: "collection",
  UPDATE_BANK_DRAWER: "update_bank_drawer",
  BANK_PAN: "Bank_PAN",
  PROCEED_AFTER_VERIFICATION: "proceed_after_verification",
  ADD: "add",
  UPDATE: "update",
  SOURCING_FTUX: "sourcingftux",
  REWARDS: "Rewards",
  ONGOING: "ongoing",
  OPTED_IN: "opted_in",
  COMPLETED: "completed",
  EXPIRED: "expired",
  LOCKED: "locked",
  RETURNED: "returned",
  ALL: "all",
  PAGE_NOT_CONNECTED: "pagenotconnected",
  LOCKED_MILESTONE: "lockedmilestone",
  FOLLOWERS: "followers",
  ACCOUNT_TYPE: "accounttype",
  ACCOUNT_MAPPING: "accountmapping",
  SUBSCRIBERS: "subscribers",
  MEDIA_PERMISSIONS: "mediapermissions",
  POSTS: "posts",
  LEADERBOARD_RANKS: "leaderboardranks",
  POST_YT: "postyt",
  POST_IG: "postig",
  POST_FB: "postfb",
  POST_PINTEREST: "postpinterest",
  EDUCATION_PAGE: "education_page",
  ENABLE_CROSSPOSTING: "enable_crossposting",
  MEN: "men",
  WOMEN: "women",
  WA_ALLOWED: "waallowed",
  WA_DISALLOWED: "wadisallowed",
  IG_POST: "igpost",
  IG_REEL: "igreel",
  YT_SHORTS: "ytshorts",
  YT_VIDEO: "ytvideo",
  COMPLETE: "complete",
  MIN_EARNINGS: "minearnings",
  EXISTING_CONTENT: "existingcontent",
  UNLINK_INSTA: "unlinkinsta",
  ON: "on",
  OFF: "off",
  HIDE: "hide",
  UNHIDE: "unhide",
  MANUAL: "manual",
  AUTO: "auto",
  NO_OTP: "nootp",
  IG: "ig",
  YT: "yt",
  FB: "fb",
  BOTH: "both",
  REWARDS_Y: "rewardsy",
  REWARDS_N: "rewardsn",
  NEXT: "next",
  PREVIOUS: "previous",
  VIEW_LESS: "viewless",
  VIEW_MORE: "viewmore",
  POST: "post",
  PRODUCT: "product",
  CHART: "chart",
  LEGEND: "legend",
  BUTTON: "button",
  TEXT: "text",
  ANIMATION: "animation",
  COMPONENT: "Component",
  PDP_SIMILAR_PRODUCTS: "pdp_similar_products",
  HEADER: "Header",
  TAP: "Tap",
  PRE_SALE: "presale",
  POST_SALE: "postsale",
  SWITCH_HANDLE: "switch",
  SKIPFORNOW: "skipfornow",
  NO: "no",
  YES: "yes",
  COMMISSION_ATTRIBUTION: "commission_&_attribution",
  SOCIALMEDIABLOCKED: "socialmediablocked",
  USERBLOCKED: "userblocked",
  KYC: "kyc",
  TELEGRAM: "telegram",
  SOCIAL_LOGIN_SUCCESS: "social_login_success",
  SOCIAL_LOGIN_FAIL: "social_login_fail",
  AMAZON_FTUX: "amazonftux",
  AMAZON_STOREID_DRAWER: "amazon_storeID_drawer",
  ENGAGE_FTUX: "engageftux",
  BRAND_COLLAB_FTUX: "brandcollabftux",
  REWARDS_FTUX: "rewardsftux",
  GROWTH_FTUX: "growthftux",
  INSIGHTS: "insights",
  PAYOUTS: "payouts",
  CONFIRMED_COMMISSIONS: "confirmed-commissions",
  LIFETIME_PAYOUT: "lifetime-payout",
  FLAGGED_CONTENT: "flagged_content",
  INFO_ICON: "info_icon",
  TAX_INVOICE: "tax_invoice",
  GST_CLAIMED: "gst_claimed",
  ALREADY_CLAIMED: "already_claimed",
  CLAIM_ERROR: "claim_error",
  EDUCATION_OPEN: "education_open",
  EDUCATION_CLOSE: "education_close",
  VIEW_ALL: "View All",
  LEARN_MORE_REENGAGE: "learnmore_reengage",
  REENGAGE_EDUCATION_DRAWER: "reengage_education_drawer",
  TAB_SELECT: "tab_select",
  RELOGIN: "relogin",
  POST_SELECT: "post_select",
  POST_TITLE_FIELD_CLICK: "post_title_field_click",
  STORIES_EDUCATION: "stories_education",
  CHECK_CLICK: "check_click",
  SELECT_POST: "select_post",
  CREATE_POST: "createpost",
  GOT_IT: "gotit",
  CHANNEL: "channel",
  BRAND: "brand",
  CONTENT_TYPE: "content_type",
  TRY_IT_NOW: "try_it_now",
  TRY_LATER: "try_later",
  SEE_ALL: "see_all",
  VIEW_PRODUCTS: "view_products",
  INTERNAL_PAGE: "internal_page",
  EXTERNAL_PAGE: "external_page",
  OPEN: "open",
  CLOSE: "close",
  LEFT: "left",
  RIGHT: "right",
  COLLAB_LISTING: "collab_listing",
  COLLAB_INBOX: "collab_inbox",
  // Folders
  FOLDER_OPEN: "folder_open",
  FOLDER_CREATE: "folder_create",
  FOLDER_ADD_LINK: "folder_add_link",
  FOLDER_PASTE_LINK: "folder_paste_link",
  FOLDER_DELETE_ITEM: "folder_delete_item",
  FOLDER_ITEM_CLICK: "folder_item_click",
  FOLDER_ADD_LINK_SHEET_OPEN: "folder_add_link_sheet_open",
  FOLDER_ADD_TO_FOLDER_SHEET_OPEN: "folder_add_to_folder_sheet_open",
  FOLDER_SELECT_FOR_SHARED_LINK: "folder_select_for_shared_link",
  FOLDER_CREATE_AND_ADD: "folder_create_and_add",
  // DIY Catalogue
  DIY_ADD_FROM_CATALOG: "diy_add_from_catalog",
  DIY_ADD_FROM_EXISTING: "diy_add_from_existing",
  SHARE_TO_WISHLINK_LOCKED_REDIRECT: "share_to_wishlink_locked_redirect",
  // COC 2026
  SHARE_ON_INSTA: "share_on_insta",
  VIEW_DETAILS: "view_details",
  SHARE_INVITE: "share_invite",
  SHARE_ON_IG: "share_on_ig",
  GO_BACK: "go_back",
  CROSS: "cross",
  FIRST_TIME: "first_time",
  REPEAT: "repeat",
  // Engage v2
  TYPE_DROPDOWN: "type_dropdown",
  POST_TYPE_CHOOSE_DRAWER: "post_type_choose_drawer",
  CHANGE_REPLYTYPE_CONFIRM_DRAWER: "change_replytype_confirm_drawer",
  ADDLINK_FIELDCLICK: "addlink_fieldclick",
  PASTE: "paste",
  ADD_ANOTHER_LINK: "add_another_link",
  FOLLOW_FIRST_TOGGLE: "follow_first_toggle",
  CROSS_POST_TOGGLE: "cross_post_toggle",
  AUTO_COMMENT_TOGGLE: "auto_comment_toggle",
  EDUCATION_DRAWER: "education_drawer",
  EDIT_POST_LINK_DRAWER: "editpostlink_drawer",
  INCOMPLETE_DETAILS_DRAWER: "incomplete_details_drawer",
  CREATE_WISHLINK: "create_wishlink",
  EDIT_POST: "edit_post",
  SAVE_AS_DRAFT: "save_as_draft",
  OPEN_DRAWER: "open_drawer",
};

export const GA_LABEL3 = {
  ADD: "add",
  NEW: "new",
  UPDATE: "update",
  NO_INDICATOR: "no_indicator",
  NONE: "none",
  LOCKED_INDICATOR: "locked_indicator",
  GREEN_INDICATOR: "green_indicator",
  RED_INDICATOR: "red_indicator",
  ORANGE_INDICATOR: "orange_indicator",
  BEFORE_LOCKED: "before_locked",
  REALISATION_PAGE: "realisation_page",
  ORANGE_PREFIX: "orange",
  PAN_KNOW_MORE: "pan_know_more",
  UNLINKED: "unlinked",
  CONFIRMED_COMMISSIONS: "confirmed-commissions",
  LIFETIME_PAYOUT: "lifetime-payout",
  IG: "ig",
  FB: "fb",
  ENGAGE_IG: "engage_ig",
  ENGAGE_FB: "engage_fb",
  FB_FTUX: "fbftux",
  INFO_OF_CREDIT: "info_of_credits",
  ACTUAL_CREDIT_CLAIM: "actual_credit_claim",
  CUSTOM_COLLECTION: "customcollection",
  RECOMMENDED_COLLECTION: "recommendedcollection",
  VIEW_ALL: "View All",
  PRODUCT_CARD: "ProductCard",
  IG_POST: "igpost",
  IG_STORY: "igstory",
  IG_REEL: "igreel",
  FB_FIRST_COMMENT: "fb_firstcomment",
  BANNER: "banner",
  CREATE: "create",
  OPEN: "Open",
  NEW: "New",
  SHOP: "shop",
  LIBAS: "libas",
  NEW_INDICATOR: "new_indicator",
};

export const GA_PAGE = {
  RAZORPAY_VERIFICATION: "razorpay-verification",
  SELECT_BY_WISHLINK: "/select-by-wishlink",
  SELEQT_BY_WISHLINK_FTUX: "/seleqtbywishlink_page_1_intro",
  FESTIVE_LANDING1: "/festive_landing1",
  FESTIVE_LANDING2: "/festive_landing2",
  ANNOUNCEMENTS: "announcements",
  FB_LOGIN_FAIL: "fbloginfail",
  FB_PAGE_SELECT: "fb_pageselect",
  PREVIEW_CONTENT: "previewcontent",
  TOP_ECCOM: "top-ecomm",
  ADJUSTMENT_EDU: "adjustment-education",
  BRANDCOLLABDETAILS: "BrandCollabdetails",
  BRANDCOLLABCHAT: "BrandCollabChat",
  BRANDCOLLABPERKS: "BrandCollabPerks",
  BRANDCOLLABBRIEF: "BrandCollabBrief",
  BRANDCOLLABLISTING: "/BrandCollablisting",
  BRANDCOLLABINBOX: "/BrandCollabInbox",
  SUGGESTED_ACTIONS: "suggestedactions",
  BRAND_COLLAB_FTUX: "Brandcollabftux",
  D2CCATEGORY: "D2CCategoryPage",
  RECOMMENDATION: "recommendation",
  GROWTH: "growth",
  PRODUCT_GROWTH: "/product-growth",
  PRODUCT_GROWTH_EDUCATION: "/product-growth-education",
  DEBUG_START: "/debugstart",
  DEBUG: "/debug",
  META_BOI: "meta-boi",
  PAYOUTS_PRELAUNCH: "payoutsprelaunch",
  LIBAS_REWARDS: "libasrewards",
  LOADING: "loading",
  ORDER_LEDGER: "orderledger",
  HELP: "help",
  SHOP: "shop",
  LOGIN: "login",
  HOME: "home",
  HAMBURGER: "hamburger",
  ANALYTICS: "analytics",
  ANALYTICS_TITLE: "Analytics",
  BRANDS: "brands",
  DISCOVER: "discover",
  CREATE: "create",
  PAYOUTS: "payouts",
  PROFILE: "profile",
  REWARDS: "rewards",
  SELLING_PLAYBOOK: "sellingplaybook",
  ENGAGE: "engage",
  ENGAGE_SETTING: "engagesetting",
  NOTIFICATION: "notification",
  REFERRAL: "referral",
  REFERRALTERMS: "ReferralTerms",
  FESTIVEBONANZA: "Festivebonanza",
  BEST_SELLERS: "bestsellers",
  PUBLIC_BRANDS: "PublicBrands",
  ONBOARDING_HOME: "onboardinghome",
  CREATOR_EARNINGS: "CreatorEarnings",
  PAYOUTS_LAUNCH: "payoutslaunch",
  BRANDS_MEN: "brands/men",
  BRANDS_WOMEN: "brands/women",
  BRANDS_ALL: "brands/all",
  NYKAA_REWARDS: "nykaa-rewards",
  SOURCING: "sourcingHome",
  SEARCH: "search",
  PRODUCT: "product",
  SOURCING_ORDER: "sourcing/my-orders",
  MINI_SOURCING_ORDER: "mini-sourcing-active-orders",
  FILTER: "filter",
  SOURCING_CREDIT: "SourcingCredits",
  SOURCING_CREDIT_FAQ: "SourcingCredits/FAQ",
  MINI_SOURCING_FAQ: "MiniSourcing/FAQ",
  SOURCING_LOCKED_FAQ: "SourcingLocked/FAQ",
  MINI_SOURCING_PAGE_OPEN_BANNER: "Banner/MiniSourcing",
  MINI_SOURCING: "sourcing/mini",
  MINI_SOURCING_CART: "mini-sourcing-cart",
  CATALOG: "Catalog",
  AJIO_REWARDS: "rewards_ajio",
  MYNTRA_REWARDS: "rewards_myntra",
  ENGAGE_COMMENT: "engage_comment",
  ENGAGE_SHARE: "engage_share",
  WISHLINK_REWARDS: "wishlink-rewards",
  CONTENTLINKS: "contentlinks",
  KYC: "kyc",
  CONTENT_DETAILS: "contentdetails",
  FAQ: "FAQ",
  ADD_PROFILE_DRAWER: "addProfileDrawer",
  COLLAGE: "Collage",
  WRAPPED: "wrapped",
  CRASH_COURSE: "crash_course",
  ENGAGE_FTUX_PAGE1_INTRO: "engageftux_page1_intro",
  ENGAGE_FTUX_PAGE2: "engageftux_page2",
  ENGAGE_FTUX_PAGE3: "engageftux_page3",
  BRAND_COLLAB_FTUX_PAGE1_INTRO: "brandcollabftux_page1_intro",
  BRAND_COLLAB_FTUX_PAGE2_PARAMETERS: "brandcollabftux_page2_parameters",
  BRAND_COLLAB_FTUX_PAGE3_INTERESTFORM: "brandcollabftux_page3_interestform",
  BRAND_COLLAB_FTUX_PAGE4_FORMFILLED: "brandcollabftux_page4_formfilled",
  BRAND_COLLAB_FTUX_REALISATIONPAGE: "brandcollabftux_realisationpage",
  BRAND_COLLAB_FTUX_PAGE4_FORM_DETAILS: "brandcollabftux_page4_form_details",
  REWARDS_FTUX_PAGE1_INTRO: "rewardsftux_page1_intro",
  REWARDS_FTUX_PAGE2_TYPE_OF_REWARDS: "rewardsftux_page2_typeofrewards",
  REWARDS_FTUX_REALISATION_PAGE: "rewardsftux_realisationpage",
  GROWTH_FTUX_PAGE1: "growthftux_page1",
  GROWTH_FTUX_REALISATION_PAGE: "growthftux_realisationpage",
  SOURCING_FTUX_PAGE1_INTRO: "sourcingftux_page1_intro",
  SOURCING_FTUX_PAGE2: "sourcingftux_page2",
  SOURCING_FTUX_PAGE3: "sourcingftux_page3",
  SOURCING_FTUX_PAGE4: "sourcingftux_page4",
  GST: "GST",
  FACEBOOK_EDUCATION: "/fbeducation",
  WISHLINK_SOURCING: "wishlinksourcing",
  BRAND_SOURCING: "brandsourcing",
  MY_ORDER: "MyOrder",
  PAID_COLLABORATION_CHECKOUT: "paid-collaboration-checkout",
  PAID_COLLABORATION_PRODUCTS: "paid-collaboration-products",
  CROSSPOSTING: "/crossposting",
  CROSSPOSTING_PANEL: "crossposting",
  CROSSPOSTING_FTUX: "/crossposting-ftux",
  CROSSPOSTING_EDUCATION: "crossposting_education",
  DIY: "diy",
  BRANDS_TOP_ECOMM: "top_ecomm",
  REWARDS_EXPERIMENT_BRANDS_PAGE: "brands_page",
  REWARDS_EXPERIMENT_REWARD_BRAND: "reward_brand",
  FOLDERS: "/folders",
  FOLDER_DETAIL: "/folder_detail",
  PRODUCT_REVIEWS: "product_reviews",
  PRODUCT_REVIEW_SUBMIT_PAGE: "product_review_submit_page",
  STREAKS_EDUCATION_PAGES: "streaks_educationpages",
  // COC 2026
  COC_2026: "coc_2026",
  STREAKS: "streaks",
  REWARD_HISTORY: "reward-history",
  REWARDS_STREAKS_HOW_IT_WORKS: "rewards_streaks_how_it_works",
  STREAK_PDF: "streaks",
  STREAKS_REALISATION_PAGE: "streaks_realisationpage",
};

export const GA_SCREEN_NAME = {
  REWARD_FTUX: "reward_ftux",
  SOURCING_PAUSED: "sourcing_paused",
  PRODUCT_REVIEWS: "product_reviews",
  PRODUCT_REVIEW_SUBMIT_PAGE: "product_review_submit_page",
  SELECT_BY_WISHLINK_LANDING_PAGE: "select_by_wishlink_landing_page",
  SELEQT_BY_WISHLINK_FTUX_PAGE_1_INTRO: "seleqtbywishlink_page_1_intro",
  SELEQT_BY_WISHLINK_FTUX_PAGE_2: "seleqtbywishlink_page_2",
  SELEQT_BY_WISHLINK_FTUX_PAGE_3: "seleqtbywishlink_page_3",
  CROSSPOSTING_LANDING_PAGE: "crossposting_landing_page",
  CROSSPOSTING_FTUX: "crossposting_ftux",
  CROSSPOSTING_EDUCATION: "crossposting_education",
  CROSSPOSTING: "crossposting",
  EDUCATION_PAGE: "education_page",
  CREATE: "create",
  FESTIVE_LANDING1: "festive_landing1",
  FESTIVE_LANDING2: "festive_landing2",
  ANNOUNCEMENT_DETAILS: "announcement_details",
  ANNOUNCEMENTS_HOME: "announcements_home",
  FB_LOGIN_FAIL: "fbloginfail",
  FB_PAGE_SELECT: "fb_pageselect",
  SHOP_EDUCATION: "Shop_Education",
  ADJUSTMENT_EDU: "adjustment-education",
  IG_LOGIN_PERMISSION_DRAWER: "login_permission_drawer",
  SIGNUP_DUPLICATE: "SignupDuplicate",
  QUICK_FILTER: "quickfilterdrawer",
  SHOP_PREVIEW: "shoppreview",
  SHOP_FILTERS: "shopfilters",
  BRANDCOLLABOPTOUT: "BrandCollabOptout",
  BRANDCOLLABOPTINADDRESS: "BrandCollabOptinAddress",
  BRANDCOLLABOPTINPRICE: "BrandCollabOptinPrice",
  BRANDCOLLABTASK: "BrandCollabTask",
  BRANDCOLLABPERKS: "BrandCollabPerks",
  PAID_COLLABORATION_PRODUCTS: "paid-collaboration-products",
  PAID_COLLABORATION_CHECKOUT: "paid-collaboration-checkout",
  CHECKOUT_SUCCESS: "checkout-success",
  BRANDCOLLABBRIEF: "BrandCollabBrief",
  BRANDCOLLABLISTING: "/BrandCollablisting",
  SUGGESTED_ACTIONS: "suggestedactions",
  BRAND_COLLAB_FTUX: "Brandcollabftux",
  RECOMMENDATION: "recommendation",
  GROWTH: "growth",
  DEBUG_START: "/debugstart",
  FOLDERS: "folders",
  FOLDER_DETAIL: "folder_detail",
  DEBUG: "/debug",
  META_BOI: "meta-boi",
  MONTHLY_ORDER_STATUS: "monthly_order_status",
  VALUE_REALISATION: "value_realisation",
  INSIGHTS: "Insights",
  PAYOUTS_PRELAUNCH: "payoutsprelaunch",
  LIBAS_REWARDS: "libasrewards",
  LOADING: "loading",
  ORDER_LEDGER: "orderledger",
  DETAILED_HELP: "detailedhelp",
  HELP: "help",
  MILESTONE_SCREEN: "milestonescreen",
  DRAWER: "drawer",
  BRANDS_SEARCH_M: "brandssearchm",
  BRANDS_SEARCH_W: "brandssearchw",
  BRANDS_CATEGORY_M: "brandscategorym",
  BRANDS_CATEGORY_W: "brandscategoryw",
  ENGAGE: "engage",
  CONTENT_ANALYTICS: "contentanalytics",
  SELLING_PLAYBOOK_EARNINGS: "sellingplaybookearnings",
  SELLING_PLAYBOOK_POSTS: "sellingplaybookposts",
  POPUP: "popup",
  PREVIEW_CONTENT: "previewcontent",
  PREVIEW_DETAILS: "previewdetails",
  PRODUCT_DETAILS: "productdetails",
  SHOP: "shop",
  SHOP_PROPS: "shopprops",
  LOGIN: "login",
  SIGNUP: "signup",
  ENTER_DETAILS: "enterdetails",
  SIGNUP_FAIL: "signupfail",
  HOME: "home",
  ANALYTICS: "analytics",
  ANALYTICS_OVERLAY: "analyticsoverlay",
  ANALYTICS_DETAIL: "analytics",
  BRANDS: "brands",
  DISCOVER: "discover",
  VIEW_ALL: "view_all",
  CONTENT_EXPLORE: "content_explore",
  QUICK_PICKS: "quick_picks",
  CONTENT: "content",
  CONTENT_REEL: "content_reel",
  PRODUCTS: "products",
  REWARDS_EXPERIMENT_REWARD_BRANDS: "reward_brands",
  REWARDS_EXPERIMENT_REWARD_BRAND: "reward_brand",
  REWARDS_EXPERIMENT_REEL_PLAYER: "reel_player",
  REWARDS_EXPERIMENT_PLP_PRODUCTS: "plp_products",
  REWARDS_EXPERIMENT_COLLECTION: "collection",
  BRAND_PAGE: "Brand_page",
  PLP_PRODUCTS: "plp_products",
  SHARE: "share",
  SURVEY: "survey",
  POSTDETAILS: "postdetails",
  PAYOUTS: "payouts",
  PROFILE: "profile",
  REWARDS: "rewards",
  LEADERBOARD: "leaderboard",
  SELLING_PLAYBOOK: "sellingplaybook",
  CONTENT_DETAILS: "contentdetails",
  PREVIEW_STOREFRONT: "previewstorefront",
  ENGAGE_SETTING: "engagesetting",
  NOTIFICATION: "notification",
  REFERRAL: "referral",
  REFERRALTERMS: "ReferralTerms",
  FESTIVEBONANZA: "FestiveBonanza",
  BEST_SELLERS: "bestsellers",
  BEST_SELLERS_COLLECTION: "bestsellerscollection",
  YT_SHOPPING_NOTIFICATION: "YTShoppingNotification",
  BRAND_SELECTION: "brand_selection",
  ONBOARDING_HOME: "onboardinghome",
  CENTRAL_WIDGET: "CentralWidget",
  CREATE_LINK_DRAWER: "CreateLinkDrawer",
  EXPLORE_BRANDS: "ExploreBrands",
  CREATOR_EARNINGS: "CreatorEarnings",
  CREATOR_NAME: "CreatorName",
  SALE_DRAWER: "saledrawer",
  PAYOUTS_LAUNCH: "payoutslaunch",
  PAYOUTS_PENDING: "payoutsPending",
  PAYOUTS_CONFIRMED: "payoutsConfirmed",
  PAYOUTS_PENDING_BRAND: "payoutsPendingBrand",
  PAYOUTS_CONFIRMED_BRAND: "payoutsConfirmedBrand",
  PAST_PAYOUTS: "pastpayouts",
  PAYOUT_STATUS: "payoutstatus",
  PAYOUTS_CX: "payouts",
  PAYOUT_STATUS_CX: "payout_status",
  PAYOUT_HISTORY_CX: "payout_history",
  PAYOUT_DETAILS_CX: "payout_details",
  PENDING_COMMISSIONS_CX: "pending_commissions",
  REQUEST_REPORT: "Requestreport",
  PAYOUTS_PAID: "payoutsPaid",
  NYKAA_REWARDS: "nykaa-rewards",
  PAYOUT_DETAILS: "payoutdetails",
  SEARCH: "search",
  PRODUCT: "product",
  SOCIAL_LOGIN: "sociallogin",
  SOURCING_CART: "SourcingCart",
  MY_ORDER: "MyOrder",
  SOURCING_CREDIT: "SourcingCredits",
  MINI_SOURCING: "MiniSourcing",
  MINI_SOURCING_CART: "MiniSourcingCart",
  BRAND_PLP: "BrandPLP",
  COLLECTION_PLP: "CollectionPLP",
  SEARCH_PLP: "SearchPLP",
  CUSTOM_PLP: "CustomPLP",
  CATEGORY_PLP: "CategoryPLP",
  PRODUCT_CARD: "ProductCard",
  FAQ: "Faq",
  AJIO_REWARDS: "rewards_ajio_static_page",
  AJIO_REWARDS_TRACKING: "rewards_ajio_tracking",
  WISHLINK_REWARDS: "wishlink-rewards",
  REWARD_DETAILS: "reward-details",
  REWARD_TRACKING: "reward-tracking",
  ELIGIBLE_POSTS: "eligible_posts",
  NOT_ELIGIBLE_POSTS: "not_eligible_posts",
  ELIGIBLE_PLP: "eligible_PLP",
  CONTENTLINKS: "contentlinks",
  KYC: "kyc",
  SAVE_FOR_LATER_PLP: "SaveForLaterPLP",
  MINI_SOURCING_SAVE_FOR_LATER: "MiniSourcingSaveForLater",
  SELECT_PRODUCTS: "SelectProducts",
  SELECT_BEST_IMAGES: "SelectBestImages",
  EDIT_COLLAGE: "EditCollage",
  COPY_COLLAGE: "CopyCollage",
  CATEGORY: "Category",
  ANSWER: "Answer",
  PAN_VERIFICATION: "pan-verification",
  CRASH_COURSE: "crash_course",
  REWARDS_HISTORY: "rewards-history",
  RAZORPAY_VERIFICATION: "razorpay-verification",
  BANK_DETAILS: "bank-details",
  AMAZON_FTUX_PAGE1_INTO: "amazonftux_page1_intro",
  AMAZON_FTUX_PAGE2_INTEREST: "amazonftux_page2_interest",
  ENGAGE_FTUX_PAGE1_INTRO: "engageftux_page1_intro",
  ENGAGE_FTUX_PAGE2: "engageftux_page2",
  ENGAGE_FTUX_PAGE3: "engageftux_page3",
  BRAND_COLLAB_FTUX_PAGE1_INTRO: "brandcollabftux_page1_intro",
  BRAND_COLLAB_FTUX_PAGE2_PARAMETERS: "brandcollabftux_page2_parameters",
  BRAND_COLLAB_FTUX_PAGE3_INTERESTFORM: "brandcollabftux_page3_interestform",
  BRAND_COLLAB_FTUX_PAGE4_FORM_FILLED: "brandcollabftux_page4_formfilled",
  BRAND_COLLAB_FTUX_REALISATIONPAGE: "brandcollabftux_realisationpage",
  BRAND_COLLAB_FTUX_PAGE4_FORM_DETAILS: "brandcollabftux_page4_form_details",
  REWARDS_FTUX_PAGE1_INTRO: "rewardsftux_page1_intro",
  REWARDS_FTUX_PAGE2_TYPE_OF_REWARDS: "rewardsftux_page2_typeofrewards",
  REWARDS_FTUX_REALISATION_PAGE: "rewardsftux_realisationpage",
  GROWTH_FTUX_PAGE1: "growthftux_page1",
  GROWTH_FTUX_REALISATION_PAGE: "growthftux_realisationpage",
  SOURCING_FTUX_PAGE1_INTRO: "sourcingftux_page1_intro",
  SOURCING_FTUX_PAGE2: "sourcingftux_page2",
  SOURCING_FTUX_PAGE3: "sourcingftux_page3",
  SOURCING_FTUX_PAGE4: "sourcingftux_page4",
  GST_SUBMISSION: "gst_submission",
  GST_VALIDATION: "gst_validation",
  GST_CLAIM_APPLY: "gst_claim_apply",
  GST_DETAILS: "gst_details",
  GST_ERROR: "gst_error",
  FACEBOOK_EDUCATION: "fbeducation",
  WISHLINK_SOURCING: "wishlinksourcing",
  CATALOG_CREATION: "Catalogcreation",
  CATALOG: "Catalog",
  ECOMM_CATALOG: "ecomm_catalog",
  SOURCING: "sourcingHome",
  BRANDS_TOP_ECOMM: "top_ecomm",
  STREAKS_FTUX_PAGE1_INTRO: "streaks_ftux_page1_intro",
  STREAKS_FTUX_PAGE2_BENEFITS: "streaks_ftux_page2_benefits",
  // COC 2026
  LANDING_PAGE: "landing_page",
  STORIES: "stories",
  // Streaks v2 (listing, track progress, how-it-works, learn-more PDF).
  // These duplicate the strings in GA_CUSTOM_PARAMETER below for callers
  // that need them as screen_name values.
  STREAKS_LISTING: "streaks_listing",
  STREAK_PROGRESS: "streak_progress",
  REWARDS_EDUCATION: "rewards_education",
  STREAKS_EDUCATION: "streaks_education",
  STREAK_PDF: "streak_pdf",
  ENGAGE_COMMENT: "engage_comment",
  // Streaks homepage-takeover FTUX (doc-exact, additive)
  STREAK_FTUX_HOME_TAKEOVER: "streak_ftux",
};

export const GA_CUSTOM_PARAMETER = {
  INVITED_CREATOR: "invited_creator",
  NON_INVITED_CREATOR: "non_invited_creator",
  STREAKS_FTUX_PAGE3_REALISATION: "streaks_ftux_page3_realisation",
  STREAKS_LISTING: "streaks_listing",
  STREAK_PROGRESS: "streak_progress",
  REWARDS_EDUCATION: "rewards_education",
  STREAKS_EDUCATION: "streaks_education",
  STREAK_PDF: "streak_pdf",
  STREAKS_REALISATION_PAGE: "streaks_realisationpage",
  ENGAGE_V2_COMINGSOON: "engage_v2_comingsoon",
  REWARDS_EXP_2: "rewards_exp_2",
};

export const bkp = () => {
  triggerGa({
    category: GA_CATEGORIES.USER_INTERACTION,
    action: GA_ACTION.EDIT_INFO_CLICK,
    label: GA_LABEL.NEW_TEMPLATE_CLICK,
    // page: pageName,
    // screenName: screenName,
  });
};

export const CHAT_ENTRY_POINTS = {
  DEFAULT: "default",
  HEADER_ROBOT_ICON: "header_robot_icon",
  SHOP_WITH_WISHII: "shop_with_wishii",
  CREATE_DIY: "create_diy",
};

export const PAGE_URLS = {
  SELECT_BY_WISHLINK: "/select-by-wishlink",
  SELECT_BY_WISHLINK_FTUX_V3: "/select-by-wishlink-ftux-v3",
  SELECT_BY_WISHLINK_REWARDS_FTUX: "/select-by-wishlink-rewards-ftux",
  SELECT_BY_WISHLINK_WRAP_FTUX: "/select-by-wishlink-wrap-ftux",
  REWARD_PRODUCTS: "/reward-products/:rewardId",
  WISHLINK_FACEBOOK_EDUCATION: "/wishlink-facebook-education",
  WISHLINK_SHOP_EDUCATION: "/wishlink-shop-education",
  ADJUSTMENT_EDUCATION: "/adjustment-education",
  FLAGGED_CONTENT_EDUCATION: "/flagged-content-education",
  SWITCH_ACCOUNT: "/switch-account",
  MCP_CONSENT: "/mcp-consent",
  COLLAB_HISTORY: "/collab-history",
  PRODUCT_PREVIEW: "/product-preview",
  CHECKOUT_SUCCESS: "/checkout-success",
  PAID_COLLABORATION_CHECKOUT: "/paid-collaboration-checkout/:collabId",
  PAID_COLLABORATION_PRODUCTS: "/paid-collaboration-products/:collabId",
  PAID_COLLABORATION_DETAILS: "/paid-collaboration/:collabId",
  PAID_COLLABORATION_CHAT: "/paid-collaboration-chat/:chatThreadId",
  PAID_COLLABORATION: "/paid-collaboration",
  WISHII: "/wishii",
  WISHII_CHAT: "/wishii/:conversationId",
  SUGGESTED_ACTIONS: "/suggested-actions",
  SOP_CHECKLIST: "/sop-checklist",
  COLLAB_COMMING_SOON: "/collab-comming-soon",
  COLLAGE_CREATION: "/collage-creation",
  COLLAGE_COPY: "/collage-copy",
  COLLAGE_SELECT_IMAGES: "/collage-select-images",
  COLLAGE_SELECT_PRODUCTS: "/collage-select-products",
  CONTENT_INSPIRATION: "/content-inspiration",
  FESTIVE_BANNER_PAGE: "/festive-banner-page",
  CREATOR_CARNIVAL_PAGE: "/creator-carnival-page",
  TOP_ECOMMERCE: "/top-ecommerce",
  BRAND_REWARD_DETAIL: "/brand-reward/:brandId",
  BRAND_REWARD_PRODUCTS: "/brand-reward/:brandId/products",
  BRAND_REWARD_REELS: "/brand-reward/:brandId/reels",
  COMING_SOON_BRAND_DETAIL: "/coming-soon-brand/:brandId",
  COMING_SOON_BRAND_REELS: "/coming-soon-brand/:brandId/reels",
  ONBOARDED_BRAND_DETAIL: "/onboarded-brand/:brandId",
  /** Rewards experiment detail — UX driven by experiment_type (sale vs curated_brands), not path name. */
  BRAND_EXPERIMENT_SALE_DETAIL: "/brand-experiment-sale/:experimentId",
  BRAND_EXPERIMENT_SALE_PRODUCTS: "/brand-experiment/:experimentId/products",
  BRAND_EXPERIMENT_SALE_REELS: "/brand-experiment/:experimentId/reels",
  BRAND_DETAIL: "/brand/:brandId",
  COMING_SOON_BRAND_EXPERIMENT_DETAIL: "/coming-soon/:experimentId",
  ONBOARDED_BRAND_REELS: "/onboarded-brand/:brandId/reels",
  SHOP_BY_CATEGORY: "/shop-by-category/:categoryId",
  HOW_GROW_EARNING: "/how-to-grow-earnings",
  GROWTH_POST_DETAILS: "/growth-post-details/:postId",
  GROWTH: "/growth",
  PRODUCT_GROWTH: "/product-growth",
  PRODUCT_GROWTH_EDUCATION: "/product-growth-education",
  TOP_OFFERS: "/top-offers",
  FESTIVE_DEAL_PRODUCTS: "/festive-deal-products/:collectionId",
  BEAUTY_PRODUCTS: "/beauty-products/:collectionId",
  FESTIVE_DEALS: "/festive-deals",
  BEAUTY_DEALS: "/beauty-deals",
  META_LANDING: "/meta-landing",
  FIRST_LINK_SELECT_BRANDS: "/first-link-select-brands",
  DEFAULT: "/",
  INDEX: "/index.html",
  APPLOGIN: "/app-login",
  SHOP: "/shop",
  THRIFT_ADMIN: "/thrift",
  THRIFT_ADMIN_CONFIG: "/thrift/config",
  THRIFT_ADMIN_UPLOAD: "/thrift/upload",
  THRIFT_ADMIN_PRODUCTS: "/thrift/products",
  NEWPOST: "/new-post",
  EDITPOST: "/edit-post/:postId",
  ADDPRODUCTS: "/post/:postId/add-products",
  PREVIEWLINKS: "/post/:postId/preview-links",
  NEWCOLLECTION: "/new-collection",
  EDITCOLLECTION: "/edit-collection/:collectionId",
  ADDPRODUCTSCOLLECTION: "/collection/:collectionId/add-products",
  PREVIEWLINKSCOLLECTION: "/collection/:collectionId/preview-links",
  PREVIEWPOST: "/post/:postId/preview",
  PREVIEWCOLLECTION: "/collection/:collectionId/preview",
  CHOOSE_REPLY_TYPE: "/post/:postId/choose-reply-type",
  ADD_CUSTOM_LINKS: "/post/:postId/add-custom-links",
  ADD_TEXT_MESSAGE: "/post/:postId/add-text-message",

  ENABLE_CUSTOM_ENGAGE: "/enable-custom-engage",
  SOCIALMEDIALOGIN: "/social-login",
  FIREBASELOGIN: "/login",
  INSTALOGINSUCCESS: "/auth/code",
  YTLOGINSUCCESS: "/youtube-auth",
  FACEBOOKLOGINSUCCESS: "/facebook/callback",
  PINTERESTLOGINSUCCESS: "/pinterest-callback",
  SNAPCHATLOGINSUCCESS: "/snapchat-callback",
  FACEBOOKPAGESELECTION: "/facebook-pages-selection",
  AFFILIATEPRODUCTS: "/new-product",
  BRANDS: "/brands",
  BRANDS_HUB_OPPORTUNITIES: "/brands/opportunities",
  BRANDS_HUB_EXCITING_SALES: "/brands/exciting-sales",
  BRANDS_HUB_FRESH_BRANDS: "/brands/fresh-brands",
  BRANDS_HUB_CONTENT_INSPIRATION: "/brands/content-inspiration",
  BRANDS_HUB_CONTENT_INSPIRATION_REEL:
    "/brands/content-inspiration/reel/:reelId",
  DISCOVER_SEARCH_RESULTS: "/brands/search",
  BRANDS_ALL: "/brands/all",
  CLOTHING: "/brands/:gender",
  PROFILE: "/profile",
  CROSSPOST: "/cross-post",
  SNAPCHAT_CROSSPOST: "/snapchat-crosspost",
  BANKDETAILS: "/bank-details",
  BANKDETAILSVERIFICATION: "/bank-details-verification",
  RAZORPAYVERIFICATION: "/razorpay-verification",
  ANALYTICSHOME: "/analytics-home",
  ANALYTICSDETAIL: "/analytics-detail",
  POSTANALYTICS: "/post/:postId/analytics",
  COLLECTIONANALYTICS: "/collection/:collectionId/analytics",
  PRODUCTANALYTICS: "/product/:productId/analytics",
  HOME: "/home",
  ENGAGE: "/engage",
  ENGAGE_INSTAGRAM: "/engage-instagram",
  ENGAGE_COMMENTS_INBOX: "/engage-comments",
  ENGAGE_FACEBOOK: "/engage-facebook",
  PAYOUTS: "/payout",
  ADMIN: "/creatoradmin",
  CRM_EMBED: "/crm-embed",
  WHY: "/why",
  ENABLEENGAGE: "/enable-wishlink-engage",
  ENGAGE_FTUX: "/engage-ftux",
  ENGAGE_REALISATION_FTUX: "/engage-realisation-ftux",
  COLLAB_FTUX: "/collab-ftux",
  COLLAB_CHAT_FTUX: "/collab-chat-ftux",
  COLLAB_ACCESS_FORM: "/collab-access-form",
  COLLAB_FORM_DETAILS: "/collab-form-details",
  COLLAB_REALISATION_FTUX: "/collab-realisation-ftux",
  REWARDS_FTUX: "/rewards-ftux",
  REWARDS_REALISATION_FTUX: "/rewards-realisation-ftux",
  GROWTH_FTUX: "/growth-ftux",
  GROWTH_REALISATION_FTUX: "/growth-realisation-ftux",
  FACEBOOK_FTUX: "/facebook-ftux",
  FACEBOOK_FTUX_V2: "/facebook-education",
  STREAKS_FTUX: "/streaks-ftux",
  CROSSPOSTING_FTUX: "/crossposting-ftux",
  AUTHSTATUS: "/auth/status?/:token",
  CROSSPOSTAUTHSUCCESS: "/cross-post/auth/status?/:token",
  CROSSPOSTING: "/crossposting",
  CROSSPOSTING_EDUCATION: "/crossposting-education",
  FAQ: "/faq",
  FAQ_ITEM: "/faq/:id",
  FAQ_QUESTION: "/faq/:id/answer/:questionId",
  SOCIAL_LOGIN_SUCCESS: "/social-login-success",
  LOGIN_SUCCESS_INSTAGRAM: "/login-success-instagram",
  LOGIN_SUCCESS_FACEBOOK: "/login-success-facebook",
  LOGIN_SUCCESS_YOUTUBE: "/login-success-youtube",
  ERROR_PAGE: "/validation-error",
  REWARDS: "/rewards/:rewardCampaignId",
  WISHLINK_REWARDS: "/wishlink-rewards",
  WISHLINK_STREAKS: "/wishlink-streaks",
  REWARD_DETAILS: "/wishlink-rewards/:rewardId",
  REWARD_DETAILS_POSTS: "/wishlink-rewards/:rewardId/posts",
  CUMULATIVE_POST_CLICKS_PREVIEW: "/dev/cumulative-post-clicks-preview",
  REWARD_HISTORY: "/reward-history",
  PLAYBOOK: "/playbook",
  PLAYBOOK_MONETIZE: "/playbook-monetize",
  PLAYBOOK_CONTENT: "/playbook-content",
  ORDER_HISTORY: "/order-history",
  ADDRESS: "/address/:id",
  NOTIFICATION: "/notification",
  TNC: "/tnc",
  REFERRAL: "/referral",
  REFER: "/refer/:code",
  WELCOME: "/welcome",
  OTP: "/welcome/otp",
  FAVOURITE_BRANDS: "/favourite-brands",
  REFERRALINPUT: "/referral-input",
  PENDING_COMMISSION: "/pending-commission",
  CONFIRMED_COMMISSION: "/confirmed-commission",
  PAYOUT_ORDER_LEDGER: "/payout-order-ledger",
  CREATOR_OAUTH: "/wishlink-creator-oauth",
  PAYOUT_PRELAUNCH: "/payout-prelaunch",
  NYKAA_REWARDS: "/nykaa-rewards",
  AJIO_REWARDS: "/ajio-rewards",
  MYNTRA_REWARDS: "/myntra-rewards",
  DISCOVER_CONTENT: "/discover-content/:rewardId",
  REWARD_LEADERBOARD: "/leaderboard/:rewardId",
  MONTHLY_ORDER_STATUS: "/monthly-order-status",
  STORY_FRAMES: "/story-frames",
  STORY_FRAME_DETAILS: "/story-frame/:frameId",

  USER_BLOCKED: "/user-blocked",
  WISHLINK_SHOPPING_PAGE: "/wishlink-shopping-insights",
  ANALYTICS: "/analytics",
  ANALYTICS_TNC: "/analytics_tnc",
  PAST_PAYOUTS: "/past-payouts",
  PAST_PAYOUTS_DETAILS: "/past-payouts/:id",
  PAYOUT_STATUS: "/payout-status",
  LEVIED: "/levied",
  ENGAGE_COMMENT: "/engage-comment",
  ENGAGE_SHARE: "/engage-share",
  COPY_LINKS: "/copy-links/:postType/:id",
  // Sourcing Maintenance
  SOURCING_MAINTENANCE: "/sourcing-maintenance",
  // Sourcing
  BRAND_SOURCING: "/brand-sourcing",
  SOURCING: "/sourcing",
  SOURCING_COLLECTION: "/sourcing/collection",
  SOURCING_PRODUCT: "/sourcing/product/",
  SOURCING_PRODUCT_URL: "/sourcing/product/:productId",
  SOURCING_CART: "/sourcing/cart",
  SOURCING_WISHLIST: "/sourcing/wishlist",
  SOURCING_MY_ORDERS: "/sourcing/my-orders",
  SOURCING_PRODUCT_REVIEWS: "/sourcing/product-reviews",
  SOURCING_PRODUCT_REVIEW_FORM: "/sourcing/product-review/:productId",
  SOURCING_MANUAL: "/sourcing/manual",
  SOURCING_MANUAL_ADD: "/sourcing/manual/add",
  BRAND_SOURCING_MANUAL: "/brand-sourcing/manual",
  BRAND_SOURCING_MANUAL_ADD: "/brand-sourcing/manual/add",
  RECOMMENDED_COLLECTIONS: "/recommended-collections",
  WISHLINK_BESTSELLERS: "/wishlink-bestsellers",
  PREVIEWRECOMMENDEDCOLLECTION: "/recommended-collection/:id",
  PREVIEWWISHLINKBESTSELLER: "/wishlink-bestseller/:id",
  SOURCING_NEW_PDP: "/sourcing/product/:productId/c/:collectionId",
  SOURCING_NEW_BARTER_PDP: "/sourcing/product/:productId/b/:collectionId",
  SOURCING_MINI: "/sourcing/mini",
  POST_DETAILS: "/shop-details/:postType/:id",
  SOURCING_ACCESS: "/sourcing-access",
  SOURCING_LOCKED: "/sourcing-locked",
  SOURCING_CREDITS: "/sourcing-credits",
  MINI_SOURCING_ACTIVE_ORDERS: "/mini-sourcing-active-orders",
  MINI_SOURCING_CART: "/mini-sourcing-cart",
  SOURCING_CREDIT_HISTORY: "/sourcing/credit-history",
  SOURCING_COINS: "/sourcing/coins",
  SOURCING_ORDER_CONFIRMATION: "/sourcing/order-confirmation",

  // Brand And Sourcing Unified Endpoint(s) Starts
  BRAND_AND_SOURCING_UNIFIED_MY_ORDERS: "/brand-and-sourcing/my-orders",
  // Brand And Sourcing Unified Endpoint(s) Ends

  // Brand Sourcing Starts
  BRAND_SOURCING_HOME: "/brand-sourcing",
  BRAND_SOURCING_FTUX: "/brand-sourcing/ftux",
  BRAND_SOURCING_GLOBAL_WISHLIST: "/brand-sourcing/wishlist",
  BRAND_SOURCING_BRAND_WISHLIST: "/brand-sourcing/:id/wishlist",
  BRAND_SOURCING_MY_ORDERS: "/brand-sourcing/my-orders",
  BRAND_SOURCING_BRAND_ORDER: "/brand-sourcing/:id/order",
  BRAND_SOURCING_GLOBAL_CART: "/brand-sourcing/cart",
  BRAND_SOURCING_BRAND_CART: "/brand-sourcing/:id/cart",
  BRAND_SOURCING_CREDIT_HISTORY: "/brand-sourcing/credit-history",
  BRAND_SOURCING_ORDER_CONFIRMATION: "/brand-sourcing/order-confirmation",
  BRAND_SOURCING_CART: "/brand-sourcing/:id/cart",
  BRAND_SOURCING_PRODUCT: "/brand-sourcing/product",
  BRAND_SOURCING_PRODUCT_URL: "/brand-sourcing/product/:productId",
  BRAND_SOURCING_NEW_PDP: "/brand-sourcing/product/:productId/c/:collectionId",
  BRAND_SOURCING_COLLECTION: "/brand-sourcing/collection",
  // Brand Sourcing Ends
  ENGAGEDEBUGGER: "/engage-debugger",
  ENGAGE_DIAGONISIS_REPORT: "/engage-diagnosis-report",
  CREATE_DIY: "/create-diy",
  KYC: "/kyc",
  TELEGRAM_LOGIN: "/telegram-login",
  TELEGRAM_WAITLIST: "/telegram-waitlist",
  HAMBURGER_MENU: "/hamburger-menu",
  NEW_LAUNCHES: "/new-launches",
  FESTIVE_RECORD_PAGE: "/festive-record-page",
  BEAUTY_AND_PERSONAL_CARE: "/beauty-personal-care",
  WISHLINK_WRAPPED: "/wishlink-wrapped",
  WISHLINK_WRAPPED_2025: "/wishlink-wrapped-2025",
  AUTO_CONTENT: "/auto-content",
  TEMPLATE_1: "/auto-content/template/1",
  TEMPLATE_2: "/auto-content/template/2",
  WHITELISTINGROUTER: "/whitelisting",
  WHITELISTINGFTUX: "/whitelisting/ftux",
  WHITELISTING: "/whitelisting/home",
  WHITELISTING_ELIGIBILITY_PAGE_URL: "/whitelisting/home/:id",
  CRASH_COURSE: "/crash-course/:id",
  AMAZON_BRAND_ACCESS: "/amazon-brand-access",

  // meesho qr code
  MEESHO_QR_CODE: "/meesho-qr-code",
  WHATS_NEW: "/whats-new",
  WHATS_NEW_DETAILS: "/whats-new/:id",
  SOURCING_FTUX: "/sourcing-ftux",

  // cretor GST details
  CREATOR_GST_DETAILS: "/creator-gst-details",

  // Select by wishlink
  SELECT_BY_WISHLINK: "/select-by-wishlink",

  // Setup Journey
  SETUP_JOURNEY: "/setup-journey",

  // Engage Setup Journey (CXB-2975)
  ENGAGE_SETUP_JOURNEY: "/engage-setup-journey",

  // CXB-3342 — Brand-campaign rejection ("Uh-Oh") full-page screen
  BRAND_CAMPAIGN_UH_OH: "/brand-campaign/uh-oh",

  // Folders
  FOLDERS: "/folders",
  FOLDER_DETAIL: "/folders/:folderId",

  // COC 2026
  COC_LANDING: "/creators-of-change-2026",

  // Streaks
  STREAK_TRACK_PROGRESS: "/wishlink-streaks/:streakId",
  STREAK_LEARN_MORE: "/wishlink-streaks/:streakId/learn-more",
  STREAKS_HOW_IT_WORKS: "/how-it-works",

  // IG Post Product Suggestions
  IG_POST_SUGGESTION: "/ig-suggestions/:shortCode",
};

export const LOGIN_DRAWER_STAGES = {
  CLOSED: "CLOSED",
  ENTER_NUMBER: "ENTER_NUMBER",
  ENTER_OTP: "ENTER_OTP",
  ENTER_REFERRAL_CODE: "ENTER_REFERRAL_CODE",
};

export const SOCIAL_LOGIN_STATES = {
  CONNECT_ACCOUNT: "CONNECT_ACCOUNT",
  ENTER_DETAILS: "ENTER_DETAILS",
};

export const SOCIAL_LOGIN_TYPES = {
  YOUTUBE: "Youtube",
  INSTAGRAM: "Instagram",
  PINTEREST: "Pinterest",
};
export const ENGAGE_VARIANT = {
  ENGAGE_VIA_INSTAGRAM: "ENGAGE_VIA_INSTAGRAM",
  ENGAGE_VIA_FACEBOOK: "ENGAGE_VIA_FACEBOOK",
};

export const CONNECT_SOCIAL_MEDIA_VALUE_PROPS = [
  "Seamlessly link products with any of your content",
  "Provide a personalized shopping experience to your audience",
];

export const CONNECT_TELEGRAM_MEDIA_VALUE_PROPS = [
  "Create affiliate links that you can share to your telegram channel easily",
  "Get access to 250+ brands in Wishlinks",
  "Do not share links created from your social profile on your telegram channel",
];

export const ASSET_COMPONENTS = {
  POLLING_ANIMATION_1: "polling-animation-1.gif",
  POLLING_ANIMATION_2: "polling-animation-2.gif",
  POLLING_ANIMATION_3: "polling-animation-3.gif",
  POLLING_ANIMATION_4: "polling-animation-4.gif",
  POLLING_ANIMATION_5: "polling-animation-5.gif",
  POLLING_ANIMATION_6: "polling-animation-6.gif",
};

// Gumlet CDN prefix for image optimization
// Set REACT_APP_DISABLE_GUMLET=true to bypass Gumlet and serve images directly
export const GUMLET_PREFIX = GUMLET_ENABLED ? GUMLET_PREFIX_URL : "";

export const BUCKET_CDN_PREFIX = "https://cdn-alabaster.wishlink.com/";

/**
 * Strips URL-unsafe characters from a file name so the resulting S3 key
 * and CDN URL stay valid.  Keeps alphanumerics, hyphens, underscores,
 * dots, and spaces (spaces are safe in S3 keys and get encoded by CDN).
 */
export const sanitizeFileName = (name) => {
  if (!name) return name;
  const dotIndex = name.lastIndexOf(".");
  const ext = dotIndex !== -1 ? name.slice(dotIndex) : "";
  const base = dotIndex !== -1 ? name.slice(0, dotIndex) : name;
  const sanitized = base.replace(/[^a-zA-Z0-9\-_ .]/g, "_");
  return `${sanitized}${ext}`;
};

/**
 * Percent-encodes each path segment of an S3 key so that characters like
 * # ? & are safe inside a CDN URL.  Slashes are preserved.
 */
export const encodeCdnKey = (key) => {
  if (!key) return key;
  return key
    .split("/")
    .map((segment) => encodeURIComponent(segment))
    .join("/");
};

// Base CDN paths (without Gumlet prefix - use transformMedia for dynamic URLs)
export const CDN_CREATOR_MASTER =
  "https://cdn-alabaster.wishlink.com/creator-master/";
export const CDN_SOURCING_ASSETS =
  "https://cdn-alabaster.wishlink.com/sourcing_assets/";
export const CDN_FRONTEND_ASSETS =
  "https://cdn-alabaster.wishlink.com/allthingsgood-frontend-assets/";

// Engage and marketing videos on our videos CDN (wishlink-storage-videos, raw/,
// so no HLS). Use them as is: images.wishlink.com cannot serve video, so never
// pass them to transformMedia.
const CDN_RAW_VIDEOS = "https://videos.wishlink.com/raw/creator-media-videos/";
export const ENGAGE_HOW_IT_WORKS_VIDEO = `${CDN_RAW_VIDEOS}07/07f876027e14a1c1ac9e3cf2568d4a6b4761447e2d96a96c84bc89388112f693.mp4`;
export const WHY_WISHLINK_SHOP_UX_VIDEO = `${CDN_RAW_VIDEOS}7e/7e6ae291cd0ce9e3a833361f45547c56f37d7fc81b14a327cea5e7889de528cc.mp4`;
export const CTK_DEMO_VIDEO = `${CDN_RAW_VIDEOS}b8/b8e23455f77c0b39f2f4bd9a823ba2cc6abb85332db55ad81793928382ce9fcd.mp4`;
export const STK_DEMO_VIDEO = `${CDN_RAW_VIDEOS}29/29fb7f4e07bb87236261ee8d32ec472a5bcf5607414a12eb556db3cf53789fdd.mp4`;

// Legacy constants with Gumlet prefix for backward compatibility
// More explicit version (optional)
export const IMAGE_PREFIX = `${CDN_CREATOR_MASTER}`;

export const IMAGE_PREFIX_AZURE =
  "https://prodcdn.wishlink.com/creator-master-assets/";

export const IMAGE_PREFIX_SOURCING_ASSETS = `${CDN_SOURCING_ASSETS}`;

// Social platform configurations for drawers
export const SOCIAL_NOT_CONNECTED_PLATFORM_CONFIG = {
  instagram: {
    icon: `${IMAGE_PREFIX}igNotConnectedIcon.svg`,
    iconBg: "rgba(202, 46, 92, 0.1)",
    title: "Instagram Not Connected",
    description: "Log-in with your Instagram account to create new posts.",
    buttonText: "Continue with Instagram",
  },
  facebook: {
    icon: `${IMAGE_PREFIX}fbNotConnectedIcon.svg`,
    iconBg:
      "linear-gradient(90deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.2) 100%), linear-gradient(90deg, rgba(194, 208, 242, 1) 0%, rgba(194, 208, 242, 1) 100%)",
    title: "Facebook Not Connected",
    description: "Log-in with your Facebook account to create new posts.",
    buttonText: "Continue with Facebook",
  },
  youtube: {
    icon: `${IMAGE_PREFIX}ytNotConnectedIcon.svg`,
    iconBg: "#ffe5e5",
    title: "YouTube Not Connected",
    description: "Log-in with your YouTube account to create new posts.",
    buttonText: "Continue with Youtube",
  },
};

export const SOCIAL_WAITLISTED_PLATFORM_CONFIG = {
  instagram: {
    icon: `${IMAGE_PREFIX}igNotConnectedIcon.svg`,
    iconBg: "rgba(202, 46, 92, 0.1)",
    title: "You're Almost There",
    description: "To create new posts, you need atleast",
    followerLabel: "followers",
    platformLower: "Instagram",
    buttonText: "Reconnect Instagram",
  },
  facebook: {
    icon: `${IMAGE_PREFIX}fbNotConnectedIcon.svg`,
    iconBg:
      "linear-gradient(90deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.2) 100%), linear-gradient(90deg, rgba(194, 208, 242, 1) 0%, rgba(194, 208, 242, 1) 100%)",
    title: "You're Almost There",
    description: "To create new posts, you need atleast",
    followerLabel: "followers",
    platformLower: "Facebook",
    buttonText: "Reconnect Facebook",
  },
  youtube: {
    icon: `${IMAGE_PREFIX}ytNotConnectedIcon.svg`,
    iconBg: "#ffe5e5",
    title: "You're Almost There",
    description: "To create new posts, you need atleast",
    followerLabel: "subscribers",
    platformLower: "YouTube",
    buttonText: "Reconnect Youtube",
  },
};

export const DEFAULT_MIN_FOLLOWERS = {
  instagram: "1000",
  facebook: "500",
  youtube: "500",
};

export const pollingAnimations = {
  0: {
    animationUrl: ASSET_COMPONENTS.POLLING_ANIMATION_1,
    title:
      "Provide details on 'how to find links' to your audience in your post caption",
  },
  1: {
    animationUrl: ASSET_COMPONENTS.POLLING_ANIMATION_2,
    title:
      "Share regular stories with product wishlinks to drive maximum sales",
  },
  2: {
    animationUrl: ASSET_COMPONENTS.POLLING_ANIMATION_3,
    title: "Know your audience and what products & outfits they want to see",
  },
  3: {
    animationUrl: ASSET_COMPONENTS.POLLING_ANIMATION_4,
    title: "Run a series of content on products your audience is interested in",
  },
  4: {
    animationUrl: ASSET_COMPONENTS.POLLING_ANIMATION_5,
    title:
      "Frequently share collections in your stories to help your audience shop during sale periods",
  },
  5: {
    animationUrl: ASSET_COMPONENTS.POLLING_ANIMATION_6,
    title: "Follow connect.wishlink for regular updates, tips and tricks",
  },
};

export const USERNAME_STATES = {
  DEFAULT: "default",
  EDITED: "edited",
  FAILED: "failed",
};

export const SOCIAL_POST_TYPES = {
  REEL: "reel",
  SHORTS: "shorts",
  YOUTUBE_VIDEO: "youtube_video",
  INSTAGRAM_POST: "instagram_post",
};

export const gender_values = [
  {
    id: 1,
    label: "Male",
    value: "MALE",
  },
  {
    id: 2,
    label: "Female",
    value: "FEMALE",
  },
  {
    id: 3,
    label: "Prefer not to say",
    value: "OTHERS",
  },
];

export const cover_pic_crop = {
  height: 28.88888888889,
  unit: "px",
  width: 100,
  x: 50,
  y: 50,
};

export const profile_pic_crop = {
  height: 100,
  unit: "px",
  width: 100,
  x: 50,
  y: 50,
};

export const DEFAULT_KEYWORDS_CTK = ["wishlink", "link", "pp", "price", "dm"];

export const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const DATE_PRESETS = {
  THIS_MONTH: "This Month",
  LAST_2_MONTHS: "Last 2 Months",
  LAST_3_MONTHS: "Last 3 Months",
  LAST_6_MONTHS: "Last 6 Months",
  ALL_TIME: "All Time",
  TODAY: "Today",
  YESTERDAY: "Yesterday",
  LAST_7_DAYS: "Last 7 days",
  LAST_MONTH: "Last month",
  LAST_TO_LAST_MONTH: MONTHS[new Date().getMonth() - 2],
};

export const CALENDAR_ALLOWED_PRESETS = [
  DATE_PRESETS.TODAY,
  DATE_PRESETS.YESTERDAY,
  DATE_PRESETS.LAST_7_DAYS,
  DATE_PRESETS.THIS_MONTH,
  DATE_PRESETS.LAST_MONTH,
  DATE_PRESETS.ALL_TIME,
];

export const CALENDAR_PRESETS = [
  DATE_PRESETS.TODAY,
  DATE_PRESETS.YESTERDAY,
  DATE_PRESETS.LAST_7_DAYS,
  DATE_PRESETS.THIS_MONTH,
  DATE_PRESETS.LAST_MONTH,
  DATE_PRESETS.LAST_6_MONTHS,
  DATE_PRESETS.ALL_TIME,
];

export const DROPDOWN_ALLOWED_PRESETS = [
  DATE_PRESETS.THIS_MONTH,
  DATE_PRESETS.LAST_MONTH,
  DATE_PRESETS.LAST_3_MONTHS,
  DATE_PRESETS.ALL_TIME,
  DATE_PRESETS.LAST_TO_LAST_MONTH,
];

export const VIEW_PRESETS_ENUM = {
  VIEW_ALL: "View All",
  SHOW_HIDDEN: "Show Hidden Only",
  HIDE_HIDDEN: "Show All Except Hidden",
};

export const VIEW_PRESETS = [
  { label: "View All", value: VIEW_PRESETS_ENUM.VIEW_ALL, dataCy: "view-all" },
  {
    label: "Show Hidden Only",
    value: VIEW_PRESETS_ENUM.SHOW_HIDDEN,
    dataCy: "hidden-only",
  },
  {
    label: "Show All Except Hidden",
    value: VIEW_PRESETS_ENUM.HIDE_HIDDEN,
    dataCy: "except-hidden",
  },
];

export const BENEFITS = [
  {
    icon: "personal-shop.png",
    title: "Your personalized",
    subtitle: "shop",
    subtext: "Link products to every",
    subtext2: "post and video",
  },
  {
    icon: "recommendations.png",
    title: "Curate your favv",
    subtitle: "products",
    subtext: "Recommend products you",
    subtext2: "love via your shop",
  },
  {
    icon: "organic-content.png",
    title: "Monetize 100% of",
    subtitle: "your content",
    subtext: "Earn from your",
    subtext2: "favorite brands",
  },
  {
    icon: "realtime-view.png",
    title: "Real time data",
    subtitle: "and analytics",
    subtext: "Track your earnings",
    subtext2: "and gain insights",
  },
];

export const commissions = [
  {
    icon: "camera.svg",
    text: "Curate products from any Wishlink partner brand",
  },
  {
    icon: "thumbsup.svg",
    text: "Link the products on your Wishlink Shop",
  },
  {
    icon: "forward.svg",
    text: "Share Wishlinks with your audience",
  },
  {
    icon: "money.svg",
    text: "Earn commissions on every purchase they make",
  },
];

export const ENABLE_ENGAGE = [
  {
    icon: "clock.svg",
    text: `Save hours replying to "link" comments`,
    color: "#9E71D0",
  },
  {
    icon: "boost.svg",
    text: "Boost engagement rates",
    color: "#FF2F32",
  },
  {
    icon: "delight.svg",
    text: "Delight your followers",
    color: "#EEB665",
  },
  {
    icon: "channel.svg",
    text: "New channel for earnings",
    color: "#5345FD",
  },
];

export const ENGAGE_WORKING = [
  "Your audience asks for the product links in comments e.g. pp, link please",
  "Engage will automatically send DMs with the exact product links",
  "Your followers can easily click and shop their favourite products",
  "You earn commissions on every purchase",
];

export const hamburgerItems = [
  {
    id: "your-profile",
    title: "Your Profile",
    description: "Add your details, social links & bank account information",
    redirectUrl: "/profile",
    gaLabel: GA_LABEL.PROFILE,
    showNewIcon: false,
    hideForTelegram: false,
    icon: "fa-solid fa-user",
    backgroundColor: "#FFDFDA",
    color: "#E03D39",
  },
  {
    id: "select-by-wishlink",
    title: "Seleqt By Wishlink",
    description: "Wishlink's fashion-forward online shopping platform.",
    redirectUrl: PAGE_URLS.SELECT_BY_WISHLINK_FTUX_V3,
    gaLabel: GA_LABEL.SELECT_BY_WISHLINK,
    showNewIcon: true,
    hideForTelegram: true,
    icon: "fa-solid fa-shop",
    imageIcon: "Seleqt_S_Orange.svg",
    backgroundColor: "#F2D9D9",
    color: "#BD3F43",
  },
  {
    id: "refer-and-win",
    title: "Refer & Win",
    description: "Win upto ₹10,000 on each referral",
    redirectUrl: "/referral",
    showNewIcon: false,
    showEndingSoonIcon: true,
    gaLabel: GA_LABEL.REFERRAL,
    showAfterFirstSale: true,
    hideForTelegram: true,
    icon: "fa-solid fa-user-group",
    backgroundColor: "#FFF6DB",
    color: "#F9CF4C",
  },
  // {
  //   title: "Brands",
  //   description: "Discover all brands on Wishlink",
  //   redirectUrl: "/referral",
  //   showNewIcon: true,
  //   gaLabel: GA_LABEL.REFERRAL,
  //   showAfterFirstSale: true,
  //   hideForTelegram: true,
  //   icon: "fa-brands fa-shopify",
  //   backgroundColor: "#FFDFDA",
  //   color: "#E03D39",
  // },
  {
    id: "wishlink-engage",
    title: "Wishlink Engage",
    description: "Send Auto DMs for your product links",
    redirectUrl: PAGE_URLS.ENGAGE_FTUX,
    gaLabel: GA_LABEL.ENGAGE_PROPS,
    showNewIcon: true,
    hideForTelegram: true,
    icon: "fa-solid fa-link",
    backgroundColor: "#EED9FF",
    color: "#772DB2",
  },
  {
    id: "crossposting",
    title: "Crossposting",
    description: "Share your Wishlink posts to other platforms",
    redirectUrl: PAGE_URLS.CROSSPOSTING,
    gaLabel: GA_LABEL.CROSSPOSTING,
    showNewIcon: true,
    hideForTelegram: true,
    icon: "fa-solid fa-link",
    imageIcon: "cross_posting.png",
    imageIconSize: 30,
    backgroundColor: "#F5F5F5",
    color: "#144cc7",
  },
  // {
  //   title: "Brand Collab",
  //   description: "Get to collab from your favourite brands",
  //   redirectUrl: "/referral",
  //   showNewIcon: true,
  //   gaLabel: GA_LABEL.REFERRAL,
  //   showAfterFirstSale: true,
  //   hideForTelegram: true,
  //   icon: "fa-solid fa-handshake-simple",
  //   backgroundColor: "#C8E565",
  //   color: "#0E1226",
  // },
  // {
  //   title: "Sourcing",
  //   description:
  //     "Get sourcing coins and source products from us to shoot more content",
  //   redirectUrl: "/referral",
  //   showNewIcon: true,
  //   gaLabel: GA_LABEL.REFERRAL,
  //   showAfterFirstSale: true,
  //   hideForTelegram: true,
  //   icon: "fa-solid fa-landmark",
  //   backgroundColor: "#FBFFEA",
  //   color: "#B2CE3C",
  // },
  // {
  //   title: "More about Wishlink",
  //   description: "Get to know Wishlink better",
  //   redirectUrl: "/referral",
  //   showNewIcon: true,
  //   gaLabel: GA_LABEL.REFERRAL,
  //   showAfterFirstSale: true,
  //   hideForTelegram: true,
  //   icon: "fa-solid fa-building",
  //   backgroundColor: "#FFE7E3",
  //   color: "#DF472C",
  // },
  {
    id: "whitelisting",
    title: "Whitelisting",
    description: "Order and return with ease",
    redirectUrl: PAGE_URLS.WHITELISTING,
    // gaLabel: GA_LABEL.ENGAGE_PROPS,
    showNewIcon: true,
    hideForTelegram: true,
    icon: "fa-solid fa-certificate",
    backgroundColor: "#FFFBD6",
    color: "#FFEB34",
  },
  {
    id: "payout",
    title: "Payout",
    description: "Manage your Wishlink earnings",
    redirectUrl: "/analytics#Payouts",
    gaLabel: GA_LABEL.ANALYTICS + "#Payouts",
    showNewIcon: false,
    hideForTelegram: false,
    icon: "fa-solid fa-money-bill",
    backgroundColor: "#C8E565",
    color: "#3D3D3D",
  },
  {
    id: "faqs-and-support",
    title: "Faqs and Support",
    description: "Need help? We've got answers",
    redirectUrl: "/faq",
    gaLabel: GA_LABEL.HELP,
    showNewIcon: false,
    hideForTelegram: false,
    icon: "fa-solid fa-headset",
    backgroundColor: "#C2D0F2",
    color: "#144CC7",
  },
];

export const HOME_LINKS = [
  {
    icon: `${IMAGE_PREFIX}profile-milestone.png`,
    text: `Social Login`,
    description: `Connect your Instagram or YouTube channel for a personalized experience`,
    redirect_url: `/social-login`,
    flag: "SOCIAL_LOGIN",
    showPulse: true,
  },
  {
    icon: `${IMAGE_PREFIX}posts-icon.svg`,
    text: `Create your first Wishlink Post`,
    description: `Tag your product links with your content and start earning`,
    redirect_url: `/new-post#instagram`,
    flag: "FIRST_POST",
    showPulse: true,
  },
  {
    icon: `${IMAGE_PREFIX}myntra-logo-2-small.png`,
    text: `Earn from existing content`,
    description: `Share Wishlinks of top brands like H&M, Urbanic, Myntra, Meesho and more!`,
    redirect_url: `/shop`,
    flag: "FIRST_SALE",
    showPulse: false,
  },
  {
    icon: `${IMAGE_PREFIX}rupee-black.svg`,
    text: `Earn Rs. 2,000 via Wishlink`,
    description: `To unlock Rewards and Leaderboard`,
    redirect_url: `/analytics`,
    flag: "EARNINGS_CROSS_2K",
    showProgressBar: true,
    status: null,
    showPulse: false,
  },
  {
    icon: `${IMAGE_PREFIX}shopping-black-icon.svg`,
    text: `Create a collection`,
    description: `Curate collections of your favourite products for your audience`,
    redirect_url: `/new-collection`,
    flag: "FIRST_COLLECTION",
    showPulse: false,
  },
  {
    icon: `${IMAGE_PREFIX}profile-completion-todo.svg`,
    text: `Add your gender, email and bank details for monthly payouts`,
    description: `Please provide your bank details for smooth payouts`,
    redirect_url: `/profile`,
    flag: "PROFILE_COMPLETED",
    showPulse: false,
  },
];

export const FTUX_DISMISSED_SESSION_KEY = "ftux_home_takeover_dismissed";

export const HOME_PAGE_BANNERS = [
  {
    banner_header_icon: `${IMAGE_PREFIX}wl-logo-white.svg`,
    banner_header_text: `Maximize earnings`,
    banner_image_url: `${IMAGE_PREFIX}earnings-max.png`,
    banner_redirect_url: PAGE_URLS.PLAYBOOK,
    banner_text: `Want to make more money from the products you recommend?`,
    banner_button_text: `Learn How`,
    open_in_same_page: true,
    ga_label: GA_LABEL.PLAYBOOK,
  },
  {
    banner_header_icon: `${IMAGE_PREFIX}instagram-icon-white.svg`,
    banner_header_text: `Wishlink Engage`,
    banner_image_url: `${IMAGE_PREFIX}engage.png`,
    banner_redirect_url: PAGE_URLS.ENABLEENGAGE,
    banner_text: `Automatically respond to comments asking for product links. Boost your Instagram Engagement & Earnings!`,
    banner_button_text: `Know more`,
    open_in_same_page: true,
    ga_label: GA_LABEL.ENGAGE_PROPS,
  },
  {
    banner_header_icon: `${IMAGE_PREFIX}shop-white.svg`,
    banner_header_text: `My Shop`,
    banner_image_url: `${IMAGE_PREFIX}shop.png`,
    banner_redirect_url: PAGE_URLS.WHY,
    banner_text: `Learn the benefits of having your own Wishlink Shop and how it works!`,
    banner_button_text: `Know more`,
    open_in_same_page: true,
    ga_label: GA_LABEL.SHOP_PROPS,
  },
];

export const POST_TYPES = {
  INSTA_REEL: "insta_reel",
  INSTA_IMAGE: "insta_image",
  INSTA_ALL: "insta_all",
  INSTA_STORY: "insta_story",
  YT_VIDEO: "yt_video",
  YT_SHORTS: "yt_shorts",
  YT_ALL: "yt_all",
  FB_VIDEO: "fb_video",
  FB_REEL: "fb_reel",
  FB_IMAGE: "fb_image",
  FB_ALL: "fb_all",
};

export const TDS_PERCENTAGE_OLD = 10;
export const TDS_PERCENTAGE_NEW = 5;
export const NEW_TDS_START_DATE = new Date("2024-07-01");

export const TELEGRAM_FAQS = [
  {
    title: "How can I get my Telegram channel bot token?",
    answer:
      "Watch this video to understand how you can get your public channel invite link and bot token to connect your channel to Wishlink. Please ensure you are an admin of the channel you are trying to connect",
    video_url: "https://youtu.be/AceyQaO0a28",
  },
  {
    title: "How to connect a private Telegram channel to Wishlink?",
    answer:
      "In order to connect your private channel to Wishlink, you need to enter the Chat ID and bot token of your channel. Watch this video to understand how you can get these details. Please ensure you are an admin of the channel you're trying to connect",
    video_url: "https://youtu.be/I_EmO42jBP8",
  },
];

export const FAQS = [
  {
    id: 1,
    gaLabel: "workingwithwishlink",
    title: "Working with Wishlink",
    icon: "faq/working-with-wishlink.png",
    text: "General guidelines, eligibility criteria",
    showOnSourcingHowToWork: false,
    children: [
      {
        question: "What is Wishlink, and how can I earn with Wishlink?",
        answer: `<div>Wishlink allows you to partner with your favourite brands and share their product links</div><br /><div>You earn a commission for every successful order through your shared wishlinks. Monetize all your content and make money while doing what you love!</div><br /><div>Learn more about commissions <a href="/faq/2">here</a></div>`,
      },
      {
        question: "Who can use Wishlink? Any eligibility criteria?",
        answer:
          "<div><div>Wishlink is open to all content creators promoting products they genuinely love</div><br /><div>Nevertheless, there are some requirements:</div><ul className='faq'><li>Instagram: Minimum 2,000 followers and Creator / Business Account</li><li>YouTube: At least 500 subscribers</li></ul></div>",
      },
      {
        question: "How can my audience find product links on my WIshlink?",
        answer:
          "<div>Instagram:</div><ul className='faq'><li>Share wishlinks in stories and highlights</li><li>Automatically respond to comments requesting product links via Wishlink Engage. Learn more <a href='/enable-wishlink-engage'>here</a></li><li>Add your Wishlink shop link in bio</li><li>Create a channel and share wishlinks</li></ul><br /><div>YouTube:</div><ul className='faq'><li>Add Wishlinks in Video Descriptions</li><li>Use Pinned comments for Shorts</li><li>Share Wishlinks with community posts</li></ul>",
      },
      {
        question: "What brands can I work with via Wishlink?",
        answer:
          "<div>On Wishlink, you have the freedom to recommend products from any brand.</div><br /><div>We have partnered with the most popular fashion and beauty brands to offer you a diverse selection to earn from</div><br /><div>Explore our partner brands <a href='/brands'>here</a></div>",
      },
      {
        question: "Does Wishlink charge a commission or fee for its services?",
        answer:
          "<div> No, Wishlink does not charge anything. The commissions are passed on to you directly from the brands. Our mission is to make content creation more sustainable for creators.</div>",
      },
    ],
  },
  {
    id: 2,
    gaLabel: "commissions",
    title: "Commissions",
    icon: "faq/creating-wishlinks.svg",
    text: "Learn how commissions work",
    showOnSourcingHowToWork: false,
    children: [
      {
        question: "How do I earn commissions via Wishlink?",
        answer:
          "<div>If a user clicks on your wishlink (from anywhere on Instagram, YouTube, WhatsApp, Telegram, etc.) and successfully orders anything from that website - you get a commission. Simple!</div>",
      },
      {
        question: "How much commission do I get on each brand?",
        answer:
          "<div>The commission percentages vary from brand to brand</div><br /><div>Explore our partner brands & commissions <a href='/brands'>here</a></div>",
      },
      {
        question: "Do I earn commissions on every purchase?",
        answer:
          "<div>You get commissions on 98% of your successful orders. The rare misses include:</div><ul className='faq'><li>Purchases made post 1 day of clicking your links. This is upto 14 days for some brands like H&M, Snitch, Urbanic, Libas, Aurelia etc</li><li>The user clicked on some ad from the same brand</li><li>The user has privacy settings or ad blockers enabled</li></ul>",
      },
      {
        question:
          "What are ordered, returned and net commissions and sales value?",
        answer:
          "<div>Ordered commissions are real-time commissions which get tracked at the time the user makes the purchase</div><br /><div>Returned commissions are deductions in ordered commissions when a user cancels or returns the order</div><br /><div>Net commissions are the total commissions you earn on your successful orders</div><br />Net Commissions = Ordered Commissions - Returned Commissions",
      },
      {
        question: "When are returned orders updated on your dashboard?",
        answer:
          "<div>Wishlink receives returns/cancellations data within 30-45 days of order date from our partner brands</div><br /><div>The data is updated immediately and visible on your dashboard on the date the data is received from the brands</div>",
      },
      {
        question: "Are sales updated in my dashboard real-time?",
        answer:
          "<div>The sales are instantly reflected for most of our partner brands. However, there are some exceptions:</div><br /><div>H&M, Urbanic - 3-6 hours</div><br /><div>Amazon - Once the product is shipped (24-72 hours usually)</div>",
      },
      {
        question: "Why are Amazon earnings displayed separately?",
        answer:
          "<div>We don't get earnings data on individual content for amazon products. You can contact us to get product level data for Amazon</div><br /><div>Moreover, you can view your Amazon commissions for any given time period in Detailed Analytics</div>",
      },
    ],
  },
  {
    id: 3,
    gaLabel: "partnerbrands",
    title: "Partner Brands",
    icon: "faq/partner-brands.png",
    text: "Discover brands, recommend products",
    showOnSourcingHowToWork: false,
    children: [
      {
        question:
          "What all brands has Wishlink partnered with? Are all brands open to all creators?",
        answer:
          "<div>We have partnered with the most popular fashion and beauty brands and you can share wishlinks of any of our partner brands to earn commissions</div><br /><div>Explore our partner brands <a href='/brands'>here</a></div>",
      },
      {
        question: "How much commission do I get on each brand?",
        answer:
          "<div>The commission percentages vary from brand to brand</div><br /><div>Explore our partner brands and commissions <a href='/brands'>here</a></div>",
      },
      {
        question:
          "Does Wishlink help me identify what brands will work for me?",
        answer:
          "<div>Absolutely yes. Wishlink gathers a lot of data through creator as well as brand insights and then our exclusive AI algorithm recommends you the brands most suited for your growth</div>",
      },
      {
        question:
          "Can I create links for brands that are not partnered with Wishlinks?",
        answer:
          "<div>Yes, your audience can click on your non-partner brand wislinks to visit their website. However, you won't earn any commissions</div><br /><div>If you want to earn commissions from those posts as well, feature similar products from partner brands</div>",
      },
      {
        question: "Can I know what brands are runnling sales in advance?",
        answer:
          '<div>Yes, go to "Brands by Category" page and apply the "On Sale" filter</div><br /><div>Wishlink also promotes popular sales on your brands page and also through WhatsApp for your convenience</div>',
      },
    ],
  },
  {
    id: 4,
    gaLabel: "myshop",
    title: "My Shop",
    icon: "faq/my-shop.svg",
    text: "Add a new post, create Wishlinks, etc",
    showOnSourcingHowToWork: false,
    children: [
      {
        question: "How do I set up my shop on Wishlink?",
        answer:
          "<div>To set up your shop, simply log in with your Instagram or YouTube account.</div><br /><div>Make sure to add some posts to your shop before sharing it with your audience</div>",
      },
      {
        question:
          "What is the difference between a post, collection and a single product link?",
        answer:
          "<div>A post is used to tag products with your social media content, allowing users to easily discover and purchase those products.</div><br /><div>A collection is a curated set of recommendations that you can share with your audience, even without creating specific content.</div><br /><div>A single product link is a quick way to share a specific product recommendation when you're short on time or don't have a dedicated post or collection</div>",
      },
      {
        question:
          "What is the difference between a Post Wishlink and a Product Wishlink?",
        answer:
          "<div>Post Wishlink: sends the user to your Wishlink Shop, where they can see all the products tagged and looks like: wishlink.com/username/post/123</div><br /><div>Product Wishlink: sends the user directly to the brand's website and looks like: wishlink.com/share/ABC</div><br /><div>By sharing more product wishlinks, you can drive more users to the brand's website, increasing your earning potential</div>",
      },
      {
        question: "How can I add, hide, or edit a post/collection on my shop?",
        answer:
          "<div>To add a post or collection, simply click on the create icon and select the desired option. Then, follow two easy steps:</div><ul className='faq'><li>Add post/collection details</li><li>Add product links to be tagged</li></ul><br /><div>For editing or hiding, click on the respective post or collection in your Shop, click on the three dots at the top right corner and choose the relevant option</div>",
      },
      {
        question:
          "How long will my wishlinks work for? Is there a limit to number of wishlinks I can create?",
        answer:
          "<div>Your Wishlinks will continue to work indefinitely unless the product goes out of stock or the brand removes our tracking without prior notice</div><br /><div>There is no limit to the number of Wishlinks you can create, allowing you to earn passively from your shared wishlinks</div>",
      },
      {
        question:
          "Can I create Wishlinks for products without linking them to any post?",
        answer:
          "<div>Yes, you can do this by:</div><ul className='faq'><li>Creating a single product Wishlink</li><li>Curating a collection of your favorite products</li></ul>",
      },
      {
        question: "Why does it show 0% commission on some brands?",
        answer:
          "<div>You earn commissions exclusively through our partner brands. Check them <a href='/brands'>here</a></div><br /><div>Want us to partner with your favorite brand? Submit <a href='#feedback'>here</a></div>",
      },
      {
        question: "Why do I see some products as faded in the preview page?",
        answer:
          "<div>Those products may not have been tagged correctly to your Wishlink. Please retry after checking the link.</div><br /><div>If you continue to face such issues, let us know!</div>",
      },
    ],
  },
  {
    id: 5,
    gaLabel: "analyticspayouts",
    title: "Analytics / Payouts",
    icon: "faq/analytics-earnings.svg",
    text: "Track your earnings and payouts",
    showOnSourcingHowToWork: false,
    children: [
      {
        question:
          "Insights: What are ordered commissions, amount, link clicks, orders placed and average order value?",
        answer:
          "<div>Ordered amount: Sum total amount of orders placed via your Wishlinks.</div><br /><div>Ordered Commissions: Commissions at the time orders are placed. Final commissions may differ once order status is confirmed by brands</div><br /><div>Link Clicks: Number of clicks on your Wishlinks to visit the brand's website</div><br /><div>Orders placed: Number of orders placed after clicking on your Wishlinks</div><br /><div>Average order value: Average amount of order placed after clicking your wishlinks. Each brand will have a different A.O.V.</div>",
      },
      {
        question: "What are Pending Commissions and Confirmed Commissions?",
        answer:
          "Pending Commissions: Commissions on orders placed but not confirmed by the brand. These are pending because users can still cancel or return the product(s)<br />Confirmed commissions: Commissions on orders confirmed by the brand, after deducting cancellations and returns",
        showOnPayouts: true,
      },
      {
        question: "How is my payout calculated?",
        answer:
          "Your payout in a month will include all the commissions which get confirmed by the brand in that month and any earnings via rewards and referral. <br/> <br/> The confirmed commissions are commissions on final order amount once cancellations and returns have been deducted",
        showOnPayouts: true,
      },
      {
        question: "When will my pending orders be confirmed for payout?",
        answer:
          "Each brand has a different confirmation time ranging from minimum one month to a few months.<br/> <br/>For example, if a brand has confirmation time of 45-60 days, its orders placed in current month will get confirmed between 15th to 30th of the next month. <br/> <br/>  You can see confirmation time of your brands by clicking on the Pending Commissions card in Payouts. The actual confirmation timeof a brand may vary",
        showOnPayouts: true,
      },
      {
        question: "What is Wishlink's payouts policy?",
        answer: `<div>Payouts are processed before 10th of the following month into the bank account linked to your profile.</div><br /><div>A 2% TDS is deducted on your total earnings from Commission and 10% on your earnings from Rewards and Paid Collaboration and this will be reflected on your dashboard.</div><br /><div>If you want to claim GST, let us know <a href='https://forms.gle/1MjL3Ri3cKDKCjUX8?wishlink_external=true' target='__blank'>here</a></div>`,
      },
      {
        question: "What are potential returns and actual returns?",
        answer:
          "Potential returns: Typical return percentage of the brand basis historical data<br/>Actual returns: Actual cancellations & return percentage on the orders placed via your Wishlinks</>",
        showOnPayouts: true,
      },
      {
        question: "How can I maximize my earnings with Wishlink?",
        answer:
          "<div>Share your Wishlinks everywhere!</div><br /><div>Learn the best tips and triks to maximize your Wishlink earnings <a href='/playbook'>here</a></div>",
      },
      {
        question: "How can I report a payment-related issue?",
        answer:
          "<div>Please connect with your Wishlink manager or contact us on WhatsApp to report any payment related issue</div>",
      },
      {
        question: "What happens to payouts for copied content?",
        answer: `Maintaining authenticity is crucial for Wishlink. Creators found copying others on Instagram or posting copied content will have their payouts withheld. Copying content undermines trust and violates our ethical guidelines. We encourage you to focus on creating original, authentic content to grow and earn sustainably. For any questions, feel free to contact our support team. Let's grow together with integrity!`,
        showOnPayouts: true,
      },
    ],
  },
  {
    id: 6,
    gaLabel: "sourcing",
    title: "Sourcing",
    icon: "faq/sourcing.png",
    showOnSourcingHowToWork: false,
    text: "Source products for your content",
    children: [
      {
        question: "What is Wishlink Sourcing?",
        answer:
          "<div>Wishlink Sourcing is a personalized platform where you can source products hassle-free for creating your content on a returnable basis.</div>",
      },
      {
        question: "What are Wishlink Sourcing guidelines?",
        answer:
          "<div>Ordering with Wishlink Sourcing is a breeze! Simply source products from our website, create your content and return the items within return deadlines. Don't forget to share links of sourced product in your content.</div><br/><div>Connect with your Wishlink Manager for more details.</div>",
      },
      {
        question: "How does Wishlink source products?",
        answer:
          "<div>With Wishlink you can place your order requests and then our team will communicate those orders with the respective brands. Usually takes 2-3 days to place orders with brands once we receive your requests.</div>",
      },
      {
        question: "How do sourcings credit work?",
        answer:
          "<div>Our exclusive AI algorithm sets a monthly sourcing limit for all creators.</div><br/><div>This limit is determined based on two main factors: your past Wishlink earnings and the percentage of sourced products that you incorporate into your content.</div> <br/><div>Reach out to your Wishlink manager for more details.</div>",
      },
      {
        question: "When am I eligible for sourcing?",
        answer:
          "<div>Sourcing is exclusive to our top performing creators. Our team will reach out to you once you become eligible.</div>",
      },
      {
        question: "Why am I seeing only limited brands?",
        answer:
          "<div>Wishlink sourcing is a personalised platform. Our AI recommends brands that your audience loves and buys from. See any brand you think your audience will love? Please fill the feedback form here.</div>",
      },
      {
        question: "Can I source products outside Wishlink platform?",
        answer:
          "<div>Wishlink can only source products for you available on your sourcing platform.</div>",
      },
      {
        question: "Why don't I see all the products from my favourite brand?",
        answer:
          "<div>The listed products are trending products (or) products with high stock with the brand. This is to ensure that the items featured in your content don't go out of stock when your content is published and also gets maximum sales</div>",
      },
      {
        question: "Why can't I source anymore? ",
        answer:
          "<div>Unfortunately, your sourcing access has been revoked.</div>",
      },
      {
        question: "When will I get sourcing back?",
        answer:
          "<div>Wishlink Sourcing access gets revoked if you don't post content from the sourced products or drive no/minimum sales from them. Or you haven't returned products in the past.<div><br/><div>To get your Sourcing access back; make sure you post all the content from Sourced products as well as try to sell and earn more</div>",
      },
      {
        question: "When will my order be delivered?",
        answer:
          "<div>You can check the estimated delivery date of your orders on your order page.</div> <br/><div>In case your items haven't been delivered 2-3 days after your estimated delivery date, please contact your Wishlink Manager.</div>",
      },
      {
        question: "Where can I track my orders?",
        answer:
          "<div>You can check the status of your orders on your order page. Unfortunately, currently you can't track your orders with Wishlink</div>",
      },
      {
        question: "Why was my order cancelled?",
        answer:
          "<div>Your order might be cancelled for one of these two reasons- either the product in your size is now out of stock or the brand removed the product from their catalogue.</div>",
      },
      {
        question: "What is the return policy of products?",
        answer:
          "<div>You have 15 days to create content and return the items sourced</div>",
      },
      {
        question: "Can I keep products on barter?",
        answer:
          "<div>Products sourced through Wishlink cannot be kept on barter. You can only keep products on barter which are eligible for barter. We appreciate your cooperation.</div>",
      },
    ],
  },
  {
    id: 7,
    gaLabel: "engage",
    title: "Wishlink Engage",
    icon: "faq/engage-faq.svg",
    showOnSourcingHowToWork: false,
    text: "Improve engagement rate and earnings",
    children: [
      {
        question: "What is Wishlink Engage?",
        answer:
          "<div>Engage, developed in collab with Meta, helps you improve your instagram engagement & earnings by automatically responding to comments asking for product links via DM.</div><br /><div>It allows you to build an amazing loyalty with your audience, because you are giving them what they want - LINKs!</div>",
      },
      {
        question:
          "How do I activate Wishlink Engage? (What are the pre requisites to enable engage?)",
        answer:
          "<div>Engage can be set up in 4 easy steps:</div><ul className='faq'><li>Make sure your Instagram account is connected to a Facebook page. <a href='https://help.instagram.com/570895513091465/'>Learn How</a></li><li>In your Instagram app, go to Privacy > Messages and allow access to messages</li><li>Click on Enable Wishlink Engage and provide us the required permissions</li><li>Set up multiple reply templates and keywords on which the DMs are sent</li></ul><br /><div>Don't forget to add #wishlinked to every post and add all your posts on your Shop with the recommended products</div>",
      },
      {
        question:
          "What will be sent in the DM? What will be the reply in comments?",
        answer:
          "<div>DMs - all products tagged to that post/reel in a carousel format</div><br /><div>Comments - randomly selected template from all the customised templates you set</div>",
      },
      {
        question: "What are the limitations of Wishlink Engage by Instagram?",
        answer:
          "<div>Engage works within Meta's limits: 40 comments and 750 DMs per hour. DMs are sent instantly, while comments are sent slowly and sequentially.</div><br /><div>If the limit is reached, Engage enters a 15-minute cooldown and queues incoming comments</div>",
      },
      {
        question:
          "Will Wishlink have access to all of my direct messages, and how will I know which comments have been replied to?",
        answer:
          "<div>No, Wishlink does not have access to any of your messages.</div><br /><div>Engage will only respond to comments that contain the trigger keywords set by you, like link please, details please, order, etc.</div>",
      },
      {
        question: "What if I don't have an active facebook account?",
        answer:
          "<div>it is mandatory to have a Facebook page linked to your Instagram account as per Meta's guidelines</div><br /><div>You can instantly create and link a facebook page in your Instagram under 'Edit Profile'</div>",
      },
      {
        question:
          "I don't want my followers to randomly call/message me? Can that be prevented?",
        answer:
          "<div>Yes, you can change your Instagram settings on who can DM/call you under Settings > Calls & Messages</div>",
      },
    ],
  },
  {
    id: 8,
    gaLabel: "profile",
    title: "Profile",
    icon: "faq/profile-faq.svg",
    showOnSourcingHowToWork: false,
    text: "Edit details, social login, bank account",
    children: [
      {
        question: "Can I edit my shop username?",
        answer:
          "<div>It is not possible to change your username once it has been confirmed</div>",
      },
      {
        question:
          "How do I change my Shop's profile pic, cover pic, display name and bio?",
        answer:
          "<div>How do I update my Shop's profile picture, cover picture and bio?</div><br /><div>Go to your profile and click on the respective edit icon to update these details</div>",
      },
      {
        question: "Can I use multiple social media accounts?",
        answer:
          "<div>You can link only one Instagram and one Youtube account to a single mobile number</div><br /><div>If you need to change your social media account, login via a different number or contact us on WhatsApp</div>",
      },
      {
        question: "How do I change phone number for login?",
        answer:
          "<div>Please contact us on WhatsApp to change the mobile number linked to your Shop</div>",
      },
      {
        question: "Can I change my bank account details?",
        answer:
          "<div>Please contact us on WhatsApp to change your bank account details for payouts</div>",
      },
      {
        question: "What is the relevance of updating additional info details?",
        answer:
          "<div>Wishlink would love to know more details about you so that we can provide you all the relevant updates and ensure timely deliveries</div><br /><div>Your additional info is private to you and is not shared anywhere outside of Wishlink</div>",
      },
      {
        question: "Why has my account been flagged?",
        answer:
          "<div>It appears that some of your social profile links have been shared extensively on platforms other than Instagram or Youtube. This is in violation of our policy and as a result your account has been flagged and some of your links are at risk of getting blacklisted. Our team will reach out to you to understand why this has happened and explain this situation further.</div>",
      },
      {
        question: "Why have my links been blacklisted?",
        answer:
          "<div>Some of your links created in your social profile can be blacklisted if we observe that they have been extensively shared on Telegram and other platforms outside of Instagram or Youtube. You will no longer earn commissions on these links.</div><br /><div>Please avoid repeating this and remember that only links created from your affiliate profile on Wishlink, starting with buy.wishlink.com/ can be shared on such platforms.</div>",
      },
    ],
  },
  {
    id: 9,
    gaLabel: "sourcingaccess",
    title: "Sourcing access",
    text: "Track orders, see delivery and return timelines",
    showOnSourcingHowToWork: true,
    thumbnail: "sourcingaccess.png",
    children: [
      {
        question: "What is Wishlink Sourcing?",
        answer:
          "Wishlink Sourcing is a personalized platform where you can source products hassle-free for creating your content on a returnable basis",
      },
      {
        question: "When am I eligible for sourcing?",
        answer:
          "Sourcing is exclusive to our top performing creators. Our team will reach out to you once you become eligible",
      },
      {
        question:
          "How does Wishlink source products? Specifically around placed order status",
        answer:
          "With Wishlink you can place your order requests and our team will place those orders for you. You don't even have to worry about returns since our team will take care of the whole order management process.",
      },
      {
        question: "Why am I seeing only limited brands?",
        answer:
          "Even though a wide variety of brands are available on sourcing, our exclusive AI algorithm recommends you brands most suitable to you basis your audience, gender and past Wishlink performance. See a brand you think your audinece will love? Please add your suggestion here.",
      },
      {
        question: "Why don't I see all the products from my favourite brand?",
        answer:
          "We prioritize listing treding products or products with high inventory to ensure that the items featured in your content don't go out of stock when your content is published",
      },
      {
        question:
          "Why can't I source anymore? Where are the products I shortlisted?",
        answer:
          "Unfortunately, your sourcing access has been revoked. You can find your shortlisted products in the sourcing portal for next 15 days. ",
      },
      {
        question: "When will I get sourcing back?",
        answer:
          "Since Wishlink Sourcing access is based upon your past Wishlink performance and adherence of Wishlink sourcing guidelines, you can improve your performance by selling more and earning more. ",
      },
    ],
  },
  {
    id: 10,
    gaLabel: "sourcingMyOrders",
    title: "My orders",
    text: "Check eligibility for sourcing products",
    showOnSourcingHowToWork: true,
    thumbnail: "Rectangle+39642.png",
    children: [
      {
        question: "When will my order be delivered?",
        answer:
          "You can check the estimated delivery date of your orders on your order page. In case your items haven't been delivered 2-3 days after your estimated delivery date, please contact your Wishlink Manager. ",
      },
      {
        question: "Where can I track my orders?",
        answer:
          "You can check the status of your orders on your order page. Unfortunately, currently you can't track your orders with Wishlink",
      },
      {
        question: "When do I have to return the product?",
        answer:
          "You have 15 days to create content and return the items sourced",
      },
      {
        question: "Why was my order cancelled?",
        answer:
          "Your order might be cancelled for one of these two reasons- either the product in your size is now out of stock or the brand removed the product from their catalogue.",
      },
    ],
  },
  {
    id: 11,
    gaLabel: "sourcingCredits",
    title: "Credits",
    text: "Learn more about credits",
    showOnSourcingHowToWork: true,
    thumbnail: "credits.png",
    children: [
      {
        question: "What are credits?",
        answer:
          "Sourcing credits are platform currency through which you can source products. ",
      },
      {
        question: "What are barter credits?",
        answer:
          "Barter credits are exclusively available for some creators. Through barter credits you can source items from barter section and keep the items with you after you have created the content.",
      },
      {
        question: "What is brand limit?",
        answer:
          "You can only source using the allocated amount of credits on certain brands. Check your brand limits in the bottom of your screen while sourcing. ",
      },
      {
        question: "When am I assigned new credits?",
        answer:
          "Our exclusive AI assigns credits to sourcing eligible creators on every 25th of the month.",
      },
      {
        question: "Where can I see my sourcing credits?",
        answer:
          "You can see your allocated sourcing credits on the top right corner of your sourcing home screen. ",
      },
      {
        question:
          "Why are my credits so less? Who decides my sourcing limit? How can I increase my credits?",
        answer:
          "Our exclusive AI algorithm sets a monthly sourcing limit for all creators. This limit is determined based on two main factors: your past Wishlink earnings and the percentage of sourced products that you incorporate into your content",
      },
      {
        question: "My credits are exhausted, how can I still source products?",
        answer:
          "You can't source products outside your allocated sourcing credits. Please wait for 25th to source products again.",
      },
    ],
  },
  {
    id: 12,
    gaLabel: "SourcingGuidelines",
    title: "Sourcing guidelines",
    text: "Guidelines for sourcing products",
    showOnSourcingHowToWork: true,
    thumbnail: "guideline.png",
    children: [
      {
        question: "What are Wishlink Sourcing guidelines?",
        answer:
          "Ordering with Wishlink Sourcing is a breeze! Simply source products from our website, create your content and return the items within return deadlines. Don't forget to share links of sourced product in your content. Connect with your Wishlink Manager for more details ",
      },
      {
        question: "What are barter credits?",
        answer:
          "Barter credits are exclusively available for some creators. Through barter credits you can source items from barter section and keep the items with you after you have created the content.",
      },
      {
        question: "What is brand limit?",
        answer:
          "You can only source using the allocated amount of credits on certain brands. Check your brand limits in the bottom of your screen while sourcing. ",
      },
      {
        question: "When am I assigned new credits?",
        answer:
          "Our exclusive AI assigns credits to sourcing eligible creators on every 25th of the month.",
      },
      {
        question: "Where can I see my sourcing credits?",
        answer:
          "You can see your allocated sourcing credits on the top right corner of your sourcing home screen. ",
      },
      {
        question:
          "Why are my credits so less? Who decides my sourcing limit? How can I increase my credits?",
        answer:
          "Our exclusive AI algorithm sets a monthly sourcing limit for all creators. This limit is determined based on two main factors: your past Wishlink earnings and the percentage of sourced products that you incorporate into your content",
      },
      {
        question: "My credits are exhausted, how can I still source products?",
        answer:
          "You can't source products outside your allocated sourcing credits. Please wait for 25th to source products again.",
      },
    ],
  },
];
export const MEESHO_CONTENT_GUIDELINES = [
  {
    title: "1. Post only original content",
    rules: [
      {
        text: "No reposts, screenshots, or screen recordings",
        isValid: false,
      },
      { text: "Use your own videos showing Meesho products", isValid: true },
    ],
  },
  {
    title: "2. Tag the right products",
    rules: [
      { text: "Don't tag random or wrong products", isValid: false },
      {
        text: "Tag only the product shown clearly in the video",
        isValid: true,
      },
    ],
  },
  {
    title: "3. Show correct prices",
    rules: [
      {
        text: "If the price in the video is too different from the actual price, the reel can get flagged",
        isValid: false,
      },
      {
        text: "Show the correct price at the time of posting",
        isValid: true,
      },
    ],
  },
  {
    title: "4. Always tag @MeeshoApp",
    rules: [
      { text: "This is now mandatory on all Meesho reels", isValid: true },
    ],
  },
];
export const ADJUSTMENT_FAQS = {
  gaLabel: "adjustment-education",
  children: [
    {
      question: "Which brands currently apply adjustments?",
      answer:
        "Currently, only Myntra, Meesho, Flipkart and Shopsy apply adjustments. We’re working with them to keep your commission rates more stable and reduce future adjustments.",
    },
    {
      question: "How do adjustments affect my payout?",
      answer:
        "Confirmation of commissions & returns are from the base of adjusted commissions</><br />e.g. if commissions of 80 become 100 after adjustments - confirmed commissions would be from 100 after returns. If 40% of orders were returned, you'd receive 60% of 100 = 60 in your payout",
    },
    {
      question: "When are adjustments positive and negative?",
      answer:
        "Adjustments are positive when commission percentage applicable increases (e.g 0.5% to 9%); negative when it decreases (e.g. 9% to 0.5%)",
    },
    {
      question: "How much adjustments are positive and how much are negative?",
      answer:
        "Adjustments are positive in more than 95% of cases currently - implying more commissions for you",
    },
    {
      question: "What happens when there are no adjustments?",
      answer:
        "Having 0 adjustments imply that commissions were tracked correctly at time of sale",
    },
    {
      question: "Can there be adjustment in sale amount as well?",
      answer:
        "Adjustment in sale amount would mean that the order amount was not tracked correctly. This is a very rare case",
    },
  ],
};
export const FLAGGED_CONTENT_FAQS = {
  gaLabel: "flagged-content-education",
  children: [
    {
      question: "What is 'Flagged Content'?",
      answer:
        "Flagged Content refers to any video or reel that <strong>doesn’t follow the content guidelines</strong> shared by the brand.<br /><br />For Meesho, these are called <strong>“Bad Reels”.</strong>",
    },
    {
      question: "Why was my Meesho reel flagged?",
      answer:
        "Here are the common reasons why Meesho flags content:<br /><br />" +
        "• Reposts, screenshots, or screen recordings<br />" +
        "• Tagging wrong/random products<br />" +
        "• Showing incorrect prices<br />" +
        "• Not tagging @MeeshoApp",
    },
    {
      question: "How much amount will be deducted for flagged content?",
      answer:
        "There’s <strong>no fixed amount</strong>. If your reel is flagged, you <strong>won’t earn commissions</strong> on orders made through that reel.",
    },
    {
      question: "If I delete a flagged reel, will the deduction go away?",
      answer:
        "No. Deleting a flagged reel <strong>does not remove the deduction</strong>.<br />" +
        "The decision is based on the original content that was uploaded.",
    },
    {
      question: "Should I delete flagged content?",
      answer:
        "Not necessary. In fact:<br /><br />" +
        "• It’s better to <strong>keep the reel visible</strong> in case you want to review or raise dispute against the decision.<br />" +
        "• Deleting it does <strong>not help avoid deductions.</strong>",
    },
    {
      question: "I disagree with the reason for flagging. What should I do?",
      answer:
        "You can raise an appeal by submitting the <strong>Dispute Form</strong> linked in your dashboard.<br /><br />" +
        "When appealing:<br />" +
        "• Clearly explain why you think the reel <strong>followed the guidelines</strong>.<br />" +
        "• Add supporting points or screenshots if needed.",
    },
    {
      question:
        "How long does the appeal take, and can I get the deduction back?",
      answer:
        "• Appeals usually take a <strong>few working days</strong> to review.<br />" +
        "• If your appeal is successful, the <strong>deducted amount will be added back</strong> to your next month’s payout.",
    },
  ],
};
export const FAQ_EDUCATION_PAGE = {
  gaLabel: "analyticspayouts",
  faqArray: [
    {
      question: "Will I receive the April '24 payout in May '24?",
      answer:
        "Commissions for orders placed in April won't be paid out in May '24. They will be disbursed once the brand confirms the status of the orders, which typically takes a minimum of one month. Therefore, your April commissions will begin to be confirmed in May and will be paid out in June.<br/><br/>The confirmation period varies from brand to brand. Starting from next month, you will receive monthly payouts.<br/> <br/>Watch the YouTube video above to learn more about the new payout process.",
    },
    {
      question: "When will my pending orders be confirmed for payout",
      answer:
        "Each brand has a different confirmation time ranging from minimum one month to a few months.<br/> <br/>For example, if a brand has confirmation time of 45-60 days, its orders placed in the current month will get confirmed between 15th to 30th of the next month.<br/> <br/>You can see confirmation time of your brands by clicking on the Pending Commissions card in Payouts. The actual confirmation time of a brand may vary.",
    },
    {
      question: "What are pending commissions and confirmed commissions?",
      answer:
        "Pending Commissions: Commissions on orders placed but not confirmed by the brand. These are pending because users can still cancel or return the product(s).<br/><br/>Confirmed commissions: Commissions on orders confirmed by the brand, after deducting cancellations and returns.",
    },
    {
      question: "How is my payout calculated?",
      answer:
        "Your payout in a month will include all the commissions which get confirmed by the brand in that month and any earnings via rewards and referral.<br/><br/>The confirmed commissions are commissions on the final order amount once cancellations and returns have been deducted.",
    },
    {
      question: "What are potential returns and actual returns?",
      answer:
        "Potential returns: Typical return percentage of the brand basis historical data.<br/><br/>Actual returns: Actual cancellations & return percentage on the orders placed via your Wishlinks.",
    },
    {
      question: "What is Wishlink's payout policy?",
      answer: `Payouts are processed before 10th of the following month into the bank account linked to your profile.<br/><br/>Note: A 2% TDS is deducted on your total earnings from Commission and 10% on your earnings from Rewards and Paid Collaboration and this will be reflected on your dashboard.`,
    },
    {
      question: "How can I maximize my earnings with Wishlink?",
      answer:
        "Share your Wishlinks everywhere!<br><br/>Learn the best tips and tricks to maximize your Wishlink earnings <a href='https://creator.wishlink.com/playbook'>here</a><br/><br/>If you want to claim GST, let us know <a href='https://forms.gle/1MjL3Ri3cKDKCjUX8'>here</a>.",
    },
    {
      question: "What payment methods are available for receiving payouts?",
      answer:
        "We process payouts monthly directly to your designated bank account. To ensure seamless transactions, kindly ensure your bank account details are updated in your profile settings.",
    },
    {
      question: "Is there a minimum threshold for payout?",
      answer:
        "There is no minimum threshold for payouts.<br/><br/>Simply start creating content, add product wishlinks, and begin earning commissions. It's that easy!",
    },
    {
      question: "Can I track my earnings and payout status?",
      answer:
        " Absolutely! You can easily monitor your earnings and payout status through your Wishlink creator dashboard.",
    },
  ],
};

export const RESPONSIVE = [
  {
    breakpoint: 430,
    settings: {
      centerPadding: "90px",
    },
  },
  {
    breakpoint: 400,
    settings: {
      centerPadding: "80px",
    },
  },
  {
    breakpoint: 370,
    settings: {
      centerPadding: "70px",
    },
  },
];

export const GET_STARTED_OBJECT = [
  "login-monetize.png",
  "login-brandsv2.png",
  "login-sourcing.png",
];

export const REC_BRAND_LOGOS = [
  "h&m.svg",
  "urbanic1.png",
  "meesho_new_small.png",
  "myntra-logo-2-small.png",
];

export const FILTERS_SHOW_STATES = {
  SHOW_MORE: "Show More",
  SHOW_LESS: "Show Less",
};

export const POST_CATEGORIES = {
  MG: "MIN. GUARANTEE",
  HIDDEN: "HIDDEN",
  BRAND_COLLAB: "BRAND COLLAB",
  CONTRACT: "CONTRACT",
  AMAZON: "AMAZON",
  NON_PARTNERED_BRAND: "NON-PARTNER BRAND",
};

export const POST_CATEGORIES_IMG_SRC = {
  HIDDEN: "hidden-tag-v2.svg",
  AMAZON: "amazon-tag.svg",
  NON_PARTNER_BRAND: "non-partner-tag.svg",
};

export const EARNING_TYPES = {
  ORGANIC: "ORGANIC",
  MG: "MG",
  CONTRACT: "CONTRACT_MG",
  BRAND_COLLAB: "FIXED",
};

export const REWARDS_EXPLAINER_CARDS = {
  YOUR_TERMS: {
    imageUrl: "reward-helper-lock-main.svg",
    text: "See milestone for reward in each week's card",
  },
  LINK_PRODUCTS: {
    imageUrl: "reward-rupee.svg",
    text: "Click on weekly milestone to know your rewards",
  },
  EXCLUDE_MEESHO: {
    imageUrl: "reward-gift.svg",
    text: "Meesho earnings will not be included in rewards",
  },
};

export const REWARDS_EXPLAINER_CARDS_SALES = {
  ANY_BRAND: {
    imageUrl: "reward-gift.svg",
    text: "We have exciting WEEKLY and MONTHLY rewards for you!",
  },
  YOUR_TERMS: {
    imageUrl: "reward-helper-lock-main.svg",
    text: "You will know your 2 weekly MILESTONES in each week's tab",
  },
  LINK_PRODUCTS: {
    imageUrl: "reward-rupee.svg",
    text: "Click on each milestones to know corresponding reward AMOUNT!",
  },
};

export const TELEGRAM_REWARDS_EXPLAINER_CARDS_SALES = {
  ANY_BRAND: {
    imageUrl: "reward-gift.svg",
    text: "See the reward amount with your earning target!",
  },
  LINK_PRODUCTS: {
    imageUrl: "reward-rupee.svg",
    text: "All of your earnings would be included!",
  },
};

export const REWARDS_CAMPAIGN_STATUSES = {
  PAST: "past",
  ACTIVE: "active",
  UPCOMING: "upcoming",
};

export const REWARDS_CAMPAIGN_COMPLETION_STATUS = {
  ALL_LEVELS_COMPLETED: "all-levels",
  TWO_LEVELS_COMPLETED: "two-levels",
  ONE_LEVELS_COMPLETED: "one-levels",
  NO_LEVELS_COMPLETED: "no-levels",
};

export const CAMPAIGN_REWARDS_STATES = [
  "no-levels",
  "one-levels",
  "two-levels",
  "all-levels",
];

export const SLAB_BACKGROUNDS = ["#D6FFDC", "#E4D6FF", "#FFE1C5"];

export const CAMPAIGN_PROGRESS_BAR_STATES = [
  "campaign-state-1.png",
  "campaign-state-2.png",
  "campaign-state-3.png",
];

export const rewardParentStatuses = {
  PAST: "past",
  CURRENT: "current",
  UPCOMING: "upcoming",
};

export const REWARDS_ACHIEVING_METRICS = {
  SALES: "sales",
  EARNINGS: "earnings",
  EARNINGS_WITH_PRODUCTS: "earnings_with_products",
  EARNINGS_WITH_PRODUCTS_ECOMM_NON_MEESHO:
    "earnings_with_product_ecomm_non_meesho",
  ALL_EARNINGS: "all_earnings",
};

export const REWARDS_DETAILS_TYPES = {
  LEADERBOARD: "leaderboard",
  WEEKLY_DETAILS: "weekly-details",
};

export const PERFORMANCE_METRIC_TYPES = {
  REWARDS: "rewards",
  PAYOUT: "payout",
};

export const PRO_TIP_TYPES = {
  BRANDS: "brands",
  DIY: "diy",
  LEADERBOARD: "leaderboard",
  REWARDS: "rewards",
};

export const CONTACT_WISHLINK_NUMBER = "919319007907";

export const USERNAME_REGEX = /^[a-zA-Z0-9.]*$/;

export const SHOW_ZERO_COMMISSION_FOR_MEESHO_CREATORS = [
  146242, 416030, 642710, 425796, 465146, 604973, 852968, 620487, 583081,
  339970, 560578, 561638, 641948, 413513, 909528, 250295, 431996, 432450,
  579533, 403813, 1022894, 566489, 506070, 665683, 730118, 447570, 524620,
  522076, 524884, 599838, 623015, 430600, 268971, 597266, 423745, 686272,
  620710, 537190, 1033893, 469065, 723809, 503637, 532940, 555327, 849693,
  509745, 942227, 405074, 613827, 577360, 515421, 776398, 640573, 758498,
  647174, 430534, 648110, 561080, 515790, 691421, 414921, 847324, 615216,
  958103, 693287, 592498, 402935, 721931, 691998, 942642, 902326, 993224,
  442087, 73981, 777397, 177457, 983210, 834032, 393355, 532253, 719642, 589923,
  411575, 1014091, 537439, 990631, 593018, 574585, 46051, 1003594, 584317,
  159523, 519782, 359287, 597728, 502191, 787684, 601368, 519801, 92212, 623470,
  711914, 931902, 414683, 1018940, 402054, 265379, 521677, 810691, 709519,
  454933, 934431, 611281, 611794, 411893, 404556, 698872, 701592, 544506,
  466965, 403509, 939353, 734173, 982505, 474011, 494795, 924441, 407249,
  420257, 851164, 382375, 697847, 522564, 970331, 837501, 928272, 696923,
  895278, 463869, 725087, 565365, 903819, 387393, 942055, 966204, 402924,
  613601, 722237, 383017, 640054, 564024, 893975, 404652, 721605, 666975,
  772951, 52759, 404736, 759593, 793321, 625216, 950007, 853179, 577978, 677598,
  510369, 295532, 551596, 906026, 552613, 719596, 327548, 546518, 408947,
  992424, 478479, 723811, 614968, 806510, 618102, 799332, 635861, 459801,
  598063, 526361, 698976, 1013644, 569833, 512655, 568383, 164568, 402996,
  544372, 556460, 652900, 660670, 536470, 597164, 413750, 729226, 736676,
  710353, 842707, 634674, 672767, 539172, 413653, 405628, 584424, 728428,
  408278, 422111, 503142, 652992, 411109, 771656, 403807, 555871, 817614,
  456828, 418432, 547295, 896362, 621821, 845424, 406149, 887237, 600832,
  410692, 655393, 544597, 624285, 225586, 200356, 427376, 588261, 491117,
  551231, 518411, 540049, 403823, 726015, 561860, 504093, 621250, 1004865, 8978,
  992369, 855832, 687253, 943315, 512326, 441997, 716355, 463329, 586839,
  539364, 752690, 411376, 502076, 586143, 418856, 738147, 180673, 404275,
  412791, 834889, 655710, 690550, 617118, 614662, 869445, 63073, 639762, 640597,
  985444, 609886, 420117, 859066, 771317, 418693, 504588, 720453, 404702,
  598460, 633321, 658363, 573222, 783170, 462536, 429039, 923495, 577210,
  496734, 629381, 404169, 989946, 564110, 386325, 716281, 753906, 38127, 366007,
  418889, 548781, 737958, 418895, 406124, 52839, 198576, 738237, 547358, 617440,
  405612, 413521, 636898, 635071, 443814, 891546, 577394, 714164, 616417,
  964396, 633360, 911278, 534794, 457597, 644961, 475585, 427191, 550522,
  918694, 281373, 491636, 801623, 710017, 922406, 445772, 574515, 561354,
  208555, 754915, 644201, 739859, 415644, 645893, 761275, 564936, 686096,
  519555, 669548, 720901, 772789, 967502, 177011, 848096, 729330, 889403,
  532504, 339336, 526444, 1018967, 662613, 62229, 781796, 452129, 791937,
  796395, 406071, 405207, 464748, 928934, 835909, 244176, 403268, 541698,
  411998, 401291, 544407, 948560, 513892, 590053, 724950, 955637, 627584,
  592639, 536376, 533244, 784184, 501563, 413608, 402909, 46661, 1009391,
  957393, 1005599, 641690, 240308, 655509, 430405, 287960, 702214, 543192,
  744154, 504346, 654801, 539756, 88727, 414318, 864355, 928067, 544370, 495159,
  600982, 448439, 495666, 413205, 656237, 597940, 486527, 586296, 287613,
  964531, 706592, 877322, 547420, 723810, 494903, 265460, 923883, 523453,
  612347, 888922, 349503, 486471, 788435, 453804, 806744, 547389, 404546,
  1001748, 647172, 594624, 665663, 788263, 739950, 928606, 450044, 528589,
  908737, 561698, 772450, 571384, 285102, 1009193, 627147, 404601, 554173,
  221033, 653174, 438234, 478038, 586029, 413053, 796611, 889187, 658650,
  853378, 326998, 749875, 894564, 740283, 533109, 996048, 641965, 504174,
  736772, 811233, 410222, 505965, 870727, 799870, 368970, 752420, 35375, 676679,
  632243, 583789, 626771, 813077, 468852, 601626, 1009102, 584967, 773452,
  732948, 493154, 735531, 59796, 893959, 403767, 77642, 408901, 537803, 404143,
  632795, 881107, 887963, 643590, 568262, 551137, 784312, 790330, 527698,
  398734, 584044, 26542, 413919, 731394, 509242, 505001, 992473, 221177, 481821,
  409757, 407813, 463440, 501102, 690874, 516798, 421792, 885671, 497418,
  898255, 949367, 525763, 924336, 406148, 1016743, 406693, 731227, 899814,
  951183, 1007219, 690378, 403238, 402629, 949287, 898225, 489753, 655873,
  411180, 985516, 578422, 404467, 769705, 841350, 413226, 1008514, 753830,
  220581, 860380, 1009628, 592750, 635939, 732973, 233309, 581588, 425200,
  287949, 532332, 439055, 994384, 636932, 939294, 463325, 837852, 406591,
  932608, 406552, 607163, 730847, 710020, 612140, 503786, 1002921, 617426,
  726186, 634162, 422547, 412790, 619713, 427178, 893181, 413546, 754914,
  898074, 322174, 563357, 552311, 697069, 509211, 736322, 637778, 262149,
  759203, 403236, 174078, 634901, 296385, 418087, 742638, 777222, 928752,
  191987, 487912, 266132, 642712, 524393, 543890, 1013373, 755578, 503086,
  836317, 518763, 536940, 706830, 427275, 737957, 606261, 797572, 547801,
  597850, 425619, 532044, 406134, 972217, 795032, 895363, 717880, 175644,
  611197, 448408, 409003, 972216, 1003067, 539131, 900762, 533919, 405625,
  631644, 496276, 637064, 413561, 582504, 552554, 543573, 754495, 69765, 410274,
  992517, 482023, 498312, 662775, 128082, 140023, 424743, 628418, 722230,
  1018969, 403000, 898123, 414771, 59914, 31785, 115169, 215026, 184149, 85608,
  258162, 14896, 93314, 138133, 76402, 44870, 38730, 27272, 32102, 31126, 38772,
  7556, 46025, 58308, 15117, 2577, 16793, 41221, 105353, 54548, 181136, 9328,
  18189, 114169, 12816, 86734, 58986, 87489, 303673, 169825, 296898, 75716,
  89606, 200737, 21044, 96114, 23701, 76981, 223136, 44761, 173296, 8979, 93186,
  16817, 132652, 29145, 85290, 26169, 91193, 18418, 23800, 166950, 53962, 90543,
  5012, 56968, 46034, 108325, 15725, 151525, 127929, 67963, 3459, 20021, 1560,
  53916, 106601, 44663, 8749, 61167, 21239, 47281, 72140, 52059, 22706, 133795,
  19206, 327480, 6431, 47477, 322291, 72034, 135361, 273491, 104889, 348170,
  88732, 92071, 165289, 167853, 144544, 170827, 263876, 12146, 20245, 48169,
  106505, 108760, 112181, 123296, 131506, 138150, 188744, 264600, 279891,
  285802, 292377, 315530, 343593, 346186, 382817, 394773, 398913, 406907,
  438070, 453659, 473893, 541475, 573257, 593701, 640525, 172379, 683150, 47733,
  165338, 702268, 514508, 488521, 118775, 554450, 330268, 431990, 7776, 37639,
  457766, 501108, 356714, 686791, 87151, 388646, 381862, 363578, 407233, 396965,
  18936, 487754, 389460, 199580, 293101, 57356, 98425, 352946, 167267, 58648,
  535508, 451393, 547669, 283650, 171530, 261474, 259552, 639546, 233377, 61793,
  98991, 636536, 544569, 214741, 379395, 38738, 401976, 440281, 332524, 31176,
  34604, 112865, 62985, 408383, 99078, 3994, 7296, 511548, 26806, 496206, 62833,
  360259, 351070, 315397, 12026, 103588, 248641, 521214, 42444, 112048, 150157,
  356662, 21467, 356171, 439493, 51279, 204917, 130607, 78547, 23090, 9995,
  302881, 43749, 221668, 14368, 282027, 571, 396533, 85786, 68167, 12670,
  469097, 7805, 319268, 429533, 369721, 402302, 85846, 77964, 387668, 46951,
  184013, 12238, 14783, 757, 91422, 14633, 388658, 89951, 88967, 675834, 72097,
  254402, 99258, 787671, 116817, 792696, 9007, 386831, 90841, 678133, 356042,
  356478, 789834, 307345, 257952, 711873, 227770, 337733, 722502, 18678, 181134,
  379547, 706330, 851745, 843738, 444897, 816848, 118285, 616608, 16809, 834627,
  675467, 67380, 847536, 869498, 844357, 243295, 251490, 170452,
];

export const MEESHO_PILOT_3_BRAND_ID = 251;

export const MEESHO_BRAND_IDS = [251, 226, 305];

export const AJIO_BRAND_ID = 301;

export const FLIPKART_BRAND_ID = 303;

export const AMAZON_BRAND_ID = 7;

export const FLIPKART_COMMISSION = 9;

// Commission on the Flipkart Auto-DM flow
export const FLIPKART_AUTO_DM_COMMISSION = 1;

// Commission on the Meta x Flipkart affiliate product-tagging flow
export const FLIPKART_META_TAGGING_COMMISSION = 12;

export const PURE_ORIGIN_BRAND_ID = 305;

export const SHOPSY_BRAND_ID = 315;

export const SHOPSY_COMMISSION = 11;

export const AMAZON_COMMISSION_AIP_PERCENT = 7;

export const AMAZON_COMMISSION_FIP_PERCENT = 10;

export const SELECT_BY_WISHLINK_BRAND_ID = 2259;

export const SELECT_BY_WISHLINK_COLLECTION_ID = 2160;

/** PLP category chips: default order; `value` must match backend filter option strings. */
export const SELECT_BY_WISHLINK_CATEGORY_RANKING = [
  {
    key: "kurta_kurti",
    label: "Kurta-Kurti Sets",
    value: "Kurta-Kurti Sets",
    image: "filter-kurta-kurti.png",
    height: "48px",
    width: "20px",
  },
  {
    key: "dresses",
    label: "Dresses",
    value: "Dresses",
    image: "filter-dresses.png",
    height: "50px",
    width: "18px",
  },
  {
    key: "co_ord_sets",
    label: "Co Ord Sets",
    value: "Co Ord Sets",
    image: "filter-co-ord-sets.png",
    height: "50px",
    width: "18px",
  },
  {
    key: "ethnic_dresses",
    label: "Ethnic Dresses",
    value: "Ethnic Dresses",
    image: "filter-ethnic-dresses.png",
    height: "53px",
    width: "26px",
  },
  {
    key: "trousers",
    label: "Trousers",
    value: "Trousers",
    image: "filter-trousers.png",
    height: "50px",
    width: "22px",
  },
  {
    key: "jeans",
    label: "Jeans",
    value: "Jeans",
    image: "filter-jeans.png",
    height: "50px",
    width: "18px",
  },
  {
    key: "tops",
    label: "Tops",
    value: "Tops",
    image: "filter-tops.png",
    height: "40px",
    width: "32px",
  },
];

export const LIBAS_BRAND_ID = 33;

export const EMAIL_REGEX =
  /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[A-Z]{2,}$/i;

export const ADDRESS_REGEX = /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;

export const AMAZON_TAG_REGEX = /.*-\d{2}$/;

export const NON_PRODUCT_LINK_IDENTIFIERS = [
  "instagram.com/",
  "youtube.com/",
  "youtu.be/",
  "telegram.me/",
  "linktr.ee/",
];

export const WISHLINK_CREATOR_IDS = [1916, 581, 373, 7435];

export const WISHLINK_CREATOR_IDS_FOR_FTUX = [581, 873504];

export const NON_PRODUCT_LINK_CREATOR_EXCEPTIONS = [406, 2666, 581];

export const IMAGE_FILE_EXTENSIONS = [".jpg", ".jpeg", ".png", ".webp"];

export const LINK_REGEX =
  // eslint-disable-next-line no-useless-escape
  /^(https?:\/\/)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,16}\b([-a-zA-Z0-9()@!:%_\+.~#?&\/=]*)/i;

// Engage V2.1 — Google links Meta may flag when sent via Instagram DMs.
// Scoped to Google product domains creators paste as "digital product" links
// (Drive / Docs / Sheets / Slides / Forms). Kept as one list so scope can be
// narrowed (e.g. Drive-only) if Meta clarifies. Bare google.com is intentionally
// excluded to avoid flagging unrelated links.
// Google Forms links are intentionally NOT flagged — forms are fine to share
// in DMs, so they get no inline warning / pre-submit drawer nudge.
export const GOOGLE_LINK_DOMAINS = [
  "drive.google.com",
  "drive.usercontent.google.com",
  "docs.google.com",
  "sheets.google.com",
  "slides.google.com",
];

// Engage V2.1 — GA label / label2 values (GA sheet "Engage v2.1").
export const ENGAGE_GA_LABEL = {
  UPLOAD_FILE: "upload_file",
  UPLOAD_STARTED: "upload_started",
  UPLOAD_STATUS: "upload_status",
  UPLOAD_ERROR: "upload_error",
  UPLOAD_RETRY: "upload_retry",
  UPLOAD_FILE_REMOVE: "upload_file_remove",
  INVALID_LINK: "invalid_link",
  GOOGLE_LINK_WARNING: "google_link_warning",
  GOOGLE_LINKS_WARNING_DRAWER: "google_links_warning_drawer",
  SUCCESS: "success",
  FAILED: "failed",
  SIZE_EXCEEDED: "size_exceeded",
  UNSUPPORTED_FORMAT: "unsupported_format",
  KEEP_EXISTING: "keep_existing",
  CONTINUE_ANYWAY: "continue_anyway",
  GO_BACK_UPLOAD: "go_back_upload",
  // added_product_link variants (label2) + link_type custom values
  MANUAL_LINK: "manual_link",
  UPLOADED_FILE: "uploaded_file",
  WISHLINK_FETCH: "wishlink_fetch",
  NORMAL_LINK: "normal_link",
  FETCHED_PRODUCT: "fetched_product",
  // Wishlink-in-Wishlink flow
  WISHLINK_FETCH_DRAWER: "wishlink_fetch_drawer",
  GOT_IT: "got_it",
};

// Engage V2.1 — product-origin tag sent per submitted item inside its
// `additional_info` payload object; the backend upserts these keys into
// atg_product.additional_info. Plain hand-pasted links send none.
export const PRODUCT_SOURCE = {
  MEDIA_UPLOAD: "media_upload",
  GOOGLE_LINK: "google_link",
  WISHLINK_POST_IMPORT: "wishlink_post_import",
};

// Engage V2.1 — Media upload (custom-engage "Upload File"). Documents (PDF, TXT,
// XLSX), images (PNG, JPEG, WebP), and video (MP4, MOV, AVI, 3GP, WebM, MKV, MPEG).
export const CUSTOM_ENGAGE_UPLOAD = {
  MAX_SIZE_MB: 25,
  ACCEPTED_MIME_TYPES: [
    "application/pdf",
    "text/plain",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "image/png",
    "image/jpeg",
    "image/webp",
    "video/mp4",
    "video/quicktime",
    "video/x-msvideo",
    "video/3gpp",
    "video/webm",
    "video/x-matroska",
    "video/mpeg",
  ],
  // `accept` attribute for the file picker (MIME types + extensions, since some
  // browsers don't map these container formats to a MIME type).
  ACCEPT_ATTRIBUTE:
    "application/pdf,text/plain,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,image/png,image/jpeg,image/webp,video/mp4,video/quicktime,video/x-msvideo,video/3gpp,video/webm,video/x-matroska,video/mpeg,.pdf,.txt,.xlsx,.png,.jpeg,.jpg,.webp,.mp4,.mov,.avi,.3gp,.webm,.mkv,.mpeg",
};

// Fallback card thumbnail for uploads that can't preview themselves (PDF, videos, TXT, XLSX)
export const CUSTOM_ENGAGE_DEFAULT_THUMBNAIL = `${BUCKET_CDN_PREFIX}logo-1024x1024.png`;

export const PRODUCT_SECTION_TYPES = {
  TAGGED: "TAGGED",
  FAILED: "FAILED",
};

export const CITY_REGEX = /[`!@#$%^&*_+\-=[\]{};':"\\|,.<>/?~]/;

export const ADDITIONAL_ELEMENT = {
  CTA_BUTTON: "CTA_BUTTON",
  BANNER: "BANNER",
};

export const LINK_TYPE = {
  LINK_EXTERNAL: "LINK_EXTERNAL",
  LINK_INTERNAL: "LINK_INTERNAL",
  COPY_TEXT: "COPY_TEXT",
};

export const NOTIFICATION_TYPE = {
  NEW: "new",
  EARLIER: "earlier",
};

export const ADD_CREATOR_TO_GROUP = "add_creator_to_group";

export const NOTIF_TYPE = {
  NOTIFICATION_LEDGER: "NOTIFICATION_LEDGER",
  BELL_ICON: "BELL_ICON",
};

export const NOTIFICATION_GIFS = [
  `${IMAGE_PREFIX}321.gif`,
  `${IMAGE_PREFIX}Heart.gif`,
  `${IMAGE_PREFIX}Quote.gif`,
];

export const STOREFRONT_HOST_NAME = "https://wishlink.com/refer/";
export const tncSheet = `https://www.wishlink.com/w/terms-of-service?wishlink_external=true`;

export const TIRA_BEAUTY_BANNER = `https://www.wishlink.com/share/45rgs?wishlink_external=true`;

export const invitedCreatorCount =
  20 +
  5 *
    Math.floor((new Date().getTime() - 1695197731582) / (1000 * 60 * 60 * 24));

export const REFERRAL_NUDGES = [
  {
    icon_url: `${IMAGE_PREFIX}ref-topbrandsv2.png`,
    title:
      "Help your besties work with top brands like Myntra, Meesho, H&M & more",
  },
  {
    icon_url: `${IMAGE_PREFIX}timeflies.png`,
    title:
      "Simplify their life by automating replies to comments asking for links",
  },
  {
    icon_url: `${IMAGE_PREFIX}ref-earningsboost.png`,
    title: "Boost their earnings and celebrate together!",
  },
  {
    icon_url: `${IMAGE_PREFIX}ref-high-five.png`,
    title: `${invitedCreatorCount}+ creators have already invited their besties to Wishlink`,
  },
];

export const URL_CLEANING_REGEX =
  // This keeps only characters allowed by RFC 3986 — used in valid URLs.
  /[^a-zA-Z0-9\-._~:/?#[@\]!$&'()*+,;=%]/g;

export const URL_REGEX =
  // eslint-disable-next-line no-useless-escape
  // /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,16}\b([-a-zA-Z0-9()@!:%_\+.~#?&\/=]*)/g;
  /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,16}\b([^\s]*)/g;

export const WISHLINK_CREATION_NUDGE = [
  "Pssst! Wanna know the secret sauce? More Product Wishlinks shared = more cha-ching! 💰",
  "Here's the scoop: Keep the Product Wishlinks flowing, and your bank balance growing! 💸",
  "Time to level up your earnings: Share those Product  Wishlinks like a pro! 💼💰",
  "In the world of wishlinks, sharing is caring, and earning! 🌟💸",
  "Show those Product Wishlinks some love, and they'll show your wallet some love back! 💖💰",
  "Ready to turn Wishlinks into a WishFUL wallet? Share away! 🚀💰",
  "Your Wishlink army is ready to conquer the earnings realm! Share away, General! ⚔️💰",
  "Wishlink warriors assemble! The more you share, the richer you get! 💎💸",
  "Eureka! Your genius formula: More Product Wishlinks = More moolah! 🧪💸",
  "Wishlink sorcery: The more you cast them, the more gold you amass! ✨💰",
];

export const brandWiseChartColors = [
  "#E38125",
  "#D37FA2",
  "#7FD397",
  "#8262BF",
  "#E91E63",
  "#D4D4D4",
];

export const ChannelWiseChartColors = [
  "#4e90ff",
  "#E38125",
  "#D37FA2",
  "#7FD397",
  "#8262BF",
  "#E91E63",
  "#D4D4D4",
];

export const FRONTEND_ASSETS_BASE_URL = `${GUMLET_PREFIX}${CDN_FRONTEND_ASSETS}`;
export const OPEN_MEESHO_DRAWER = "openMeeshoDrawer";

export const RETURN_YT_VIDEO_LINK =
  "https://youtu.be/f1GxPCY19l0?feature=shared";

export const HOW_DOES_ITS_WORK = [
  "Source from highly personalised and commissonable brands",
  "Use credits to source products",
  "Create Content and Share Your Wishlinks",
  "Return your sourced products in 14 days",
];

export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.wishlink.creator";
export const APP_STORE_URL =
  "https://apps.apple.com/in/app/wishlink-creator/id6458532575";

export const ENGAGE_UPDATE_TYPES = {
  COMMENT: "comment",
  DM: "dm",
  STK: "stk",
  STORIES: "story_dm",
  REENGAGE_FOLLOWERS: "reengage_followers",
  SHARE_LINKS_OPTION: "share_links_option",
};

export const UTM_APP_TYPE_ANDROID = "ANDROID";

export const LEARN_HOW_DOCUMENT = "https://help.instagram.com/2358103564437429";

export const SCREEN_HALVES = {
  TOP: "top",
  BOTTOM: "bottom",
};

//These names need to be same as the names in the backend
export const OVERLAY_NAMES = {
  SHOP_INTRO: "SHOP_OVERLAY_1",
  SHOP_CONTENT_ITEM_INTRO: "SHOP_OVERLAY_2",
  SHOP_CONTENT_ITEM_INTRO_2: "SHOP_OVERLAY_3",
  SHOP_CONTENT_ITEM_INTRO_3: "SHOP_OVERLAY_4",
  SHOP_OVERLAY_NON_PARTNERED: "SHOP_OVERLAY_NON_PARTNERED",
  SHOP_OVERLAY_AMAZON: "SHOP_OVERLAY_AMAZON",
  DIY_OVERLAY_BASIC: "DIY_OVERLAY_BASIC",
  DIY_OVERLAY_COUPON: "DIY_OVERLAY_COUPON",
  PAYOUTS_HOME_COMMS: "PAYOUTS_HOME_COMMS",
  PAYOUTS_HOME_PAST_PAYOUTS: "PAYOUTS_HOME_PAST_PAYOUTS",
  PAYOUTS_PENDING_COMMS: "PAYOUTS_PENDING_COMMS",
  PAYOUTS_PENDING_BRANDS: "PAYOUTS_PENDING_BRANDS",
  PAYOUTS_CONFIRMED_COMMS: "PAYOUTS_CONFIRMED_COMMS",
  PAYOUTS_CONFIRMED_BRANDS: "PAYOUTS_CONFIRMED_BRANDS",
  FRESHDESK_CHAT_COMMS: "FRESHDESK_CHAT_COMMS",
  HOMEPAGE_COMMS: "HOMEPAGE_COMMS",
  SUGGESTED_ACTIONS_COMMS: "SUGGESTED_ACTIONS_COMMS",
  WISHLINK_EXCLUSIVE_COMMS: "WISHLINK_EXCLUSIVE_COMMS",
  ENGAGE_OVERLAY: "ENGAGE_OVERLAY",
  FESTIVE_OVERLAY: "FESTIVE_OVERLAY",
  CROSS_POSTING_OVERLAY: "CROSS_POSTING_OVERLAY",
  SUGGESTED_ACTIONS: "SUGGESTED_ACTIONS",
  SOURCING_WISHLIST_HEADER: "SOURCING_WISHLIST_HEADER",
  SOURCING_WISHLIST_BUTTON_ICON: "SOURCING_WISHLIST_BUTTON_ICON",
  GROWTH_OVERLAY_RECOMMENDATION: "GROWTH_OVERLAY_RECOMMENDATION",
  GROWTH_OVERLAY_SIMILAR: "GROWTH_OVERLAY_SIMILAR",
  GROWTH_OVERLAY_QUESTION: "GROWTH_OVERLAY_QUESTION",
  GROWTH_OVERLAY_REALIZED: "GROWTH_OVERLAY_REALIZED",
  WRAPPED: "WRAPPED",
  DND_OVERLAY: "DND_OVERLAY",
  DND_OVERLAY_2: "DND_OVERLAY_2",
  SOURCING_SEARCH_IMPROVED: "SOURCING_SEARCH_IMPROVED",
  SOURCING_SEARCH_NEW: "SOURCING_SEARCH_NEW",
  SOURCING_RTC_BRAND_EDU_HOME: "SOURCING_RTC_BRAND_EDU_HOME",
  SOURCING_RTC_BRAND_EDU_BRAND: "SOURCING_RTC_BRAND_EDU_BRAND",
  BRANDS_HUB_EDU: "BRANDS_HUB_EDU",
  VALUE_REALISATION_CARD: "VALUE_REALISATION_CARD",
  BRANDCOLLAB_CHAT_INTRO: "BRANDCOLLAB_CHAT_INTRO",
  BRANDCOLLAB_TEMPLATE_GUIDE: "BRANDCOLLAB_TEMPLATE_GUIDE",
  BRANDCOLLAB_CHAT_GUIDE: "BRANDCOLLAB_CHAT_GUIDE",
  BRANDCOLLAB_DETAILS_GUIDE: "BRANDCOLLAB_DETAILS_GUIDE",
  BRANDCOLLAB_PAYOUT_STATUS_GUIDE: "BRANDCOLLAB_PAYOUT_STATUS_GUIDE",
  BRANDCOLLAB_CHAT_ACCESS: "BRANDCOLLAB_CHAT_ACCESS",
  STORIES_EDUCATION: "STORIES_EDUCATION",
  STREAKS_ENTRY_AWARENESS: "STREAKS_ENTRY_AWARENESS",
  STREAKS_LISTING_OVERVIEW: "STREAKS_LISTING_OVERVIEW",
  STREAKS_UPCOMING_CARD: "STREAKS_UPCOMING_CARD",
  STREAKS_LIVE_CARD: "STREAKS_LIVE_CARD",
  STREAKS_TRACK_PROGRESS: "STREAKS_TRACK_PROGRESS",
  STREAKS_WON_CARD: "STREAKS_WON_CARD",
  STREAKS_MISSED_CARD: "STREAKS_MISSED_CARD",
  DISCOVER_PAGE_TOUR: "DISCOVER_PAGE_TOUR",
  SELEQT_WEBSITE_CTA: "SELEQT_WEBSITE_CTA",
  PAYOUTS_CX_EXISTING_USER_TOUR: "PAYOUTS_CX_EXISTING_USER_TOUR",
  PAYOUTS_CX_NEW_USER_TOUR: "PAYOUTS_CX_NEW_USER_TOUR",
  PAYOUTS_CX_FIRST_SALE_TRIGGER: "PAYOUTS_CX_FIRST_SALE_TRIGGER",
  PAYOUTS_CX_FIRST_PAYOUT_CONFIRMED_TRIGGER:
    "PAYOUTS_CX_FIRST_PAYOUT_CONFIRMED_TRIGGER",
  PAYOUTS_CX_BANK_MISSING_TRIGGER: "PAYOUTS_CX_BANK_MISSING_TRIGGER",
  PAYOUTS_CX_FIRST_PAYOUT_PAID_TRIGGER: "PAYOUTS_CX_FIRST_PAYOUT_PAID_TRIGGER",
};

export const BRANDS_HUB_OVERLAY_CLASSES = {
  HIGHLIGHTED_BRANDS: "overlay-brands-hub-highlighted-brands",
  CREATOR_CONTENT: "overlay-brands-hub-creator-content",
  QUICK_PICKS: "overlay-brands-hub-quick-picks",
  COLLECTIONS: "overlay-brands-hub-collections",
};

export const DISCOVER_TOUR_CLASSES = {
  SEARCH: "overlay-discover-search",
  OPPORTUNITIES: "overlay-discover-opportunities",
  EXCITING_SALES: "overlay-discover-exciting-sales",
  CREATOR_CONTENT: BRANDS_HUB_OVERLAY_CLASSES.CREATOR_CONTENT,
  QUICK_PICKS: BRANDS_HUB_OVERLAY_CLASSES.QUICK_PICKS,
  FRESH_BRANDS: "overlay-discover-fresh-brands",
  COLLECTIONS: BRANDS_HUB_OVERLAY_CLASSES.COLLECTIONS,
  BROWSE_ALL: "overlay-discover-browse-all",
};

export const DISCOVER_TOUR_SHOW_SEARCH_EVENT = "discover-tour:show-search";
// Dispatched with `detail: boolean` whenever the Discover page tour starts
// or ends, so BrandsHubSearch can pin the search bar open for the tour's
// whole run instead of letting its own scroll-hide logic collapse it as a
// side effect of the tour scrolling to a later step.
export const DISCOVER_TOUR_ACTIVE_EVENT = "discover-tour:active";

export const PAYOUTS_TOUR_CLASSES = {
  PAYOUTS_TAB: "overlay-payouts-tab",
  PENDING_COMMS: "overlay-payout-home-pending-comms",
  STATUS_PREVIEW: "overlay-payout-status-preview",
  STATUS_CONTENT: "overlay-payout-status-content",
  STATUS_EMPTY: "overlay-payout-status-empty",
  HISTORY_PREVIEW: "overlay-payout-history-preview",
  HISTORY_CONTENT: "overlay-payout-history-content",
  STATUS_CARD: "overlay-payout-status-card",
  STATUS_CAROUSEL: "overlay-payout-status-carousel",
  CONNECTIVITY_CTA: "overlay-payout-connectivity-cta",
};

export const PAYOUTS_CX_OVERLAY_NAMES = [
  OVERLAY_NAMES.PAYOUTS_CX_EXISTING_USER_TOUR,
  OVERLAY_NAMES.PAYOUTS_CX_NEW_USER_TOUR,
  OVERLAY_NAMES.PAYOUTS_CX_FIRST_SALE_TRIGGER,
  OVERLAY_NAMES.PAYOUTS_CX_FIRST_PAYOUT_CONFIRMED_TRIGGER,
  OVERLAY_NAMES.PAYOUTS_CX_BANK_MISSING_TRIGGER,
  OVERLAY_NAMES.PAYOUTS_CX_FIRST_PAYOUT_PAID_TRIGGER,
];

export const PAYOUT_OVERLAY_JOURNEY_SECTION_BY_CLASS = {
  [PAYOUTS_TOUR_CLASSES.PAYOUTS_TAB]: "payouts_tab",
  [PAYOUTS_TOUR_CLASSES.PENDING_COMMS]: "pending_commissions",
  [PAYOUTS_TOUR_CLASSES.STATUS_PREVIEW]: "payout_status",
  [PAYOUTS_TOUR_CLASSES.STATUS_CONTENT]: "payout_status",
  [PAYOUTS_TOUR_CLASSES.STATUS_EMPTY]: "payout_status_empty",
  [PAYOUTS_TOUR_CLASSES.HISTORY_PREVIEW]: "payout_history",
  [PAYOUTS_TOUR_CLASSES.HISTORY_CONTENT]: "payout_history",
  [PAYOUTS_TOUR_CLASSES.STATUS_CARD]: "payout_status_card",
};

export const DISCOVER_OVERLAY_JOURNEY_SECTION_BY_CLASS = {
  [DISCOVER_TOUR_CLASSES.SEARCH]: "search",
  [DISCOVER_TOUR_CLASSES.OPPORTUNITIES]: "opportunities",
  [DISCOVER_TOUR_CLASSES.EXCITING_SALES]: "exciting_sales",
  [DISCOVER_TOUR_CLASSES.CREATOR_CONTENT]: "trending_content",
  [DISCOVER_TOUR_CLASSES.QUICK_PICKS]: "quick_picks",
  [DISCOVER_TOUR_CLASSES.FRESH_BRANDS]: "fresh_brands",
  [DISCOVER_TOUR_CLASSES.COLLECTIONS]: "explore_by_theme",
  [DISCOVER_TOUR_CLASSES.BROWSE_ALL]: "all_brands",
};

export const DISCOVER_SEE_ALL_BRAND_HUB_SOURCE = {
  OPPORTUNITIES: "see_all_opportunities",
  EXCITING_SALES: "see_all_sales",
  FRESH_BRANDS: "see_all_fresh",
};

export const DISCOVER_COLLECTION_GA_CUSTOM = {
  BRAND_PAGE_SEE_ALL: "brand_page_see_all",
  HUB_SEE_ALL: "hub_see_all",
  HUB_TRAY: "hub_tray",
};

export const DRAWER_ALLOWED_OVERLAYS = [
  OVERLAY_NAMES.SHOP_OVERLAY_AMAZON,
  OVERLAY_NAMES.SHOP_OVERLAY_NON_PARTNERED,
  OVERLAY_NAMES.STORIES_EDUCATION,
];

export const OVERLAY_ALLOWED_HASHES = ["#Payouts", "#Insights", "#chat"];

export const SUPPORT_DRAWER_ONBOARDING_HASH = "#sourcing-support";
export const SUPPORT_DRAWER_HASH = "#sourcing-support-drawer";

export const SOURCING_SUPPORT_NUMBER = "9319007902";

export const SOURCING_SUPPORT_POINTS = [
  "OTP for receiving/returning any product",
  "Rescheduling any delivery or Return",
  "Help related to which Items to be returned",
  "Report wrong order status",
];
export const FLIPKART_COMMISSION_URL = "https://www.wishlink.com/share/67n29";

export const SHOPSY_COMMISSION_URL =
  "https://docs.google.com/document/d/1pdiv0GXv6zC8Pu_5UvU-a_3c8gBWA6skNwaUP9bWEA4/edit";

export const APPEAL_FORM_URL =
  "https://docs.google.com/forms/d/19k3jwihKupc_cMD1ReWtaJFZpdfFki7z8eUsEQ-L28U/viewform?edit_requested=true";

export const APPEAL_FRAUD_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLScDaeHVqzxGtkqN6yGhwp_J-FuktaW2ikX5OXUb0YRDuhrdYQ/viewform";

export const TESTIMONIAL_SUBTITLES = [
  "Affordable ethnic to look amazing everyday",
  "Beauty and lifestyle creator helping you with a bit of everything",
  "Fashion deals too good to refuse",
  "Men's fashion, grooming and lifestyle expert",
  "Desi fashion enthusiast showcasing their favorite outfitsg",
  "Discover fresh drips and best fits from our top emerging creator",
];

export const SOCIAL_LOGIN_DATE_CONSTANT = "2024-03-18T18:30:00.0000Z";
export const PAYOUT_STATUS = {
  PENDING: "pending",
  CONFIRMED: "confirmed",
  PAID: "paid",
  PROCESSING: "processing",
  SETTLED: "settled",
  REJECTED: "rejected",
  TO_BE_PAID: "to_be_paid",
  FAILED: "failed",
};

export const PAYOUT_STATUS_TO_COLOR = {
  [PAYOUT_STATUS.PENDING]: "#FFF066",
  [PAYOUT_STATUS.PROCESSING]: "#FFF066",
  [PAYOUT_STATUS.PAID]: "#47DD9C",
  [PAYOUT_STATUS.REJECTED]: "#E34552",
  [PAYOUT_STATUS.SETTLED]: "#47DD9C",
  [PAYOUT_STATUS.TO_BE_PAID]: "#FFF066",
};

export const PAYOUT_STATUS_CAPITALIZE = {
  PENDING: "Pending",
  CONFIRMED: "Confirmed",
  PAID: "Paid",
  PROCESSING: "Processing",
  SETTLED: "Settled",
  REJECTED: "Rejected",
  TO_BE_PAID: "To be Paid",
  FAILED: "Failed",
};

export const YT_SHOPPING_PILLS = [
  {
    id: 0,
    name: "Wishlinks",
    value: "wishlinks",
    collapsible: false,
    clickable: true,
  },
  {
    id: 1,
    name: "YT Shopping",
    value: "youtube",
    collapsible: false,
    clickable: true,
  },
];
export const NYKAA_WISHLINK_URL = "https://www.wishlink.com/share/b8dg8";

export const MYNTRA_BRAND_ID = 227;

export const HNM_BRAND_ID = 90;

export const FAQ_ICON_URL = "help-support.svg";

export const ANDRIOD_URL =
  "https://play.google.com/store/apps/details?id=com.wishlink.creator";

export const IOS_URL =
  "https://apps.apple.com/in/app/wishlink-creator/id6458532575";

export const PROGRESSION = {
  ADJUSTMENT: "adjustment",
  RETURN: "return",
  FLAGGED_CONTENT: "flagged_content",
  APP_NOT_TAGGED: "app_not_tagged",
};
export const BRAND_IDS_TO_SHOW_CATEGORY_COMMISSION_SPLIT_FOR = [227, 90];

export const CREATOR_EXPERIMENT_TYPE = {
  CONTROL: "control",
  TEST: "test",
};

export const REWARDS_CAMPAIGN = {
  AJIO: "ajio_reward",
  MYNTRA: "myntra_reward",
};

// export const FORCE_UPDATE_BUILD_NUMBER = 24; deprecated, use BE for force updates
export const COLLAB_UPDATE_NUDGE_MIN_BUILD = 44;

export const firebaseAuthPhoneNumbers = [
  "9812569663",
  "9971751599",
  "9569394880",
  "6377092692",
  "9650258617",
];

export const WHY_ENGAGE_STK = [
  {
    id: 1,
    icon: "Engage_save_time_01.png",
    title: "Save Time",
    subTitle: "Automate replies – no manual work",
  },
  {
    id: 2,
    icon: "Engage_boost_01.png",
    title: "Boost your reach",
    subTitle: "Drive engagement & improve post reach",
  },
  {
    id: 3,
    icon: "Engage_quick_01.png",
    title: "Quick tip or product tag",
    subTitle: "Send what your followers love instantly",
  },
  {
    id: 4,
    icon: "Engage_boost_earnings_01.png",
    title: "Boost your earnings",
    subTitle: "Grow income with new link channels",
  },
];

// milliseconds
export const FRESHDESK_TIMEOUT = 120000;

export const FRESHDESK_RETRY_INTERVAL = 300;

export const FRESHDESK_RETRIES = FRESHDESK_TIMEOUT / FRESHDESK_RETRY_INTERVAL;

export const ENGAGE_CAROUSEL = [
  {
    image: "engage-carousel-1.png",
    text: "Make sure to post your content on Wishlink for Engage to work",
  },
  {
    image: "engage-carousel-2.png",
    text: "Put stories to educate your followers on how they can get links",
  },
  {
    image: "engage-carousel-3.png",
    text: "Add clear captions so that users are aware on how they can get links",
  },
  {
    image: "engage-carousel-4.png",
    text: "Put stories to educate your followers on how they can get links",
  },
];
export const FLIPKART_BANNER_REDIRECT_URL =
  "https://www.wishlink.com/share/crsn8?wishlink_external=true";

export const FLIPKART_BRAND_DETAIL_BOTTOM_BANNER_IMAGE_URL =
  "https://cdn-alabaster.wishlink.com/creator-master/Flipkart_x_Meta_Banner_2X_4x_3512x1440+(1).png";

export const FLIPKART_BRAND_DETAIL_BOTTOM_BANNER_REDIRECT_URL =
  "https://docs.google.com/presentation/d/1VApzNWhd2TS9Uw5zEw7LYj-OIssyGH0OSCppJHBC49A/edit?slide=id.p1#slide=id.p1";

export const MEESHO_BANNER_REDIRECT_URL =
  "https://metabase.wishlink.com/public/dashboard/865ef918-c53f-4cfc-bb1a-b346a7730287?wishlink_username=";

export const AMAZON_AIP_COMMISSION_DOC = `https://www.wishlink.com/share/ygc24`;
export const AMAZON_FIP_COMMISSION_DOC = `https://www.wishlink.com/share/y5wg8`;

export const MEESHO_REWARDS_REDIRECT_URL =
  "https://creator.wishlink.com/wishlink-rewards/74";

export const MEESHO_NEW_COMMISSION_EDUCATION_URL =
  "https://newcommissionpayout.lovable.app/";
export const MEESHO_NEW_COMMISSION_MUST_READ_LINK =
  "https://cdn-alabaster.wishlink.com/creator-master/meesho_new_commission_education.pdf";

export const CREATOR_ACCOUNT_TYPE = {
  SOCIAL: "SOCIAL",
  AFFILIATE: "AFFILIATE",
};
export const BRAND_COLLAB_WHATSAPP_URL = "https://wa.me/919319007908";

export const PRODUCT_GROWTH_TAB_OPTIONS = [
  { value: 0, label: "Recommendation", id: "growth-recommendation-tab-cta" },
  { value: 1, label: "Growth Earnings", id: "growth-earnings-tab-cta" },
];

export const SHOP_TABS = {
  DRAFT: "draft",
  POST: "post",
  COLLECTION: "collection",
  PRODUCT: "product",
};

export const CONTENT_TYPE_OPTIONS = {
  instagram: [
    { label: "All", value: "insta_all" },
    { label: "Reels", value: "insta_reel" },
    { label: "Images", value: "insta_image" },
    { label: "Stories", value: "insta_story" },
  ],
  facebook: [
    { label: "All", value: "fb_all" },
    { label: "Videos", value: "fb_video" },
    { label: "Reels", value: "fb_reel" },
    { label: "Images", value: "fb_image" },
  ],
  youtube: [
    { label: "All", value: "yt_all" },
    { label: "Shorts", value: "yt_shorts" },
    { label: "Videos", value: "yt_video" },
  ],
};

export const SOCIAL_MEDIA_PLATFORMS_TYPES = {
  INSTAGRAM: {
    name: "INSTAGRAM",
    icon: "Property 1=IG.png", // Add the path to the Instagram icon
  },
  FACEBOOK: {
    name: "FACEBOOK",
    icon: "facebook-logo.svg",
  },
  YOUTUBE: {
    name: "YOUTUBE",
    icon: "Property 1=YT.png", // Add the path to the YouTube icon
  },
};

export const AFFILIATE_PLATFORMS_TYPES = {
  TELEGRAM: {
    name: "TELEGRAM",
    icon: "telegram-green.svg",
  },
};
export const MINIMUM_FOLLOWER_COUNT_FOR_ADS = 2000;

export const ZERO_COMMISSION = "0%";

// Feature flag variants for OTP Auth
export const OTP_AUTH_VARIANTS = {
  OTPLESS: "OTPLESS_AUTH",
  KALEYRA: "CUSTOM_OTP_AUTH", // Keep original name for compatibility with backend
  FIREBASE: "FIREBASE_AUTH",
};

export const COLLAB_CHAT_ACTIONS = [
  "ACKNOWLEDGE_COLLAB",
  "OPT_IN_COLLAB",
  "CONTENT_SUBMISSION_COLLAB",
  "DRAFT_SUBMISSION_COLLAB",
  "SCRIPT_SUBMISSION_COLLAB",
  "SCRIPT_FEEDBACK_SHARED_COLLAB",
  "DRAFT_FEEDBACK_SHARED_COLLAB",
  "CONTENT_FEEDBACK_SHARED_COLLAB",
  "ADS_RIGHTS_REQUEST_COLLAB",
  "SUBMIT_ADS_CODE_COLLAB",
  "COMPLETE_PRODUCT_ORDERING",
];

export const MEESHO_BAD_REEL_FORM =
  "https://docs.google.com/forms/d/e/1FAIpQLSekFWrI449uv8T8wXQrnk8wb36m54X_AUqyoprO6uo358roqQ/viewform";

export const AMAZON_PRODUCTS_FOR_REWARDS = [
  {
    id: 235031,
    name: "Herbal Essences Argan Oil Hair Mask 237ml",
    brand: "Amazon",
    price: "431.00",
    mrp: "599.00",
    thumbnail_url: "https://m.media-amazon.com/images/I/714-aw7YTuL.jpg",
  },
  {
    id: 235032,
    name: "Herbal Essences Rosemary Herbs Shampoo 240ml",
    brand: "Amazon",
    price: "306.00",
    mrp: "340.00",
    thumbnail_url: "https://m.media-amazon.com/images/I/613n-dOuZsL.jpg",
  },
  {
    id: 235033,
    name: "Herbal Essences Argan Oil Conditioner + Shampoo 400ml",
    brand: "Amazon",
    price: "907.00",
    mrp: "1358.00",
    thumbnail_url: "https://m.media-amazon.com/images/I/81LM0UidnqL.jpg",
  },
  {
    id: 235034,
    name: "Herbal Essences Argan Oil Shampoo + Hair Mask Combo",
    brand: "Amazon",
    price: "820.00",
    mrp: "1258.00",
    thumbnail_url: "https://m.media-amazon.com/images/I/71nkSjJ14ZL.jpg",
  },
  {
    id: 235035,
    name: "Herbal Essences Coconut Milk Shampoo + Conditioner 400ml",
    brand: "Amazon",
    price: "898.00",
    mrp: "1358.00",
    thumbnail_url: "https://m.media-amazon.com/images/I/71VqXiEO3pL.jpg",
  },
];

export const BRAND_REWARD_DETAILS_REDIRECT = {
  224: 5442, // Newme
  218: 5409, // SwissBeauty
  240: null, // Offduty (to be decided)
};

export const WISHLINK_CONSTANT_KEYS = {
  BRAND_IDS_HIDE_PRODUCT_PRICE: "BRAND_IDS_HIDE_PRODUCT_PRICE",
  CUMULATIVE_POST_CLICKS_FTUX_REWARD_IDS:
    "CUMULATIVE_POST_CLICKS_FTUX_REWARD_IDS",
};
//using this to hide product price for brands

export const REWARD_ID_TO_SHOW_SELECT_BY_WISHLINK_REWARDS_FTUX_IDS = [
  "6399",
  "6960",
];
export const REWARD_ID_TO_SHOW_SELECT_BY_WISHLINK_WRAP_FTUX = "5178";

export const EFE_UTM_SOURCE = "_efe_";
